[
  "OpenapiAbstractCardApiResourceRedaction",
  "OpenapiAccountAffirmPaymentsSettings",
  "OpenapiAccountAgenticCommerceSettings",
  "OpenapiAccountAnnualRevenue",
  "OpenapiAccountApplicationDetails",
  "OpenapiAccountAtlasParentCompany",
  "OpenapiAccountAtlasSettings",
  "OpenapiAccountBacsDebitPaymentsSettings",
  "OpenapiAccountBrandingSettings",
  "OpenapiAccountBusinessProfile",
  "OpenapiAccountCapabilities",
  "OpenapiAccountCapabilitiesDetails",
  "OpenapiAccountCapabilityFutureRequirements",
  "OpenapiAccountCapabilityProtections",
  "OpenapiAccountCapabilityRequirements",
  "OpenapiAccountCardIssuingChargeCardSettings",
  "OpenapiAccountCardIssuingPayoutSettings",
  "OpenapiAccountCardIssuingSettings",
  "OpenapiAccountCardPaymentsSettings",
  "OpenapiAccountConsumerFinancialAccountSettings",
  "OpenapiAccountCryptoPaymentsSettings",
  "OpenapiAccountCryptoTransfersSettings",
  "OpenapiAccountCustomPaymentMethodTypesAdapterOnboardingSettings",
  "OpenapiAccountDashboardSettings",
  "OpenapiAccountDeclineChargeOn",
  "OpenapiAccountErrorSuggestion",
  "OpenapiAccountExtensionAccessPolicy",
  "OpenapiAccountExternalAccounts",
  "OpenapiAccountFundAndSendSettings",
  "OpenapiAccountFundingCreditSettings",
  "OpenapiAccountFutureRequirements",
  "OpenapiAccountGroupMembership",
  "OpenapiAccountInvoicesSettings",
  "OpenapiAccountKonbiniPaymentsSettings",
  "OpenapiAccountKonbiniPaymentsSettingsApiResourceSupportHours",
  "OpenapiAccountLink",
  "OpenapiAccountMassPayoutsSettings",
  "OpenapiAccountMissingHoldingCompany",
  "OpenapiAccountMissingPerson",
  "OpenapiAccountMonthlyEstimatedRevenue",
  "OpenapiAccountPaymentsSettings",
  "OpenapiAccountPayoutControlPolicy",
  "OpenapiAccountPayoutSettings",
  "OpenapiAccountPaypayPaymentsSettings",
  "OpenapiAccountPaypaySiteAccessibleSettings",
  "OpenapiAccountPaypaySiteInDevelopmentSettings",
  "OpenapiAccountPaypaySiteRestrictedSettings",
  "OpenapiAccountPaypaySiteSettings",
  "OpenapiAccountRequirements",
  "OpenapiAccountRequirementsAlternative",
  "OpenapiAccountRequirementsDetailedRequirementInformation",
  "OpenapiAccountRequirementsDetailedRequirementInformationBusinessOfficials",
  "OpenapiAccountRequirementsError",
  "OpenapiAccountRequirementsErrorDetails",
  "OpenapiAccountSepaDebitPaymentsSettings",
  "OpenapiAccountServiceResourceFinancialAccountFeatures",
  "OpenapiAccountServiceResourceFinancialAddress",
  "OpenapiAccountServiceResourceIbanRecord",
  "OpenapiAccountServiceResourceIdBbanRecord",
  "OpenapiAccountServiceResourceSortCodeRecord",
  "OpenapiAccountServiceResourceSpeiRecord",
  "OpenapiAccountServiceResourceSwiftRecord",
  "OpenapiAccountServiceResourceZenginRecord",
  "OpenapiAccountSettings",
  "OpenapiAccountSmartDisputesAutoRespond",
  "OpenapiAccountSmartDisputesSettings",
  "OpenapiAccountSuccess",
  "OpenapiAccountTermsOfService",
  "OpenapiAccountTosAcceptance",
  "OpenapiAccountTreasurySettings",
  "OpenapiAccountUnificationAccountController",
  "OpenapiAccountUnificationAccountControllerApplication",
  "OpenapiAccountUnificationAccountControllerDashboard",
  "OpenapiAccountUnificationAccountControllerFees",
  "OpenapiAccountUnificationAccountControllerLosses",
  "OpenapiAccountUnificationAccountControllerStripeDashboard",
  "OpenapiAccountUnificationConfig",
  "OpenapiAccountUnificationConfigApiResourceInvalid",
  "OpenapiAccountUnificationValidUaConfigs",
  "OpenapiAccountWithKeysExternalAccounts",
  "OpenapiAccountsV2ResourcesAllGates",
  "OpenapiAccountsV2ResourcesDisconnectV2Account",
  "OpenapiAccountsV2ResourcesEnableAutoprojections",
  "OpenapiAccountsV2ResourcesGetPlatformPublicPreviewEnrollment",
  "OpenapiAccountsV2ResourcesGetV2AccountsFasttrackState",
  "OpenapiAccountsV2ResourcesRequestV2AccountsFasttrack",
  "OpenapiActionableErrors",
  "OpenapiAdaptivePricingSubaccountInheritance",
  "OpenapiAdaptivePricingTemplateInheritance",
  "OpenapiAdditionalVerificationsResourceAdditionalVerificationWithTimeLimits",
  "OpenapiAdditionalVerificationsResourceAdditionalVerifications",
  "OpenapiAdditionalVerificationsResourceAddressAdditionalVerification",
  "OpenapiAdditionalVerificationsResourceDocumentAdditionalVerification",
  "OpenapiAdditionalVerificationsResourceGetEligibleAdditionalVerifications",
  "OpenapiAdditionalVerificationsResourcePersonIdentityAdditionalVerification",
  "OpenapiAdditionalVerificationsResourceTaxIdAdditionalVerification",
  "OpenapiAdditionalVerificationsResourceTaxReportingAdditionalVerification",
  "OpenapiAdditionalVerificationsResourceUsW8OrW9AdditionalVerification",
  "OpenapiAdditionalVerificationsResourceUsW8OrW9W8Configuration",
  "OpenapiAddon",
  "OpenapiAddonClient",
  "OpenapiAddress",
  "OpenapiAddressReferenceAddressReferenceList",
  "OpenapiAgentDetails",
  "OpenapiAgenticCommerceWebhookResponse",
  "OpenapiAllowedSettlementBankAccountCountries",
  "OpenapiAllowedSettlementCurrencies",
  "OpenapiAlmaInstallments",
  "OpenapiAlternateStatementDescriptors",
  "OpenapiAmazonPayUnderlyingPaymentMethodFundingDetails",
  "OpenapiApiEnums",
  "OpenapiApiKeysList",
  "OpenapiApiRequestStatsList",
  "OpenapiApiRequestsList",
  "OpenapiApmsProviderPaymentProviderTransferDestinationAccount",
  "OpenapiAppMarketplaceResourceDashboardRecommendedApp",
  "OpenapiAppMarketplaceResourceDashboardRecommendedApps",
  "OpenapiAppServiceResourceAction",
  "OpenapiAppServiceResourceActiveBackendSecret",
  "OpenapiAppServiceResourceAppBackend",
  "OpenapiAppServiceResourceAppBuildVersionExtensionPrototype",
  "OpenapiAppServiceResourceAppEligibilityForDistribution",
  "OpenapiAppServiceResourceAppInquiryPlatformConfiguration",
  "OpenapiAppServiceResourceAutomations",
  "OpenapiAppServiceResourceAutomationsActionConfigView",
  "OpenapiAppServiceResourceAutomationsActionSource",
  "OpenapiAppServiceResourceAutomationsActionSourceAppWithSource",
  "OpenapiAppServiceResourceAutomationsActionSourceExternal",
  "OpenapiAppServiceResourceBackendSecret",
  "OpenapiAppServiceResourceBackendSignature",
  "OpenapiAppServiceResourceBuildResult",
  "OpenapiAppServiceResourceChangelogEntrySection",
  "OpenapiAppServiceResourceCodeError",
  "OpenapiAppServiceResourceContentSecurityPolicy",
  "OpenapiAppServiceResourceEventDestination",
  "OpenapiAppServiceResourceExtensionEndpointAuth",
  "OpenapiAppServiceResourceExtensionEndpointDefinition",
  "OpenapiAppServiceResourceExtensionEndpointHeaderAuth",
  "OpenapiAppServiceResourceInstallControl",
  "OpenapiAppServiceResourcePermission",
  "OpenapiAppServiceResourceScript",
  "OpenapiAppServiceResourceScriptFunctionImplementation",
  "OpenapiAppServiceResourceScriptStatusTransitions",
  "OpenapiAppServiceResourceSourceLocation",
  "OpenapiAppServiceResourceUiExtension",
  "OpenapiAppServiceResourceView",
  "OpenapiAppServiceResourceWebhook",
  "OpenapiApprovalsResourceApprovalRequestList",
  "OpenapiApprovalsResourceApprovalRequestRequestingIdentity",
  "OpenapiApprovalsResourceApprovalRuleCondition",
  "OpenapiApprovalsResourceApprovalRuleList",
  "OpenapiApprovalsResourceApprovers",
  "OpenapiAtlasAccountTermsOfService",
  "OpenapiAtlasFundraisingResourcesAllFundraisingBoardConsent",
  "OpenapiAtlasFundraisingResourcesAllSafes",
  "OpenapiAtlasFundraisingResourcesFundraisingCapacity",
  "OpenapiAtlasOnboardingResourcesGenerateAlternateNames",
  "OpenapiAtlasOnboardingResourcesPostDeleteApplication",
  "OpenapiAtlasPerksResourcesAtlasPartnerPerks",
  "OpenapiAttributeValue",
  "OpenapiAuthenticationAuthChallengeResourceFlattenedSchema",
  "OpenapiAuthenticationAuthChallengeResourceInitiateUserChallenge",
  "OpenapiAuthenticationAuthChallengeResourceSchemaAssociation",
  "OpenapiAuthenticationAuthChallengeResourceSchemaRestrictedChallenge",
  "OpenapiAuthenticationTwoFactorReverseSmsInstruction",
  "OpenapiAuthenticationTwoFactorUserPhoneData",
  "OpenapiAutomaticTax",
  "OpenapiAutomationsResourceAction",
  "OpenapiAutomationsResourceActionResourceAppsActionConfig",
  "OpenapiAutomationsResourceActionResourceBranch",
  "OpenapiAutomationsResourceActionResourceBranchingConfig",
  "OpenapiAutomationsResourceActionResourceCancelSubscriptionAsDelinquentConfig",
  "OpenapiAutomationsResourceActionResourceConditionalTerminationConfig",
  "OpenapiAutomationsResourceActionResourceCreateSubscriptionConfig",
  "OpenapiAutomationsResourceActionResourceCreateSubscriptionItemConfig",
  "OpenapiAutomationsResourceActionResourceCreditCustomerBalanceConfig",
  "OpenapiAutomationsResourceActionResourceCustomActionConfig",
  "OpenapiAutomationsResourceActionResourceDelayConfig",
  "OpenapiAutomationsResourceActionResourceForEachConfig",
  "OpenapiAutomationsResourceActionResourceMarkInvoiceUncollectibleConfig",
  "OpenapiAutomationsResourceActionResourceMarkSubscriptionUnpaidConfig",
  "OpenapiAutomationsResourceActionResourcePlatformActionConfig",
  "OpenapiAutomationsResourceActionResourceSendMerchantNotificationEmailConfig",
  "OpenapiAutomationsResourceActionResourceSendSubscriptionCancelationConfirmationEmailConfig",
  "OpenapiAutomationsResourceActionResourceSendWebhookConfig",
  "OpenapiAutomationsResourceActionResourceSendWebhookInvoiceOverdueConfig",
  "OpenapiAutomationsResourceActionResourceSendWebhookInvoiceWillBeDueConfig",
  "OpenapiAutomationsResourceActionResourceSendWebhookQuoteWillExpireConfig",
  "OpenapiAutomationsResourceActionResourceSendWebhookSubscriptionCustomEvent",
  "OpenapiAutomationsResourceActionResourceSendWebhookSubscriptionWillCancelConfig",
  "OpenapiAutomationsResourceActionResourceSendWebhookUpcomingInvoiceConfig",
  "OpenapiAutomationsResourceActionResourceSetOneOffInvoiceRetryPolicyConfig",
  "OpenapiAutomationsResourceActionResourceSetSubscriptionRetryPolicyConfig",
  "OpenapiAutomationsResourceActionResourceVoidInvoice",
  "OpenapiAutomationsResourceActivationSummary",
  "OpenapiAutomationsResourceAutomationDefinition",
  "OpenapiAutomationsResourceAutomationRunGet",
  "OpenapiAutomationsResourceAutomationSwitchCase",
  "OpenapiAutomationsResourceAutomationVersionGet",
  "OpenapiAutomationsResourceExpression",
  "OpenapiAutomationsResourceExpressionResourceActionResultExpression",
  "OpenapiAutomationsResourceExpressionResourceBinaryExpression",
  "OpenapiAutomationsResourceExpressionResourceCollectionFilterExpression",
  "OpenapiAutomationsResourceExpressionResourceIterationItemExpression",
  "OpenapiAutomationsResourceExpressionResourceMapAccessExpression",
  "OpenapiAutomationsResourceExpressionResourceMapEntry",
  "OpenapiAutomationsResourceExpressionResourceMapExpression",
  "OpenapiAutomationsResourceExpressionResourceObjectExpression",
  "OpenapiAutomationsResourceExpressionResourceObjectProperty",
  "OpenapiAutomationsResourceExpressionResourcePaginatedListExpression",
  "OpenapiAutomationsResourceExpressionResourcePaginationContinuation",
  "OpenapiAutomationsResourceExpressionResourcePaginationContinuationResourceV1Api",
  "OpenapiAutomationsResourceExpressionResourcePropertyAccessExpression",
  "OpenapiAutomationsResourceExpressionResourceTemplateExpression",
  "OpenapiAutomationsResourceExpressionResourceUnaryExpression",
  "OpenapiAutomationsResourcePayloadSchema",
  "OpenapiAutomationsResourcePlatformActionConfigParameter",
  "OpenapiAutomationsResourceResourceChanges",
  "OpenapiAutomationsResourceTeamMember",
  "OpenapiAutomationsResourceTrigger",
  "OpenapiAutomationsResourceTriggerPayload",
  "OpenapiAutomationsResourceUserDefinedSchema",
  "OpenapiAutomationsResourceUserDetails",
  "OpenapiBackwardsCompatiblePlatformEarningRefunds",
  "OpenapiBacsDebitGeneratedFrom",
  "OpenapiBalance",
  "OpenapiBalanceAmount",
  "OpenapiBalanceAmountBySource",
  "OpenapiBalanceAmountNet",
  "OpenapiBalanceDetail",
  "OpenapiBalanceDetailUngated",
  "OpenapiBalanceNetAvailable",
  "OpenapiBalanceSettingsResourceDebitSettlementTiming",
  "OpenapiBalanceSettingsResourcePaymentMethodSettlementTimingOptions",
  "OpenapiBalanceSettingsResourcePayments",
  "OpenapiBalanceSettingsResourcePayoutSchedule",
  "OpenapiBalanceSettingsResourcePayouts",
  "OpenapiBalanceSettingsResourceSettlementTiming",
  "OpenapiBalanceSettingsResourceStartOfDay",
  "OpenapiBalanceSummary",
  "OpenapiBalanceTransactionSourcedTransfers",
  "OpenapiBalanceTransferResourceBalanceTransferBalances",
  "OpenapiBalancesResourceBalancesItemManage",
  "OpenapiBalancesResourceBalancesItemTransactionManage",
  "OpenapiBankAccountVerificationHints",
  "OpenapiBankAccountWireInfoManage",
  "OpenapiBankConnectionsResourceAccountholder",
  "OpenapiBankConnectionsResourceBalanceApiResourceCashBalance",
  "OpenapiBankConnectionsResourceBalanceApiResourceCreditBalance",
  "OpenapiBankConnectionsResourceEmpty",
  "OpenapiBankConnectionsResourceEventsToEmit",
  "OpenapiBankConnectionsResourceEventsToEmitError",
  "OpenapiBankConnectionsResourceEventsToEmitInstitutionSelected",
  "OpenapiBankConnectionsResourceEventsToEmitSearchInitiated",
  "OpenapiBankConnectionsResourceEventsToEmitSuccess",
  "OpenapiBankConnectionsResourceInferredBalancesRefresh",
  "OpenapiBankConnectionsResourceInstitutionFeatureSupport",
  "OpenapiBankConnectionsResourceInstitutionSupportedFeature",
  "OpenapiBankConnectionsResourceInternalRecipientOnboardingConfiguration",
  "OpenapiBankConnectionsResourceLinkAccountSessionAccounts",
  "OpenapiBankConnectionsResourceLinkAccountSessionFilters",
  "OpenapiBankConnectionsResourceLinkAccountSessionHosted",
  "OpenapiBankConnectionsResourceLinkAccountSessionLimits",
  "OpenapiBankConnectionsResourceLinkAccountSessionLinkedAccounts",
  "OpenapiBankConnectionsResourceLinkAccountSessionManualEntry",
  "OpenapiBankConnectionsResourceLinkAccountSessionRelinkOptions",
  "OpenapiBankConnectionsResourceLinkAccountSessionRelinkResult",
  "OpenapiBankConnectionsResourceLinkAccountSessionStatusDetails",
  "OpenapiBankConnectionsResourceLinkAccountSessionStatusDetailsResourceCancelledStatusDetails",
  "OpenapiBankConnectionsResourceOwnershipOwners",
  "OpenapiBankConnectionsResourceOwnershipRefresh",
  "OpenapiBankConnectionsResourceRefreshError",
  "OpenapiBankingResourceFinanceTransactionResourceFinanceTransactionCardholder",
  "OpenapiBankingResourceFinanceTransactionResourceFinanceTransactionCoordinates",
  "OpenapiBankingResourceFinanceTransactionResourceFinanceTransactionCustomDetails",
  "OpenapiBankingResourceFinanceTransactionResourceFinanceTransactionReward",
  "OpenapiBankingResourceFinanceTransactionResourceReceipt",
  "OpenapiBankingResourceInstructionsPdf",
  "OpenapiBankingResourceStatement",
  "OpenapiBankingResourceTransactionVolume",
  "OpenapiBankingRiskOverrideDetails",
  "OpenapiBankingRiskOverrideableRestrictedFinancialAccountFeatures",
  "OpenapiBaplingRoutingAccountsEnableCustomerAutoprojections",
  "OpenapiBaplingRoutingAccountsGetV1CustomerProjectionStatus",
  "OpenapiBaplingRoutingAccountsProjectV1Customer",
  "OpenapiBillieMultiCapture",
  "OpenapiBillingBillResourceInvoiceItemParentsInvoiceItemContractDetailsParent",
  "OpenapiBillingBillResourceInvoiceItemParentsInvoiceItemParent",
  "OpenapiBillingBillResourceInvoiceItemParentsInvoiceItemPricingPlanSubscriptionParent",
  "OpenapiBillingBillResourceInvoiceItemParentsInvoiceItemRateCardSubscriptionParent",
  "OpenapiBillingBillResourceInvoiceItemParentsInvoiceItemScheduleParent",
  "OpenapiBillingBillResourceInvoiceItemParentsInvoiceItemSubscriptionParent",
  "OpenapiBillingBillResourceInvoicingCommonInvoicePauseCollection",
  "OpenapiBillingBillResourceInvoicingLinesCommonCreditedItems",
  "OpenapiBillingBillResourceInvoicingLinesCommonProrationDetails",
  "OpenapiBillingBillResourceInvoicingLinesParentsInvoiceLineItemContractLineDetailsParent",
  "OpenapiBillingBillResourceInvoicingLinesParentsInvoiceLineItemInvoiceItemParent",
  "OpenapiBillingBillResourceInvoicingLinesParentsInvoiceLineItemParent",
  "OpenapiBillingBillResourceInvoicingLinesParentsInvoiceLineItemPricingPlanSubscriptionParent",
  "OpenapiBillingBillResourceInvoicingLinesParentsInvoiceLineItemRateCardSubscriptionParent",
  "OpenapiBillingBillResourceInvoicingLinesParentsInvoiceLineItemScheduleParent",
  "OpenapiBillingBillResourceInvoicingLinesParentsInvoiceLineItemSubscriptionItemParent",
  "OpenapiBillingBillResourceInvoicingParentsInvoiceBillingCadenceParent",
  "OpenapiBillingBillResourceInvoicingParentsInvoiceParent",
  "OpenapiBillingBillResourceInvoicingParentsInvoiceQuoteParent",
  "OpenapiBillingBillResourceInvoicingParentsInvoiceScheduleParent",
  "OpenapiBillingBillResourceInvoicingParentsInvoiceSubscriptionParent",
  "OpenapiBillingBillResourceInvoicingPricingPricing",
  "OpenapiBillingBillResourceInvoicingPricingPricingCustomLicensedFeeDetails",
  "OpenapiBillingBillResourceInvoicingPricingPricingCustomRateDetails",
  "OpenapiBillingBillResourceInvoicingPricingPricingLicenseFeeDetails",
  "OpenapiBillingBillResourceInvoicingPricingPricingPriceDetails",
  "OpenapiBillingBillResourceInvoicingPricingPricingRateCardCustomPricingUnitOverageRateDetails",
  "OpenapiBillingBillResourceInvoicingPricingPricingRateCardRateDetails",
  "OpenapiBillingBillResourceInvoicingTaxesTax",
  "OpenapiBillingBillResourceInvoicingTaxesTaxRateDetails",
  "OpenapiBillingClocksResourceStatusDetailsAdvancingStatusDetails",
  "OpenapiBillingClocksResourceStatusDetailsStatusDetails",
  "OpenapiBillingCreditGrantsResourceAmount",
  "OpenapiBillingCreditGrantsResourceApplicabilityConfig",
  "OpenapiBillingCreditGrantsResourceBalanceBalanceUpdateDetails",
  "OpenapiBillingCreditGrantsResourceBalanceCredit",
  "OpenapiBillingCreditGrantsResourceBalanceCreditsApplicationInvoiceVoided",
  "OpenapiBillingCreditGrantsResourceBalanceCreditsApplied",
  "OpenapiBillingCreditGrantsResourceBalanceDebit",
  "OpenapiBillingCreditGrantsResourceBalanceLatestMeterEvent",
  "OpenapiBillingCreditGrantsResourceFunding",
  "OpenapiBillingCreditGrantsResourceMonetaryAmount",
  "OpenapiBillingCreditGrantsResourceOtherFundingSource",
  "OpenapiBillingCreditGrantsResourceScope",
  "OpenapiBillingDetails",
  "OpenapiBillingMeterResourceAggregationSettings",
  "OpenapiBillingMeterResourceBillingMeterStatusTransitions",
  "OpenapiBillingMeterResourceBillingMeterValue",
  "OpenapiBillingMeterResourceCustomerMappingSettings",
  "OpenapiBillingMeterResourceMerchantSettings",
  "OpenapiBillingMeterRetrieveRatedUsageMetadata",
  "OpenapiBillingOrchestrationExtensionsPolicyTypesResourcePolicy",
  "OpenapiBillingOrchestrationExtensionsPolicyTypesResourceRule",
  "OpenapiBillingOverviewUbbMerchantSettings",
  "OpenapiBillingResourceUsageMetadata",
  "OpenapiBillingScheduleConfigsAppliesToClient",
  "OpenapiBillingScheduleConfigsBillFromClient",
  "OpenapiBillingScheduleConfigsBillUntilClient",
  "OpenapiBillingSettingsBillingModeSettings",
  "OpenapiBillingSettingsBillingNotificationLegacySettings",
  "OpenapiBillingSettingsSubscriptionProrationSettings",
  "OpenapiBitcoinReceiverTransactions",
  "OpenapiBrowserSession",
  "OpenapiBusinessNetworkFacilitatedCommercePermissionGrant",
  "OpenapiBusinessNetworkFacilitatedCommercePermissionedKey",
  "OpenapiBusinessNetworkFlagProfile",
  "OpenapiBusinessNetworkProfileAlerts",
  "OpenapiBusinessNetworkResourceAgenticCommerceChannel",
  "OpenapiBusinessNetworkResourceAgenticCommerceMarketingConsentOption",
  "OpenapiBusinessNetworkResourceAgenticCommerceSeller",
  "OpenapiBusinessNetworkResourceAgenticCommerceSellerAcsAdapterConfig",
  "OpenapiBusinessNetworkResourceAgenticCommerceSellerCheckoutAdapterConfig",
  "OpenapiBusinessNetworkResourceAgenticCommerceSyndicatorReservedSettings",
  "OpenapiBusinessNetworkResourceProfileBranding",
  "OpenapiBusinessNetworkResourceProfileBrandingImageSizes",
  "OpenapiBusinessNetworkResourceProfileProposal",
  "OpenapiBusinessNetworkResourceProfileVerification",
  "OpenapiBusinessNetworkResourceStripeProfileOnboardingTask",
  "OpenapiBusinessNetworkResourceUsernameStatus",
  "OpenapiCanMerchantOptOutOfSharingSupportHistoryWithPlatform",
  "OpenapiCancellationDetails",
  "OpenapiCapitalAccountSettingsResourceAllowedPayoutDestination",
  "OpenapiCapitalAttestationDetailsGroupStubAttestationDetails",
  "OpenapiCapitalAttestationDetailsGroupYouLendPersonalGuaranteeDetails",
  "OpenapiCapitalBankAccounts",
  "OpenapiCapitalCapitalFpiCreatePartnerApplicationWorkflow",
  "OpenapiCapitalCapitalFpiCreatePartnerApplicationWorkflowStatus",
  "OpenapiCapitalConnectConnectFinancingAcceptedTerms",
  "OpenapiCapitalConnectConnectFinancingBalance",
  "OpenapiCapitalConnectConnectFinancingOfferedTerms",
  "OpenapiCapitalConnectConnectFinancingOnDemandOffer",
  "OpenapiCapitalConnectConnectFinancingRepaymentIntervalConfiguration",
  "OpenapiCapitalConnectConnectFinancingStatusTransitions",
  "OpenapiCapitalConnectDurableLink",
  "OpenapiCapitalConnectEmbeddedAccountLinks",
  "OpenapiCapitalConnectFinancingApplication",
  "OpenapiCapitalConnectFinancingApplicationResourceStatusTransitions",
  "OpenapiCapitalConnectFinancingSummary",
  "OpenapiCapitalConnectFinancingSummaryCurrentRepaymentWindow",
  "OpenapiCapitalConnectFinancingSummaryDetails",
  "OpenapiCapitalConnectFinancingSummaryLineOfCredit",
  "OpenapiCapitalConnectFinancingTransactionDetailsTransaction",
  "OpenapiCapitalConnectPartnerProgramsConsistencyMapping",
  "OpenapiCapitalConnectPartnerProgramsListResponse",
  "OpenapiCapitalFlexLoanAgreement",
  "OpenapiCapitalFlexLoanMultiDrawDetails",
  "OpenapiCapitalFlexLoanOriginatingFinancingBalance",
  "OpenapiCapitalOffersCalculations",
  "OpenapiCapitalOffersCapitalActiveOnlineThirdPartyIntegrations",
  "OpenapiCapitalOffersMerchantRevenue",
  "OpenapiCapitalOffersMultiDrawDetails",
  "OpenapiCapitalOffersOfferDocuments",
  "OpenapiCapitalSecondaryRepaymentSource",
  "OpenapiCapitalThirdPartyPotentialOfferSize",
  "OpenapiCapitalYouLendYouLendAcceptanceStatus",
  "OpenapiCapitalYouLendYouLendEligibleSigners",
  "OpenapiCapitalYouLendYouLendRepaymentInfo",
  "OpenapiCapitalYouLendYouLendWorkflow",
  "OpenapiCardGeneratedFromPaymentMethodDetails",
  "OpenapiCardIssuingAccountGranularTermsOfServiceAcceptance",
  "OpenapiCardIssuingAccountTermsOfService",
  "OpenapiCardIssuingAccountTermsOfServiceAcceptances",
  "OpenapiCardIssuingChargeCardCrossRiverBank",
  "OpenapiCardIssuingChargeCardCrossRiverBankAccountTermsOfService",
  "OpenapiCardMandatePaymentMethodDetails",
  "OpenapiCardMandatePaymentMethodDetailsIndia",
  "OpenapiCardPresentCompleteStandardEmvTransactionNextAction",
  "OpenapiCardStatusDetails",
  "OpenapiCardStatusDetailsContactOwner",
  "OpenapiCashBalance",
  "OpenapiChargeApiResourceRedaction",
  "OpenapiChargeFraudDetails",
  "OpenapiChargeOutcome",
  "OpenapiChargeOutcomeApiResourceCustomMerchantModelScores",
  "OpenapiChargeOutcomeApiResourceDisputeProtectionResultForChargeOutcome",
  "OpenapiChargeOutcomeApiResourceRadarScoreDetail",
  "OpenapiChargeOutcomeApiResourceRadarScores",
  "OpenapiChargeOutcomeApiResourceRiskDetails",
  "OpenapiChargeOutcomeApiResourceRiskDetailsFloatScoreInsight",
  "OpenapiChargeOutcomeApiResourceRiskDetailsInsights",
  "OpenapiChargeOutcomeApiResourceRiskDetailsIntegerScoreInsight",
  "OpenapiChargeRefunds",
  "OpenapiChargeTransferData",
  "OpenapiChargeUpdateOutcome",
  "OpenapiChargeUpdateRecord",
  "OpenapiChargeWithChargeRefunds",
  "OpenapiChargeWithPaymentRefunds",
  "OpenapiCheckoutAcssDebitMandateOptions",
  "OpenapiCheckoutAcssDebitPaymentMethodOptions",
  "OpenapiCheckoutAffirmPaymentMethodOptions",
  "OpenapiCheckoutAfterpayClearpayPaymentMethodOptions",
  "OpenapiCheckoutAlmaPaymentMethodOptions",
  "OpenapiCheckoutAmazonPayPaymentMethodOptions",
  "OpenapiCheckoutAuBecsDebitPaymentMethodOptions",
  "OpenapiCheckoutBacsDebitPaymentMethodOptions",
  "OpenapiCheckoutBancontactPaymentMethodOptions",
  "OpenapiCheckoutBilliePaymentMethodOptions",
  "OpenapiCheckoutBizumPaymentMethodOptions",
  "OpenapiCheckoutCardInstallmentsOptions",
  "OpenapiCheckoutCardNetworkOptions",
  "OpenapiCheckoutCardNetworkOptionsAmex",
  "OpenapiCheckoutCardPaymentMethodOptions",
  "OpenapiCheckoutCryptoPaymentMethodOptions",
  "OpenapiCheckoutDemoPayPaymentMethodOptions",
  "OpenapiCheckoutEpsPaymentMethodOptions",
  "OpenapiCheckoutFpxPaymentMethodOptions",
  "OpenapiCheckoutGiropayPaymentMethodOptions",
  "OpenapiCheckoutGrabPayPaymentMethodOptions",
  "OpenapiCheckoutIdBankTransferPaymentMethodOptions",
  "OpenapiCheckoutIdealPaymentMethodOptions",
  "OpenapiCheckoutKakaoPayPaymentMethodOptions",
  "OpenapiCheckoutKlarnaPaymentMethodOptions",
  "OpenapiCheckoutKrCardPaymentMethodOptions",
  "OpenapiCheckoutKrMarketPaymentMethodOptions",
  "OpenapiCheckoutLinkPaymentMethodOptions",
  "OpenapiCheckoutLinkWalletOptions",
  "OpenapiCheckoutMobilepayPaymentMethodOptions",
  "OpenapiCheckoutNaverPayPaymentMethodOptions",
  "OpenapiCheckoutNgBankPaymentMethodOptions",
  "OpenapiCheckoutNgBankTransferPaymentMethodOptions",
  "OpenapiCheckoutNgCardPaymentMethodOptions",
  "OpenapiCheckoutNgMarketPaymentMethodOptions",
  "OpenapiCheckoutNgUssdPaymentMethodOptions",
  "OpenapiCheckoutP24PaymentMethodOptions",
  "OpenapiCheckoutPaycoPaymentMethodOptions",
  "OpenapiCheckoutPaymentMethodOptionsMandateOptionsBacsDebit",
  "OpenapiCheckoutPaymentMethodOptionsMandateOptionsSepaDebit",
  "OpenapiCheckoutPaynowPaymentMethodOptions",
  "OpenapiCheckoutPaypalPaymentMethodOptions",
  "OpenapiCheckoutRevolutPayPaymentMethodOptions",
  "OpenapiCheckoutSamsungPayPaymentMethodOptions",
  "OpenapiCheckoutSatispayPaymentMethodOptions",
  "OpenapiCheckoutScalapayPaymentMethodOptions",
  "OpenapiCheckoutSepaDebitPaymentMethodOptions",
  "OpenapiCheckoutSessionPaymentMethodOptions",
  "OpenapiCheckoutSessionWalletOptions",
  "OpenapiCheckoutSofortPaymentMethodOptions",
  "OpenapiCheckoutStudioCheckoutInspectResourcesFormDetails",
  "OpenapiCheckoutStudioCheckoutInspectResourcesRetrieveInspectDetails",
  "OpenapiCheckoutStudioCheckoutInspectResourcesSimulateOrRetrievePaymentMethodFilteringResult",
  "OpenapiCheckoutStudioCheckoutInspectResourcesSimulateOrRetrievePaymentMethodFilteringResultResourcePaymentMethodWithFiltrationReason",
  "OpenapiCheckoutStudioCheckoutInspectResourcesTransactionDetails",
  "OpenapiCheckoutSwishPaymentMethodOptions",
  "OpenapiCheckoutUsBankAccountPaymentMethodOptions",
  "OpenapiCheckoutWechatPayPaymentMethodOptions",
  "OpenapiClimateRemovalsBeneficiary",
  "OpenapiClimateRemovalsLocation",
  "OpenapiClimateRemovalsOrderSummary",
  "OpenapiClimateRemovalsOrderSummarySummary",
  "OpenapiClimateSignupPricePoint",
  "OpenapiCommunicationManagementResourcesEmailDestinationCreation",
  "OpenapiCommunicationManagementResourcesEmpty",
  "OpenapiCommunicationManagementResourcesListEmailDestination",
  "OpenapiCommunicationManagementResourcesListSubscriptionRecipients",
  "OpenapiComplianceHubResourcesAccountMetrics",
  "OpenapiComplianceHubResourcesCohortAggregations",
  "OpenapiComplianceHubResourcesCohortDatesChange",
  "OpenapiComplianceHubResourcesGroups",
  "OpenapiComplianceHubResourcesNewAccountsData",
  "OpenapiComplianceHubResourcesNewAccountsDatesChange",
  "OpenapiComplianceHubResourcesOrrChanges",
  "OpenapiComplianceHubResourcesOrrMetricsResult",
  "OpenapiComplianceHubResourcesPaymentVolumeMetrics",
  "OpenapiComplianceSingaporeCddResourceSingaporeAccountActivitySurveyApi",
  "OpenapiComplianceSingaporeCddResourceSingaporeAccountActivitySurveyV1Api",
  "OpenapiConnectAccountReference",
  "OpenapiConnectAuthResourcesCreateDirectifySecret",
  "OpenapiConnectAuthResourcesCreateLoginLinks",
  "OpenapiConnectAuthResourcesEligibleForIdentityAuth",
  "OpenapiConnectAuthResourcesEmpty",
  "OpenapiConnectAuthResourcesExternalAccountChallenge",
  "OpenapiConnectAuthResourcesExternalAccountCodeVerify",
  "OpenapiConnectAuthResourcesIdentityChallenge",
  "OpenapiConnectAuthResourcesIdentityChallengeGetKey",
  "OpenapiConnectAuthResourcesInviteNewOwner",
  "OpenapiConnectAuthResourcesLightSessionAuthRequirements",
  "OpenapiConnectAuthResourcesListInvitations",
  "OpenapiConnectAuthResourcesLoginLink",
  "OpenapiConnectAuthResourcesRequiresExternalAccountVerification",
  "OpenapiConnectAuthResourcesResendVerificationEmail",
  "OpenapiConnectAuthResourcesResendVerificationPhone",
  "OpenapiConnectAuthResourcesVerifyPhone",
  "OpenapiConnectCommsCenterPlatformCommunicationsConfigResourceTemplatePlatformCommunicationsConfig",
  "OpenapiConnectCommsCenterPlatformCommunicationsConfigResourceTemplatePlatformCommunicationsOptions",
  "OpenapiConnectCommsCenterResourceConnectedAccountTraits",
  "OpenapiConnectCommsCenterResourceEmailArchiveData",
  "OpenapiConnectCommsCenterResourceGetSentEmail",
  "OpenapiConnectCommsCenterResourceNilableProductCommunicationsSettings",
  "OpenapiConnectCommsCenterResourceProductCommunicationsSettingsEmail",
  "OpenapiConnectCommsCenterResourceProductCommunicationsSettingsEmailList",
  "OpenapiConnectCommsCenterResourceProductCommunicationsSettingsList",
  "OpenapiConnectCommsCenterResourceProductSettings",
  "OpenapiConnectCommsCenterResourceSuccess",
  "OpenapiConnectConnectOnboardingResourceAccountReadyToOnboard",
  "OpenapiConnectConnectOnboardingResourceCompleteOnboarding",
  "OpenapiConnectConnectOnboardingResourceIsLegalEntitySharingAllowed",
  "OpenapiConnectConnectOnboardingResourceJapanAddressSuggest",
  "OpenapiConnectConnectOnboardingResourceSingaporeCddSurveyEnabled",
  "OpenapiConnectConnectOnboardingResourceUsedWithPlatforms",
  "OpenapiConnectConnectOnboardingResourceUsedWithPlatformsResponse",
  "OpenapiConnectEmbeddedAccountConfigClaim",
  "OpenapiConnectEmbeddedAccountFeaturesClaim",
  "OpenapiConnectEmbeddedAccountSessionClaimComponents",
  "OpenapiConnectEmbeddedAccountSessionClaimMerchantData",
  "OpenapiConnectEmbeddedAppConfigClaim",
  "OpenapiConnectEmbeddedAppFeatures",
  "OpenapiConnectEmbeddedBaseConfigClaim",
  "OpenapiConnectEmbeddedBaseFeatures",
  "OpenapiConnectEmbeddedBillsConfig",
  "OpenapiConnectEmbeddedBillsFeatures",
  "OpenapiConnectEmbeddedCheckScanningConfigClaim",
  "OpenapiConnectEmbeddedCheckScanningFeatures",
  "OpenapiConnectEmbeddedDisputesListConfig",
  "OpenapiConnectEmbeddedDisputesListFeatures",
  "OpenapiConnectEmbeddedFinancialAccountConfigClaim",
  "OpenapiConnectEmbeddedFinancialAccountFeatures",
  "OpenapiConnectEmbeddedFinancialAccountTransactionsConfigClaim",
  "OpenapiConnectEmbeddedFinancialAccountTransactionsFeatures",
  "OpenapiConnectEmbeddedFinancialAccountsConfig",
  "OpenapiConnectEmbeddedFinancialAccountsFeatures",
  "OpenapiConnectEmbeddedFinancialAccountsTransactionsConfig",
  "OpenapiConnectEmbeddedFinancialAccountsTransactionsFeatures",
  "OpenapiConnectEmbeddedInstantPayoutsPromotionConfig",
  "OpenapiConnectEmbeddedInstantPayoutsPromotionFeatures",
  "OpenapiConnectEmbeddedIssuingCardConfigClaim",
  "OpenapiConnectEmbeddedIssuingCardFeatures",
  "OpenapiConnectEmbeddedIssuingCardsListConfigClaim",
  "OpenapiConnectEmbeddedIssuingCardsListFeatures",
  "OpenapiConnectEmbeddedMethodEmbeddedSurfaceLastAccessedUpdateMethodEmbeddedSurface",
  "OpenapiConnectEmbeddedMethodEmbeddedSurfaceLastAccessedUpdateMethodLastAccessed",
  "OpenapiConnectEmbeddedPaymentDetailSummary",
  "OpenapiConnectEmbeddedPaymentDisputesConfig",
  "OpenapiConnectEmbeddedPaymentDisputesFeatures",
  "OpenapiConnectEmbeddedPaymentsConfigClaim",
  "OpenapiConnectEmbeddedPaymentsFeatures",
  "OpenapiConnectEmbeddedPayoutsConfigClaim",
  "OpenapiConnectEmbeddedPayoutsFeaturesClaim",
  "OpenapiConnectEmbeddedRecipientsConfigClaim",
  "OpenapiConnectEmbeddedRecipientsFeatures",
  "OpenapiConnectEmbeddedRecipientsListConfig",
  "OpenapiConnectEmbeddedRecipientsListFeatures",
  "OpenapiConnectEmbeddedTransactionsListConfigClaim",
  "OpenapiConnectEmbeddedTransactionsListFeatures",
  "OpenapiConnectEmbeddedTransactionsTypeCount",
  "OpenapiConnectIntegrationPlatformAttestationItem",
  "OpenapiConnectPayoutsNoCodeInstantPayoutsConfigResourcesNoCodeInstantPayoutsSubaccountConfig",
  "OpenapiConnectPayoutsNoCodeInstantPayoutsConfigResourcesNoCodeInstantPayoutsTemplateConfig",
  "OpenapiConnectPayoutsNoCodeInstantPayoutsResourcesInstantPayoutSupportedCountriesPnbl",
  "OpenapiConnectPayoutsNoCodeInstantPayoutsResourcesInstantPayoutSupportedCountriesPnblResourceCountryCurrencyMapping",
  "OpenapiConnectPayoutsNoCodeInstantPayoutsResourcesMeetsInstantPayoutsEligibilityPnbl",
  "OpenapiConnectPayoutsPlatformExternalAccountSettingsIsDebitCardCountrySupported",
  "OpenapiConnectPayoutsResourceInstantPayoutsPricing",
  "OpenapiConnectPayoutsResourceInstantPayoutsPricingPrice",
  "OpenapiConnectPlatformExperiencesConnectInsightsResourceConnectInsightsDashboardConfiguration",
  "OpenapiConnectPlatformExperiencesConnectInsightsResourceConnectInsightsDashboardMerchantConfiguration",
  "OpenapiConnectPlatformExperiencesConnectInsightsResourceConnectInsightsDashboardUserAndMerchantConfigurations",
  "OpenapiConnectPlatformExperiencesConnectInsightsResourceQueryAggregatedCurrentUserTask",
  "OpenapiConnectPlatformExperiencesConnectInsightsResourceQueryAggregatedCurrentUserTasks",
  "OpenapiConnectPlatformExperiencesConnectInsightsResourceUpcomingUserTaskByMonthAggregation",
  "OpenapiConnectPlatformExperiencesConnectInsightsResourceUpcomingUserTaskMonth",
  "OpenapiConnectPlatformExperiencesConnectInsightsResourceUpcomingUserTasksByMonthAggregation",
  "OpenapiConnectPlatformExperiencesConnectedAccountDetailsResourceConnectedAccountDetails",
  "OpenapiConnectPlatformOnboardingResourcePlatformVerificationStatus",
  "OpenapiConnectPricingResourcesGrossSettlementConfigRetrieveMethod",
  "OpenapiConnectPricingResourcesPricingCondition",
  "OpenapiConnectPricingResourcesPricingConditionResourceSettlementCurrency",
  "OpenapiConnectPricingResourcesPricingConfigSchemeResourceFixedMonetaryAmount",
  "OpenapiConnectPricingResourcesPricingConfigSchemeResourcePricingRule",
  "OpenapiConnectProductListViewsRiskResourcesAggregationFilterFields",
  "OpenapiConnectProductListViewsRiskResourcesConnectedAccountsListAggregations",
  "OpenapiConnectProductListViewsRiskResourcesPlatformControls",
  "OpenapiConnectProductListViewsRiskResourcesProgram",
  "OpenapiConnectProductSuggestionResourceSetupStatusList",
  "OpenapiConnectRevenueStudioCampaignEngineRevenueStudioCampaignResourcePromotionalPricingMonetaryAmount",
  "OpenapiConnectRevenueStudioCampaignEngineRevenueStudioCampaignResourcePromotionalPricingPredicate",
  "OpenapiConnectRevenueStudioCampaignEngineRevenueStudioCampaignResourcePromotionalPricingRule",
  "OpenapiConnectRevenueStudioPaymentOptimizerPlatformPaymentMethodRecommendations",
  "OpenapiConnectRevenueStudioPaymentOptimizerPlatformPaymentMethodRecommendationsResourcePlatformPaymentMethodRecommendation",
  "OpenapiConnectRiskAccountRiskControl",
  "OpenapiConnectRiskAccountRiskControls",
  "OpenapiConnectRiskResourceAccountRiskSignals",
  "OpenapiConnectRiskResourceDemoIntervention",
  "OpenapiConnectRiskResourceUserFacingRequirement",
  "OpenapiConnectTemplatingAccountGroupsResourcesAccountGroupList",
  "OpenapiConnectTemplatingBulkCsvUploadsResourcesAccountGroupCsvUpdate",
  "OpenapiConnectTemplatingBulkCsvUploadsResourcesAccountGroupCsvValidate",
  "OpenapiConnectTemplatingBulkCsvUploadsResourcesAccountGroupCsvValidateStatus",
  "OpenapiConnectTemplatingBulkCsvUploadsResourcesAccountGroupCsvValidateStatusResourceCounts",
  "OpenapiConnectTemplatingPricingGroupsResourcesCustomizedPricingGroup",
  "OpenapiConnectTemplatingPricingGroupsResourcesSubaccountPricingGroup",
  "OpenapiConnectTemplatingResourcesAccountGroupMapping",
  "OpenapiConnectTemplatingResourcesPricingConfigAndAccountGroupMapping",
  "OpenapiConnectTemplatingResourcesPricingConfigResourceApplicationFeeConfiguration",
  "OpenapiConnectTemplatingResourcesPricingConfigResourceApplicationFeePredicate",
  "OpenapiConnectTemplatingResourcesPricingConfigResourceApplicationFeesConfiguration",
  "OpenapiConnectTemplatingResourcesPricingConfigResourceFixedMonetaryAmount",
  "OpenapiConnectTemplatingResourcesPricingConfigResourceScheduledPricingScheduledPricing",
  "OpenapiConnectW8W9CollectionResourceFullyKeyedInTaxIdRetrieve",
  "OpenapiConnectW8W9CollectionResourceRomajiAddress",
  "OpenapiConnectW8W9CollectionResourceRomajiInfo",
  "OpenapiConnectW8W9CollectionResourceTaxFormPdf",
  "OpenapiConnectW8W9CollectionResourceW8Create",
  "OpenapiConnectW8W9CollectionResourceW9Create",
  "OpenapiConsumerFinancialAccountTermsOfServiceAcceptanceDetails",
  "OpenapiConsumerFinancialAccountTosAcceptances",
  "OpenapiControlledContentBatchDisplayStatus",
  "OpenapiControlledContentDisplayStatus",
  "OpenapiControlledContentDisplayStatusForSurface",
  "OpenapiControlledContentEvent",
  "OpenapiCountrySpecVerificationFieldDetails",
  "OpenapiCountrySpecVerificationFields",
  "OpenapiCouponAppliesTo",
  "OpenapiCouponServicePeriod",
  "OpenapiCouponServicePeriodIterations",
  "OpenapiCreditBalance",
  "OpenapiCreditBalanceSummary",
  "OpenapiCreditNoteLines",
  "OpenapiCreditNoteTaxAmount",
  "OpenapiCreditNotesPaymentRecordRefund",
  "OpenapiCreditNotesPretaxCreditAmount",
  "OpenapiCreditNotesReasonDetails",
  "OpenapiCreditNotesReasonDetailsCustomReason",
  "OpenapiCreditedItemsInvoiceLineItems",
  "OpenapiCrossSell",
  "OpenapiCrossSells",
  "OpenapiCryptoPaymentsAccountTermsOfServiceAcceptances",
  "OpenapiCryptoTransfersAccountTermsOfServiceAcceptanceDetails",
  "OpenapiCryptoTransfersAccountTermsOfServiceAcceptances",
  "OpenapiCryptocurrencyPayinsNonStrictDepsResourceConsumerPerson",
  "OpenapiCryptocurrencyPayinsResourceCryptoPayinsFlags",
  "OpenapiCryptocurrencyPayinsResourceDirectDepositAddress",
  "OpenapiCryptocurrencyPayinsResourceExternalPaymentDetails",
  "OpenapiCryptocurrencyPayinsResourceMerchantBranding",
  "OpenapiCryptocurrencyPayinsResourceMiradorData",
  "OpenapiCryptocurrencyPayinsResourcePaymentDetails",
  "OpenapiCryptocurrencyPayinsResourcePaymentMandate",
  "OpenapiCryptocurrencyPayinsResourceRelayQuote",
  "OpenapiCryptocurrencyPayinsResourceTokenBalance",
  "OpenapiCryptocurrencyPayinsResourceTransactionDetails",
  "OpenapiCryptocurrencyPayinsResourceUnderpaymentTransfer",
  "OpenapiCryptocurrencyPayinsResourceWalletTokenBalances",
  "OpenapiCryptocurrencyPayinsResourceWalletVerificationChallenge",
  "OpenapiCryptocurrencyPayoutsSupportedCryptoNetworks",
  "OpenapiCurrencyConversionResourceAvailableBalancesForCurrencyConversion",
  "OpenapiCurrencyConversionResourceAvailableBalancesForCurrencyConversionResourceBalanceSummary",
  "OpenapiCurrencyConversionResourceCurrencyConversionAmountBlock",
  "OpenapiCurrencyConversionResourceExpandedV2CurrencyConversionExpansionOf",
  "OpenapiCurrencyConversionResourceMonetaryAmount",
  "OpenapiCurrentUserUpdateContactPhoneNumber",
  "OpenapiCustomDomainsResourcesDnsRecord",
  "OpenapiCustomDomainsResourcesDnsRecordError",
  "OpenapiCustomLogo",
  "OpenapiCustomPaymentMethodTypesAdapterOnboardingTermsOfServiceAcceptanceDetails",
  "OpenapiCustomUnitAmount",
  "OpenapiCustomerAcceptance",
  "OpenapiCustomerAddressResolution",
  "OpenapiCustomerBalanceCustomerBalanceSettings",
  "OpenapiCustomerBalanceEnabledCurrencies",
  "OpenapiCustomerBalanceFundingInstructionsCustomerBalanceFundingInstructions",
  "OpenapiCustomerBalanceResourceCashBalanceTransactionResourceAppliedToPaymentTransaction",
  "OpenapiCustomerBalanceResourceCashBalanceTransactionResourceFundedTransaction",
  "OpenapiCustomerBalanceResourceCashBalanceTransactionResourceRefundedFromPaymentTransaction",
  "OpenapiCustomerBalanceResourceCashBalanceTransactionResourceUnappliedFromPaymentTransaction",
  "OpenapiCustomerBalanceResourceCustomerBalanceEnablementDetails",
  "OpenapiCustomerBalanceResourceDefaultReconciliationMode",
  "OpenapiCustomerBalanceResourcePerCurrencyCustomerBalanceEnablementDetails",
  "OpenapiCustomerBalanceResourceVbanOwnershipPdf",
  "OpenapiCustomerBalanceTransactionAdjustment",
  "OpenapiCustomerBalanceTransactionAppliedToPayment",
  "OpenapiCustomerBalanceTransactionDeposit",
  "OpenapiCustomerBalanceTransactionFunding",
  "OpenapiCustomerBalanceTransactionFundingBankTransfer",
  "OpenapiCustomerBalanceTransactionFundingBankTransferEuBankTransfer",
  "OpenapiCustomerBalanceTransactionRefund",
  "OpenapiCustomerBalanceTransactionUnappliedFromPayment",
  "OpenapiCustomerBalanceTransactionWithdrawal",
  "OpenapiCustomerBankAccounts",
  "OpenapiCustomerCashBalanceTransfer",
  "OpenapiCustomerPortalData",
  "OpenapiCustomerResourceContact",
  "OpenapiCustomerResourceCustomerAnalyticsNumericJustification",
  "OpenapiCustomerResourceCustomerAnalyticsPercentileJustification",
  "OpenapiCustomerResourceCustomerAnalyticsTagsApi",
  "OpenapiCustomerResourceCustomerSpendData",
  "OpenapiCustomerResourceGuestCustomerFingerprint",
  "OpenapiCustomerResourceLifetimeValue",
  "OpenapiCustomerResourceRecipientDetails",
  "OpenapiCustomerResourceRecipientDetailsOpalSettings",
  "OpenapiCustomerResourceRiskDetails",
  "OpenapiCustomerResourceRiskDetailsExternalCustomerDetails",
  "OpenapiCustomerSegmentationChartList",
  "OpenapiCustomerSegmentationDashboardList",
  "OpenapiCustomerSegmentationPromptToSql",
  "OpenapiCustomerSegmentationSavedSegmentList",
  "OpenapiCustomerShipping",
  "OpenapiCustomerSources",
  "OpenapiCustomerSubscriptions",
  "OpenapiCustomerTax",
  "OpenapiCustomerTaxExemptions",
  "OpenapiCustomerTaxIds",
  "OpenapiCustomerTaxLocation",
  "OpenapiCustomerUnifiedCustomersList",
  "OpenapiCustomerUnifiedLightningCustomersList",
  "OpenapiDashboardOnboardingResourcesOnboardingBusinessInfo",
  "OpenapiDataExplorerListReportGroups",
  "OpenapiDataStudioBillingDataStudioBillingCount",
  "OpenapiDataStudioBillingStartSdpTrial",
  "OpenapiDataStudioBillingSubscribeTrial",
  "OpenapiDataStudioBillingTrialEligibility",
  "OpenapiDebitAgreementResourceList",
  "OpenapiDeferredInterruptDeferredInterruptFulfill",
  "OpenapiDelegatedCheckoutResourceAffiliateAttribution",
  "OpenapiDelegatedCheckoutResourceAffiliateAttributionSource",
  "OpenapiDelegatedCheckoutResourceApplicableFee",
  "OpenapiDelegatedCheckoutResourceBuyerConsents",
  "OpenapiDelegatedCheckoutResourceClientDeviceMetadataDetails",
  "OpenapiDelegatedCheckoutResourceCustomAttribute",
  "OpenapiDelegatedCheckoutResourceDigitalOption",
  "OpenapiDelegatedCheckoutResourceDisclosure",
  "OpenapiDelegatedCheckoutResourceFulfillmentAddress",
  "OpenapiDelegatedCheckoutResourceFulfillmentDetails",
  "OpenapiDelegatedCheckoutResourceFulfillmentOption",
  "OpenapiDelegatedCheckoutResourceFulfillmentOptionDigital",
  "OpenapiDelegatedCheckoutResourceFulfillmentOptionShipping",
  "OpenapiDelegatedCheckoutResourceLineItem",
  "OpenapiDelegatedCheckoutResourceMarketingConsent",
  "OpenapiDelegatedCheckoutResourceMarketingConsentOption",
  "OpenapiDelegatedCheckoutResourceMarketingOptions",
  "OpenapiDelegatedCheckoutResourceMarketplaceSellerDetails",
  "OpenapiDelegatedCheckoutResourceOrderDetails",
  "OpenapiDelegatedCheckoutResourcePaymentMethodDataBillingAddress",
  "OpenapiDelegatedCheckoutResourcePaymentMethodDataBillingDetails",
  "OpenapiDelegatedCheckoutResourcePaymentMethodDataCard",
  "OpenapiDelegatedCheckoutResourcePaymentMethodDataPaymentMethodPreview",
  "OpenapiDelegatedCheckoutResourcePaymentMethodOptions",
  "OpenapiDelegatedCheckoutResourcePaymentMethodOptionsCard",
  "OpenapiDelegatedCheckoutResourceProductDetails",
  "OpenapiDelegatedCheckoutResourceRiskDetails",
  "OpenapiDelegatedCheckoutResourceSelectedFulfillmentOption",
  "OpenapiDelegatedCheckoutResourceSelectedFulfillmentOptionDigital",
  "OpenapiDelegatedCheckoutResourceSelectedFulfillmentOptionOverride",
  "OpenapiDelegatedCheckoutResourceSelectedFulfillmentOptionShipping",
  "OpenapiDelegatedCheckoutResourceSellerDetails",
  "OpenapiDelegatedCheckoutResourceShippingOption",
  "OpenapiDelegatedCheckoutResourceTotalDetails",
  "OpenapiDeliveryEstimate",
  "OpenapiDepositAddress",
  "OpenapiDepositAddresses",
  "OpenapiDepositDetails",
  "OpenapiDepositOptions",
  "OpenapiDestinationDetailsUnimplemented",
  "OpenapiDiscountEnd",
  "OpenapiDiscountServicePeriod",
  "OpenapiDiscountSource",
  "OpenapiDiscountsResourceDiscountAmount",
  "OpenapiDiscountsResourceStackableDiscountWithDiscountEnd",
  "OpenapiDisplayDetailsDepositAddress",
  "OpenapiDisplayDetailsDepositAddresses",
  "OpenapiDisplayDetailsSupportedToken",
  "OpenapiDisputeArbitrationCapabilitySettings",
  "OpenapiDisputeArbitrationSettings",
  "OpenapiDisputeArbitrationTermsOfServiceAcceptanceDetails",
  "OpenapiDisputeCaseDetails",
  "OpenapiDisputeEnhancedEligibility",
  "OpenapiDisputeEnhancedEligibilityVisaCompellingEvidence3",
  "OpenapiDisputeEnhancedEligibilityVisaCompliance",
  "OpenapiDisputeEnhancedEvidence",
  "OpenapiDisputeEnhancedEvidenceVisaCompellingEvidence3",
  "OpenapiDisputeEnhancedEvidenceVisaCompliance",
  "OpenapiDisputeEvidence",
  "OpenapiDisputeEvidenceDetails",
  "OpenapiDisputeGuidedFlowDetails",
  "OpenapiDisputeGuidedFlowDetailsTriageQuestions",
  "OpenapiDisputeGuidedFlowsEvidenceFields",
  "OpenapiDisputeGuidedFlowsEvidenceFieldsApiResourceFieldDetails",
  "OpenapiDisputeNetworkDetails",
  "OpenapiDisputeNetworkDetailsVisa",
  "OpenapiDisputePaymentMethodDetails",
  "OpenapiDisputePaymentMethodDetailsAmazonPay",
  "OpenapiDisputePaymentMethodDetailsCard",
  "OpenapiDisputePaymentMethodDetailsKlarna",
  "OpenapiDisputePaymentMethodDetailsPaypal",
  "OpenapiDisputeProtectionResultForDispute",
  "OpenapiDisputeTimestampUser",
  "OpenapiDisputeTransactionShippingAddress",
  "OpenapiDisputeVisaCompellingEvidence3DisputedTransaction",
  "OpenapiDisputeVisaCompellingEvidence3PriorUndisputedTransaction",
  "OpenapiDisputesAutoRepresentmentFeePassthroughDisputeFeePassthroughUsageFee",
  "OpenapiDisputesAutoRepresentmentFeePassthroughDisputeFeePassthroughUsageFeeData",
  "OpenapiDisputesAutoRepresentmentFeePassthroughDisputeFeePassthroughUsageFeeSummary",
  "OpenapiDisputesAutoRepresentmentMerchantConfiguration",
  "OpenapiDisputesAutoRepresentmentSettingTemplateInheritance",
  "OpenapiDisputesEnrichedCanonicalSearchEnrichedDisputeList",
  "OpenapiDisputesEnrichedCanonicalSearchEnrichedDisputeResourceEvidenceDetails",
  "OpenapiDisputesEvidenceLibraryEvidenceLibrary",
  "OpenapiDisputesEvidenceLibraryEvidenceLibraryCategory",
  "OpenapiDisputesPreventionMerchantSettingsQuery",
  "OpenapiDisputesPreventionProductEnrollmentQuery",
  "OpenapiDisputesUserFacingBooking",
  "OpenapiDisputesUserFacingChargeEvidence",
  "OpenapiDisputesUserFacingCreditVoucher",
  "OpenapiDisputesUserFacingEventDetails",
  "OpenapiDisputesUserFacingPriorPayment",
  "OpenapiDocument",
  "OpenapiDocumentAttestationResourceCreateCompliancePdf",
  "OpenapiDocumentAttestationResourceGetCompliancePdf",
  "OpenapiDocumentCollectionApiSubmitVerificationDocument",
  "OpenapiEcommerceProductCatalogFeedResourcesApplicableFees",
  "OpenapiEcommerceProductCatalogFeedResourcesError",
  "OpenapiEcommerceProductCatalogFeedResourcesFreeShippingThreshold",
  "OpenapiEcommerceProductCatalogFeedResourcesIngestedAndSyndicatedProductCounts",
  "OpenapiEcommerceProductCatalogFeedResourcesInventory",
  "OpenapiEcommerceProductCatalogFeedResourcesMedia",
  "OpenapiEcommerceProductCatalogFeedResourcesPrice",
  "OpenapiEcommerceProductCatalogFeedResourcesProduct",
  "OpenapiEcommerceProductCatalogFeedResourcesProductDetails",
  "OpenapiEcommerceProductCatalogFeedResourcesProductEntry",
  "OpenapiEcommerceProductCatalogFeedResourcesProductList",
  "OpenapiEcommerceProductCatalogFeedResourcesShipping",
  "OpenapiEcommerceProductCatalogFeedResourcesStatusCounts",
  "OpenapiEcommerceProductCatalogResourcesIngestionSourceApps",
  "OpenapiEcommerceProductCatalogResourcesMetadata",
  "OpenapiEmailSent",
  "OpenapiEmeraldAirport",
  "OpenapiEmeraldAuthorizationControls",
  "OpenapiEmeraldFlight",
  "OpenapiEmeraldFlightSegment",
  "OpenapiEmeraldSpendingLimit",
  "OpenapiEmeraldSpendingLimitUtilization",
  "OpenapiEmptyManage",
  "OpenapiEnterpriseProjectsBulkPromoCodesBulkPromoCodes",
  "OpenapiEnterpriseProjectsBulkPromoCodesBulkPromoCodesGetAllExecutionsList",
  "OpenapiEnterpriseProjectsBulkPromoCodesBulkPromoCodesGetCurrentExecution",
  "OpenapiEnterpriseProjectsBulkPromoCodesBulkPromoCodesGetDownloadUrl",
  "OpenapiExportDetails",
  "OpenapiExportField",
  "OpenapiExpressResourceExpressAccountBehaviorFlag",
  "OpenapiExpressResourceExpressEarnings",
  "OpenapiExpressResourceExpressEarningsApiResourceEarningsByPeriod",
  "OpenapiExpressResourceExpressEarningsApiResourceEarningsData",
  "OpenapiExpressResourceExpressEarningsApiResourceEarningsTimeseries",
  "OpenapiExpressResourceExpressPlatformBusinessProfileManage",
  "OpenapiExternalAccountBankAccountDebitAgreement",
  "OpenapiExternalAccountRequirements",
  "OpenapiFaEligibilityCheckResult",
  "OpenapiFasterSettlementSettings",
  "OpenapiFasterSettlementSettingsEnrollment",
  "OpenapiFasterSettlementSettingsProduct",
  "OpenapiFee",
  "OpenapiFees",
  "OpenapiFeesReferralReferralFeeAssessmentFeeSource",
  "OpenapiFileLinks",
  "OpenapiFinancialConnectionsOptionsLink",
  "OpenapiFinancialPartnerCommonDeclineError",
  "OpenapiFinancialPartnerCommonOutcome",
  "OpenapiFinancialPartnerDisputeResourceCancellationPolicyEvidence",
  "OpenapiFinancialPartnerDisputeResourceCustomerEvidence",
  "OpenapiFinancialPartnerDisputeResourceDuplicateChargeEvidence",
  "OpenapiFinancialPartnerDisputeResourceEvidence",
  "OpenapiFinancialPartnerDisputeResourceRefundPolicyEvidence",
  "OpenapiFinancialPartnerDisputeResourceServiceEvidence",
  "OpenapiFinancialPartnerDisputeResourceShippingEvidence",
  "OpenapiFinancialPartnerPaymentAuthorizationFundingSource",
  "OpenapiFinancialPartnerPaymentAuthorizationFundingSourceResourceCard",
  "OpenapiFinancialPartnerPaymentAuthorizationFundingSourceResourceMitExemption",
  "OpenapiFinancialPartnerPaymentAuthorizationFundingSourceResourceSettlementBalance",
  "OpenapiFinancialPartnerPaymentAuthorizationFundingSourceResourceSettlementBalanceResourceInstallment",
  "OpenapiFinancialPartnerPaymentAuthorizationResourceBuyerSelection",
  "OpenapiFinancialPartnerPaymentAuthorizationResourceBuyerSelectionResourceCard",
  "OpenapiFinancialPartnerPaymentAuthorizationResourceBuyerSelectionResourceInstallment",
  "OpenapiFinancialPartnerPaymentAuthorizationResourceFee",
  "OpenapiFinancialPartnerPaymentAuthorizationResourceMandateData",
  "OpenapiFinancialPartnerPaymentAuthorizationResourceNextAction",
  "OpenapiFinancialPartnerPaymentAuthorizationResourceNextActionResourceAuthenticationUrl",
  "OpenapiFinancialPartnerPaymentAuthorizationResourceNextActionResourceRedirectToUrl",
  "OpenapiFinancialReportingFinanceReportRunRunParameters",
  "OpenapiFinancialReportingMultiEntityFinanceReportTypeEntity",
  "OpenapiFinancialReportingOrgsResourceGetAccountMetadata",
  "OpenapiFinancialReportingOrgsResourceGetAccountsCurrencies",
  "OpenapiFinancialReportingOrgsResourceGetAccountsCurrency",
  "OpenapiFinancialReportingOrgsResourceGetAccountsMetadata",
  "OpenapiFinancialReportingOrgsResourceOrgPlatformAggregations",
  "OpenapiFinancialReportingStatementsMetadata",
  "OpenapiFortunaResourceActivateCredit",
  "OpenapiFortunaResourceCreateSetupIntent",
  "OpenapiFortunaResourceCurrentPricing",
  "OpenapiFortunaResourceCurrentPricingDetail",
  "OpenapiFortunaResourceGetCredit",
  "OpenapiFortunaResourceGetCurrentPricing",
  "OpenapiFortunaResourceListCredits",
  "OpenapiFortunaResourcePendingUpdate",
  "OpenapiFortunaResourceUpdateInvoicingEligibility",
  "OpenapiFundAndSendAccountTermsOfServiceAcceptanceDetails",
  "OpenapiFundAndSendAccountTermsOfServiceAcceptances",
  "OpenapiFundingCreditAccountTermsOfService",
  "OpenapiFundingInstructionsBankTransfer",
  "OpenapiFundingInstructionsBankTransferAbaRecord",
  "OpenapiFundingInstructionsBankTransferAuBankAccountAddressRecord",
  "OpenapiFundingInstructionsBankTransferCaBankAccountAddressRecord",
  "OpenapiFundingInstructionsBankTransferFinancialAddress",
  "OpenapiFundingInstructionsBankTransferIbanRecord",
  "OpenapiFundingInstructionsBankTransferIdBbanRecord",
  "OpenapiFundingInstructionsBankTransferSortCodeRecord",
  "OpenapiFundingInstructionsBankTransferSpeiRecord",
  "OpenapiFundingInstructionsBankTransferSwiftRecord",
  "OpenapiFundingInstructionsBankTransferZenginRecord",
  "OpenapiFundingSource",
  "OpenapiFxQuoteUsage",
  "OpenapiFxQuoteUsagePayment",
  "OpenapiFxQuoteUsageTransfer",
  "OpenapiGatewayEcho",
  "OpenapiGelatoAddressReport",
  "OpenapiGelatoAddressReportError",
  "OpenapiGelatoBlocklistEntryDocumentExtractedData",
  "OpenapiGelatoDocumentReport",
  "OpenapiGelatoDocumentReportError",
  "OpenapiGelatoDuplicateReport",
  "OpenapiGelatoDuplicateReportError",
  "OpenapiGelatoEmailDetails",
  "OpenapiGelatoEmailReport",
  "OpenapiGelatoEmailReportError",
  "OpenapiGelatoIdNumberReport",
  "OpenapiGelatoIdNumberReportError",
  "OpenapiGelatoInsightsInsightLabel",
  "OpenapiGelatoInsightsInsightLevel",
  "OpenapiGelatoInsightsV3BooleanInsight",
  "OpenapiGelatoInsightsV3RiskLevelInsight",
  "OpenapiGelatoMatchingReport",
  "OpenapiGelatoMatchingReportCollected",
  "OpenapiGelatoMatchingReportError",
  "OpenapiGelatoMatchingReportProvided",
  "OpenapiGelatoPersonVerification",
  "OpenapiGelatoPhoneDetails",
  "OpenapiGelatoPhoneOtpReport",
  "OpenapiGelatoPhoneOtpReportError",
  "OpenapiGelatoPhoneRecordsReport",
  "OpenapiGelatoPhoneRecordsReportError",
  "OpenapiGelatoPhoneReport",
  "OpenapiGelatoPhoneReportError",
  "OpenapiGelatoProvidedDetails",
  "OpenapiGelatoRelatedPerson",
  "OpenapiGelatoReportDocumentOptions",
  "OpenapiGelatoReportDuplicateOptions",
  "OpenapiGelatoReportEmailOptions",
  "OpenapiGelatoReportIdNumberOptions",
  "OpenapiGelatoReportPhoneOptions",
  "OpenapiGelatoReportPhoneOtpOptions",
  "OpenapiGelatoReportPhoneRecordsOptions",
  "OpenapiGelatoSelfieReport",
  "OpenapiGelatoSelfieReportError",
  "OpenapiGelatoSessionDocumentOptions",
  "OpenapiGelatoSessionDuplicateOptions",
  "OpenapiGelatoSessionEmailOptions",
  "OpenapiGelatoSessionIdNumberOptions",
  "OpenapiGelatoSessionLastError",
  "OpenapiGelatoSessionMatchingOptions",
  "OpenapiGelatoSessionPhoneOptions",
  "OpenapiGelatoSessionPhoneOtpOptions",
  "OpenapiGelatoSessionPhoneRecordsOptions",
  "OpenapiGelatoUserDataRequirement",
  "OpenapiGelatoVerificationReportOptions",
  "OpenapiGelatoVerificationSessionOptions",
  "OpenapiGelatoVerifiedOutputs",
  "OpenapiGeoIpAddressGeocoding",
  "OpenapiGetV1AccountPersons",
  "OpenapiGetV1AccountSuggestions",
  "OpenapiGetV1AccountsAccountCapabilities",
  "OpenapiGetV1AccountsAccountExternalAccounts",
  "OpenapiGetV1AccountsAccountPersons",
  "OpenapiGetV1AdaptivePricingSubaccountConfigs",
  "OpenapiGetV1AgenticCommerceChannels",
  "OpenapiGetV1AgenticCommerceSellers",
  "OpenapiGetV1AjaxPaymentMethodConfigurations",
  "OpenapiGetV1ApplePayDomains",
  "OpenapiGetV1ApplicationFees",
  "OpenapiGetV1Applications",
  "OpenapiGetV1Apps",
  "OpenapiGetV1AppsAppConnectionStripeType",
  "OpenapiGetV1AppsAppIdChannels",
  "OpenapiGetV1AppsAppIdInstalls",
  "OpenapiGetV1AppsInquiries",
  "OpenapiGetV1AppsSecrets",
  "OpenapiGetV1BalancePendingCurrency",
  "OpenapiGetV1BalanceSummary",
  "OpenapiGetV1BalanceTransactions",
  "OpenapiGetV1BalanceTransfers",
  "OpenapiGetV1BankingPrivateAccountsFinancialAccountStatements",
  "OpenapiGetV1BankingPrivatePlatformTransactionVolume",
  "OpenapiGetV1BillingAlerts",
  "OpenapiGetV1BillingCreditBalanceTransactions",
  "OpenapiGetV1BillingCreditGrants",
  "OpenapiGetV1BillingFeedbackOptions",
  "OpenapiGetV1BillingMeterEvents",
  "OpenapiGetV1BillingMeters",
  "OpenapiGetV1BillingPortalConfigurations",
  "OpenapiGetV1BillingPortalRefundPolicies",
  "OpenapiGetV1BillingPortalRefundPoliciesPrice",
  "OpenapiGetV1BillingPortalRetentionFlows",
  "OpenapiGetV1BillingPortalSessionsSessionInvoices",
  "OpenapiGetV1BillingPortalSessionsSessionInvoicesSearch",
  "OpenapiGetV1BillingPortalSessionsSessionPaymentMethods",
  "OpenapiGetV1BillingPortalSessionsSessionPricingPlanSubscriptions",
  "OpenapiGetV1BillingPortalSessionsSessionSubscriptions",
  "OpenapiGetV1BulkOnboardingExternalAccountsForLeAndMerchants",
  "OpenapiGetV1BulkOnboardingGetAccountsForBulkOnboardingMerchants",
  "OpenapiGetV1BulkOnboardingLegalEntitiesAccessibleForUserAndMerchants",
  "OpenapiGetV1CapitalActionRequired",
  "OpenapiGetV1CapitalAdditionalUnderwritingRequests",
  "OpenapiGetV1CapitalBankAccounts",
  "OpenapiGetV1CapitalDualMerchantFinancings",
  "OpenapiGetV1CapitalFinancingAccepted",
  "OpenapiGetV1CapitalFinancingMultiDrawFinancingLines",
  "OpenapiGetV1CapitalImports",
  "OpenapiGetV1CapitalOffers",
  "OpenapiGetV1CapitalPlatformPortfolioUnderwritingTimeSeries",
  "OpenapiGetV1CapitalPlatformsMerchantSettings",
  "OpenapiGetV1CashAdvances",
  "OpenapiGetV1Charges",
  "OpenapiGetV1CheckoutSessions",
  "OpenapiGetV1CheckoutSessionsSessionLineItems",
  "OpenapiGetV1ClimateOrders",
  "OpenapiGetV1ClimateProducts",
  "OpenapiGetV1ClimateSignupPricePoints",
  "OpenapiGetV1ClimateSuppliers",
  "OpenapiGetV1CommunicationPreferences",
  "OpenapiGetV1ConnectCommsCenterSentMessagesToConnectedAccount",
  "OpenapiGetV1ConnectCommsCenterUrls",
  "OpenapiGetV1ConnectFinancialAccounts",
  "OpenapiGetV1ConnectFinancingFinancingTransactions",
  "OpenapiGetV1ConnectInstantPayoutsConfig",
  "OpenapiGetV1ConnectLegalEntitiesAccessibleForUserAndMerchant",
  "OpenapiGetV1ConnectRisk",
  "OpenapiGetV1ConnectUnderwritingRequests",
  "OpenapiGetV1ConnectionsAccounts",
  "OpenapiGetV1ConnectionsFeaturedInstitutions",
  "OpenapiGetV1ConnectionsInstitutions",
  "OpenapiGetV1ConnectionsOffers",
  "OpenapiGetV1Coupons",
  "OpenapiGetV1CreditNotes",
  "OpenapiGetV1CreditNotesCreditNoteLines",
  "OpenapiGetV1CreditNotesPreviewLines",
  "OpenapiGetV1Customers",
  "OpenapiGetV1CustomersCustomerBalanceTransactions",
  "OpenapiGetV1CustomersCustomerCashBalanceTransactions",
  "OpenapiGetV1CustomersCustomerFundingInstructions",
  "OpenapiGetV1CustomersCustomerSources",
  "OpenapiGetV1CustomersCustomerTaxExemptions",
  "OpenapiGetV1CustomersSearch",
  "OpenapiGetV1DashboardSearch",
  "OpenapiGetV1Disputes",
  "OpenapiGetV1DisputesInternalAutoRepresentmentSettingSubaccountConfigs",
  "OpenapiGetV1EmeraldTransactions",
  "OpenapiGetV1EntitlementsActiveEntitlements",
  "OpenapiGetV1EntitlementsFeatures",
  "OpenapiGetV1Events",
  "OpenapiGetV1FacilitatedCommercePermissionGrants",
  "OpenapiGetV1FacilitatedCommerceProducts",
  "OpenapiGetV1FacilitatedCommerceProductsSearch",
  "OpenapiGetV1Files",
  "OpenapiGetV1FinancialConnectionsAccounts",
  "OpenapiGetV1FinancialConnectionsAccountsAccountBalanceActivity",
  "OpenapiGetV1FinancialConnectionsRefreshes",
  "OpenapiGetV1FinancialConnectionsSessions",
  "OpenapiGetV1FinancialConnectionsSessionsSessionEvents",
  "OpenapiGetV1FinancingFinancingTransactions",
  "OpenapiGetV1FinancingTransactions",
  "OpenapiGetV1FlexLoans",
  "OpenapiGetV1FlexLoansFlexLoanMinRepaymentWindows",
  "OpenapiGetV1FrMealVouchersSiretInfo",
  "OpenapiGetV1GiftCardsCards",
  "OpenapiGetV1GiftCardsTransactions",
  "OpenapiGetV1GuestCustomers",
  "OpenapiGetV1IdentityVerificationReports",
  "OpenapiGetV1IdentityVerificationSessions",
  "OpenapiGetV1IdentityVerificationTemplates",
  "OpenapiGetV1Inventories",
  "OpenapiGetV1InvoicePayments",
  "OpenapiGetV1InvoiceRenderingTemplates",
  "OpenapiGetV1Invoiceitems",
  "OpenapiGetV1Invoices",
  "OpenapiGetV1InvoicesInvoiceLines",
  "OpenapiGetV1InvoicesInvoicePayments",
  "OpenapiGetV1InvoicesInvoiceRevisions",
  "OpenapiGetV1InvoicesInvoiceSummaryItems",
  "OpenapiGetV1InvoicesUpcomingLines",
  "OpenapiGetV1IssuingAuthorizations",
  "OpenapiGetV1IssuingCardholders",
  "OpenapiGetV1IssuingCards",
  "OpenapiGetV1IssuingDisputes",
  "OpenapiGetV1IssuingPersonalizationDesigns",
  "OpenapiGetV1IssuingPhysicalBundles",
  "OpenapiGetV1IssuingPrograms",
  "OpenapiGetV1IssuingProgramsList",
  "OpenapiGetV1IssuingReceipts",
  "OpenapiGetV1IssuingTransactions",
  "OpenapiGetV1ListLegacyChargesSearch",
  "OpenapiGetV1ManagedOperationsCampaigns",
  "OpenapiGetV1ManagedOperationsCancellationReasons",
  "OpenapiGetV1Mandates",
  "OpenapiGetV1MexicoAddressSuggest",
  "OpenapiGetV1Notes",
  "OpenapiGetV1OrdersIdLineItems",
  "OpenapiGetV1PaperChecks",
  "OpenapiGetV1PaymentAttemptRecordsIdEntries",
  "OpenapiGetV1PaymentIntents",
  "OpenapiGetV1PaymentIntentsWithLegacyCharges",
  "OpenapiGetV1PaymentLinks",
  "OpenapiGetV1PaymentLinksPaymentLinkLineItems",
  "OpenapiGetV1PaymentMethodConfigurations",
  "OpenapiGetV1PaymentMethodDomains",
  "OpenapiGetV1PaymentMethods",
  "OpenapiGetV1PaymentOptimizerTrials",
  "OpenapiGetV1PaymentOrchestrationRoutingRoutingConfigs",
  "OpenapiGetV1PaymentProviderBalanceTransactions",
  "OpenapiGetV1Payouts",
  "OpenapiGetV1PayoutsCurrencyCurrency",
  "OpenapiGetV1PersonVerificationRequest",
  "OpenapiGetV1Prices",
  "OpenapiGetV1PricingTables",
  "OpenapiGetV1ProductCatalogTrialOffers",
  "OpenapiGetV1ProductClasses",
  "OpenapiGetV1ProductFeatures",
  "OpenapiGetV1ProductSuggestions",
  "OpenapiGetV1Products",
  "OpenapiGetV1ProductsProductFeatures",
  "OpenapiGetV1ProfilesSearch",
  "OpenapiGetV1Quotes",
  "OpenapiGetV1RadarPaymentEvaluations",
  "OpenapiGetV1RadarRetrieveFraudAlerts",
  "OpenapiGetV1RadarValueListItems",
  "OpenapiGetV1RadarValueLists",
  "OpenapiGetV1RealTimeNotificationSettings",
  "OpenapiGetV1Refunds",
  "OpenapiGetV1ReportingCompartmentCachedMetadataKeys",
  "OpenapiGetV1ReportingMultiEntityReportTypes",
  "OpenapiGetV1ReportingReportRuns",
  "OpenapiGetV1ReportingReportTypes",
  "OpenapiGetV1ReserveHolds",
  "OpenapiGetV1ReservePlans",
  "OpenapiGetV1ReserveReleases",
  "OpenapiGetV1RetryPolicies",
  "OpenapiGetV1RevenueRecognitionContractsIdLines",
  "OpenapiGetV1RevenueRecognitionDataImportJournalEntries",
  "OpenapiGetV1RevenueStudioCampaigns",
  "OpenapiGetV1Reviews",
  "OpenapiGetV1RiskStripeVerifiedInterventions",
  "OpenapiGetV1SettingsUserSettlementCurrencies",
  "OpenapiGetV1SetupAttempts",
  "OpenapiGetV1ShippingRates",
  "OpenapiGetV1SigmaOrganizationQueries",
  "OpenapiGetV1SigmaOrganizationQueryFiles",
  "OpenapiGetV1SigmaOrganizationScheduledQueryRuns",
  "OpenapiGetV1SigmaQueries",
  "OpenapiGetV1SigmaScheduledQueries",
  "OpenapiGetV1SigmaScheduledQueryRuns",
  "OpenapiGetV1Skus",
  "OpenapiGetV1StripeDataPipelineExportPlans",
  "OpenapiGetV1StripecliDevices",
  "OpenapiGetV1StripecliWebhookResponses",
  "OpenapiGetV1SubscriptionItems",
  "OpenapiGetV1SubscriptionSchedules",
  "OpenapiGetV1Subscriptions",
  "OpenapiGetV1TailorAppBuildVersion",
  "OpenapiGetV1TailorAppIdInstalls",
  "OpenapiGetV1TailorExtensionPrototypeVersions",
  "OpenapiGetV1TailorExtensionUsagesForApp",
  "OpenapiGetV1TailorExtensionsForInterface",
  "OpenapiGetV1TailorInstall",
  "OpenapiGetV1TaxAvailableCountries",
  "OpenapiGetV1TaxCodes",
  "OpenapiGetV1TaxDocuments",
  "OpenapiGetV1TaxFilingEnrollmentApplications",
  "OpenapiGetV1TaxFilingEnrollmentsAndApplications",
  "OpenapiGetV1TaxLocations",
  "OpenapiGetV1TaxRates",
  "OpenapiGetV1TaxRegistrationApplications",
  "OpenapiGetV1TaxRegistrations",
  "OpenapiGetV1TerminalAccountGroupAccountGroupIdDeployments",
  "OpenapiGetV1TerminalAccountGroupAccountGroupIdDeviceAssetVersions",
  "OpenapiGetV1TerminalAccountGroupAccountGroupIdDeviceAssets",
  "OpenapiGetV1TerminalAccountGroupAccountGroupIdDeviceDeployGroups",
  "OpenapiGetV1TerminalConfigurations",
  "OpenapiGetV1TerminalDeployPlans",
  "OpenapiGetV1TerminalDeviceAssetVersions",
  "OpenapiGetV1TerminalDeviceAssets",
  "OpenapiGetV1TerminalDeviceDeployBundles",
  "OpenapiGetV1TerminalDeviceDeployGroups",
  "OpenapiGetV1TerminalDeviceDeployGroupsDeployGroupDeployRules",
  "OpenapiGetV1TerminalHardwareOrderDevices",
  "OpenapiGetV1TerminalHardwareOrderDevicesHardwareOrderInfo",
  "OpenapiGetV1TerminalHardwareOrders",
  "OpenapiGetV1TerminalHardwareOrdersInvoicesPaginated",
  "OpenapiGetV1TerminalHardwareOrdersMerchantTaxIds",
  "OpenapiGetV1TerminalHardwareShippingMethods",
  "OpenapiGetV1TerminalHardwareSkus",
  "OpenapiGetV1TerminalHardwareSkusRetrieveByIds",
  "OpenapiGetV1TerminalLocationCapabilities",
  "OpenapiGetV1TerminalLocationCapabilitiesSearch",
  "OpenapiGetV1TerminalLocations",
  "OpenapiGetV1TerminalLocationsSearch",
  "OpenapiGetV1TerminalReaders",
  "OpenapiGetV1TerminalReadersSearch",
  "OpenapiGetV1TerminalZones",
  "OpenapiGetV1TestHelpersTestClocks",
  "OpenapiGetV1ThreeDSecureAuthentications",
  "OpenapiGetV1Topups",
  "OpenapiGetV1Transfers",
  "OpenapiGetV1TreasuryFinancialAccounts",
  "OpenapiGetV1TreasuryOutboundPayments",
  "OpenapiGetV1TreasuryTransactions",
  "OpenapiGetV1WebhookEndpoints",
  "OpenapiGetV1WorkbenchWebhookConversations",
  "OpenapiGiftCardTransactions",
  "OpenapiGiftCardsBalanceResourceBalanceAmount",
  "OpenapiGiftCardsOperationActivationDetail",
  "OpenapiGiftCardsOperationActivationVoidDetail",
  "OpenapiGiftCardsOperationBalanceCheckDetail",
  "OpenapiGiftCardsOperationCashoutDetail",
  "OpenapiGiftCardsOperationCashoutVoidDetail",
  "OpenapiGiftCardsOperationDeactivationDetail",
  "OpenapiGiftCardsOperationReloadDetail",
  "OpenapiGiftCardsOperationReloadVoidDetail",
  "OpenapiGrowthInviteATeammateList",
  "OpenapiGrowthXpGetLtmHandraiseEligibility",
  "OpenapiHostedAgenticCommerceProtocolConnectResourceAgenticCommerceConfigSubaccount",
  "OpenapiHostedAgenticCommerceProtocolConnectResourceAgenticCommerceConfigTemplate",
  "OpenapiHostedAgenticCommerceProtocolTurnkeySellerOnboardingSteps",
  "OpenapiHostedAgenticCommerceProtocolTurnkeySellerOnboardingStepsResourceOnboardingStep",
  "OpenapiHostedAgenticCommerceProtocolTurnkeySellerOnboardingStepsResourceOnboardingSteps",
  "OpenapiHostedAgenticCommerceProtocolTurnkeySellerOnboardingStepsResourceStripeTax",
  "OpenapiHostedAgenticCommerceProtocolTurnkeySellerOnboardingStepsResourceTax",
  "OpenapiIamResourceRoleAssignment",
  "OpenapiIamResourceRoleAssignments",
  "OpenapiIdentifiers",
  "OpenapiImportSetCreationContextField",
  "OpenapiImportSetResultErrorFieldApi",
  "OpenapiImportSetResultFieldApi",
  "OpenapiImportSetResultSkippedByFilterFieldApi",
  "OpenapiImportSetResultSkippedDuplicatesFieldApi",
  "OpenapiImportSetResultSuccessFieldApi",
  "OpenapiImportSetStatusTransitionsFieldApi",
  "OpenapiInboundTransfers",
  "OpenapiInboundTransfersPaymentMethodDetailsUsBankAccount",
  "OpenapiInboundTransfersPaymentMethodDetailsUsBankAccountAchSubmission",
  "OpenapiInboundTransfersPaymentMethodDetailsUsCashVoucher",
  "OpenapiInboundTransfersPaymentMethodDetailsUsCashVoucherDeviceLocation",
  "OpenapiInboundTransfersResourceInboundTransferResourceLinkedFlows",
  "OpenapiInsightsResourcesPaymentEvaluationAddress",
  "OpenapiInsightsResourcesPaymentEvaluationBillingDetails",
  "OpenapiInsightsResourcesPaymentEvaluationClientDeviceMetadata",
  "OpenapiInsightsResourcesPaymentEvaluationClientDeviceMetadataContext",
  "OpenapiInsightsResourcesPaymentEvaluationCustomerDetails",
  "OpenapiInsightsResourcesPaymentEvaluationDisputeOpened",
  "OpenapiInsightsResourcesPaymentEvaluationEarlyFraudWarningReceived",
  "OpenapiInsightsResourcesPaymentEvaluationEvent",
  "OpenapiInsightsResourcesPaymentEvaluationInsights",
  "OpenapiInsightsResourcesPaymentEvaluationMerchantBlocked",
  "OpenapiInsightsResourcesPaymentEvaluationMoneyMovementCard",
  "OpenapiInsightsResourcesPaymentEvaluationMoneyMovementDetails",
  "OpenapiInsightsResourcesPaymentEvaluationOutcome",
  "OpenapiInsightsResourcesPaymentEvaluationPaymentDetails",
  "OpenapiInsightsResourcesPaymentEvaluationPaymentMethodDetails",
  "OpenapiInsightsResourcesPaymentEvaluationRefunded",
  "OpenapiInsightsResourcesPaymentEvaluationRejected",
  "OpenapiInsightsResourcesPaymentEvaluationRejectedCard",
  "OpenapiInsightsResourcesPaymentEvaluationScorer",
  "OpenapiInsightsResourcesPaymentEvaluationShipping",
  "OpenapiInsightsResourcesPaymentEvaluationSignalNonPaymentAbuse",
  "OpenapiInsightsResourcesPaymentEvaluationSignalV2",
  "OpenapiInsightsResourcesPaymentEvaluationSignals",
  "OpenapiInsightsResourcesPaymentEvaluationSucceeded",
  "OpenapiInsightsResourcesPaymentEvaluationSucceededCard",
  "OpenapiInsightsResourcesPaymentEvaluationUserInterventionRaised",
  "OpenapiInsightsResourcesPaymentEvaluationUserInterventionRaisedCustom",
  "OpenapiInsightsResourcesPaymentEvaluationUserInterventionResolved",
  "OpenapiInstallmentsOptionsP24",
  "OpenapiInstantDebitsSellerInfoLink",
  "OpenapiIntegrationMigrationSourcesUsage",
  "OpenapiIntegrationMigrationUsage",
  "OpenapiInternalCard",
  "OpenapiInvoiceCheckDepositAddressOptions",
  "OpenapiInvoiceClientLines",
  "OpenapiInvoiceInstallmentsCard",
  "OpenapiInvoiceItemProrationCreditedItems",
  "OpenapiInvoiceItemThresholdReason",
  "OpenapiInvoiceLineItemPeriod",
  "OpenapiInvoiceLineItemRendering",
  "OpenapiInvoiceLines",
  "OpenapiInvoiceMandateOptionsCard",
  "OpenapiInvoiceMandateOptionsPayto",
  "OpenapiInvoicePaymentMethodOptionsAcssDebit",
  "OpenapiInvoicePaymentMethodOptionsAcssDebitMandateOptions",
  "OpenapiInvoicePaymentMethodOptionsBancontact",
  "OpenapiInvoicePaymentMethodOptionsBizum",
  "OpenapiInvoicePaymentMethodOptionsBlik",
  "OpenapiInvoicePaymentMethodOptionsCard",
  "OpenapiInvoicePaymentMethodOptionsCheckScan",
  "OpenapiInvoicePaymentMethodOptionsCustomerBalance",
  "OpenapiInvoicePaymentMethodOptionsCustomerBalanceBankTransfer",
  "OpenapiInvoicePaymentMethodOptionsCustomerBalanceBankTransferEuBankTransfer",
  "OpenapiInvoicePaymentMethodOptionsCustomerBalanceBankTransferIdBankTransfer",
  "OpenapiInvoicePaymentMethodOptionsIdBankTransfer",
  "OpenapiInvoicePaymentMethodOptionsKonbini",
  "OpenapiInvoicePaymentMethodOptionsMandateOptionsUpi",
  "OpenapiInvoicePaymentMethodOptionsPayto",
  "OpenapiInvoicePaymentMethodOptionsPix",
  "OpenapiInvoicePaymentMethodOptionsSepaDebit",
  "OpenapiInvoicePaymentMethodOptionsUpi",
  "OpenapiInvoicePaymentMethodOptionsUsBankAccount",
  "OpenapiInvoicePaymentMethodOptionsUsBankAccountLinkedAccountOptions",
  "OpenapiInvoicePaymentMethodOptionsUsBankAccountLinkedAccountOptionsFilters",
  "OpenapiInvoicePayments",
  "OpenapiInvoiceRenderingCustomText",
  "OpenapiInvoiceRenderingFields",
  "OpenapiInvoiceRenderingFieldsCustomFields",
  "OpenapiInvoiceRenderingFieldsDescription",
  "OpenapiInvoiceRenderingFieldsFooter",
  "OpenapiInvoiceRenderingPdf",
  "OpenapiInvoiceSettingAccountSetting",
  "OpenapiInvoiceSettingCheckoutRenderingOptions",
  "OpenapiInvoiceSettingCustomField",
  "OpenapiInvoiceSettingCustomerRenderingOptions",
  "OpenapiInvoiceSettingCustomerSetting",
  "OpenapiInvoiceSettingProrationSetting",
  "OpenapiInvoiceSettingQuoteSetting",
  "OpenapiInvoiceSettingRendering",
  "OpenapiInvoiceSettingRenderingOptions",
  "OpenapiInvoiceSettingSubscriptionSchedulePhaseSetting",
  "OpenapiInvoiceSettingSubscriptionScheduleSetting",
  "OpenapiInvoiceSettingSupportedPaymentMethods",
  "OpenapiInvoiceTaxAmount",
  "OpenapiInvoiceTaxAmountClient",
  "OpenapiInvoiceThresholdReason",
  "OpenapiInvoiceTransferData",
  "OpenapiInvoicesAvailablePaymentMethod",
  "OpenapiInvoicesChallengesSiteKey",
  "OpenapiInvoicesPaymentMethodOptions",
  "OpenapiInvoicesPaymentMethodTypesResourceMerchantEnabledPaymentConfiguration",
  "OpenapiInvoicesPaymentSettings",
  "OpenapiInvoicesPaymentsInvoicePaymentAssociatedPayment",
  "OpenapiInvoicesPaymentsInvoicePaymentStatusTransitions",
  "OpenapiInvoicesPaymentsOutOfBandPayment",
  "OpenapiInvoicesPaymentsPaymentRecordTemporaryClient",
  "OpenapiInvoicesPaymentsPaymentRecordTemporaryClientResourceAmount",
  "OpenapiInvoicesPaymentsPaymentRecordTemporaryClientResourcePaymentMethodDetails",
  "OpenapiInvoicesPaymentsPaymentRecordTemporaryClientResourcePaymentMethodDetailsResourceCustomDetails",
  "OpenapiInvoicesResourceConfirmationSecret",
  "OpenapiInvoicesResourceEmailSubjectData",
  "OpenapiInvoicesResourceFromInvoice",
  "OpenapiInvoicesResourceInvoiceRendering",
  "OpenapiInvoicesResourceInvoiceRenderingSummaryItems",
  "OpenapiInvoicesResourceInvoiceTaxId",
  "OpenapiInvoicesResourcePretaxCreditAmount",
  "OpenapiInvoicesResourceRedaction",
  "OpenapiInvoicesResourceScheduledPayment",
  "OpenapiInvoicesResourceStatusTransitions",
  "OpenapiInvoicesResourceTaxCalculationExtension",
  "OpenapiInvoicesResourceTaxCalculationExtensionErrorDetails",
  "OpenapiInvoicesResourceTaxCalculationExtensionInternalErrorDetails",
  "OpenapiInvoicesResourceTaxCalculationExtensionResult",
  "OpenapiInvoicesResourceTaxCalculationExtensionValidationErrorDetails",
  "OpenapiInvoicesTaxInfoSettings",
  "OpenapiInvoicingRule",
  "OpenapiIssuingAftEnrollmentEnrollment",
  "OpenapiIssuingAftEnrollmentEnrollmentResourcePricingDetails",
  "OpenapiIssuingAftEnrollmentUserConfig",
  "OpenapiIssuingAuthenticationChallenge",
  "OpenapiIssuingAuthenticationMerchantData",
  "OpenapiIssuingAuthenticationRedaction",
  "OpenapiIssuingAuthorizationAuthenticationExemption",
  "OpenapiIssuingAuthorizationCardTestingRisk",
  "OpenapiIssuingAuthorizationFleetCardholderPromptData",
  "OpenapiIssuingAuthorizationFleetData",
  "OpenapiIssuingAuthorizationFleetDynamicPurchaseControls",
  "OpenapiIssuingAuthorizationFleetFuelPriceData",
  "OpenapiIssuingAuthorizationFleetNonFuelPriceData",
  "OpenapiIssuingAuthorizationFleetReportedBreakdown",
  "OpenapiIssuingAuthorizationFleetTaxData",
  "OpenapiIssuingAuthorizationFraudChallenge",
  "OpenapiIssuingAuthorizationFuelData",
  "OpenapiIssuingAuthorizationMerchantData",
  "OpenapiIssuingAuthorizationMerchantRisk",
  "OpenapiIssuingAuthorizationNetworkData",
  "OpenapiIssuingAuthorizationOriginalCredit",
  "OpenapiIssuingAuthorizationPendingRequestFleet",
  "OpenapiIssuingAuthorizationRedaction",
  "OpenapiIssuingAuthorizationRequest",
  "OpenapiIssuingAuthorizationRiskAssessment",
  "OpenapiIssuingAuthorizationSenderData",
  "OpenapiIssuingAuthorizationStoredCredentialData",
  "OpenapiIssuingAuthorizationThreeDSecure",
  "OpenapiIssuingAuthorizationVerificationData",
  "OpenapiIssuingAuthorizationViolatedAuthControl",
  "OpenapiIssuingCardAllowedAuthorizationPeriod",
  "OpenapiIssuingCardApplePay",
  "OpenapiIssuingCardAuthenticationExemption",
  "OpenapiIssuingCardAuthorizationControls",
  "OpenapiIssuingCardCardFulfillments",
  "OpenapiIssuingCardCryptoWallet",
  "OpenapiIssuingCardDesignDetails",
  "OpenapiIssuingCardGooglePay",
  "OpenapiIssuingCardGooglePayWebProvisioningRequestCard",
  "OpenapiIssuingCardGooglePayWebProvisioningRequestCardholder",
  "OpenapiIssuingCardGooglePayWebProvisioningRequestInitiateProvisioning",
  "OpenapiIssuingCardLifecycleConditions",
  "OpenapiIssuingCardLifecycleControls",
  "OpenapiIssuingCardMultiFactorAuthenticationOverride",
  "OpenapiIssuingCardOfflinePin",
  "OpenapiIssuingCardOnlinePin",
  "OpenapiIssuingCardPin",
  "OpenapiIssuingCardRedaction",
  "OpenapiIssuingCardShipping",
  "OpenapiIssuingCardShippingAddressValidation",
  "OpenapiIssuingCardShippingCustoms",
  "OpenapiIssuingCardSimpleSpendingControls",
  "OpenapiIssuingCardSimpleSpendingLimit",
  "OpenapiIssuingCardSpendUtilization",
  "OpenapiIssuingCardSpendUtilizationInterval",
  "OpenapiIssuingCardSpendingLimit",
  "OpenapiIssuingCardWalletVerificationCode",
  "OpenapiIssuingCardWallets",
  "OpenapiIssuingCardholderAddress",
  "OpenapiIssuingCardholderAuthorizationControls",
  "OpenapiIssuingCardholderCardIssuing",
  "OpenapiIssuingCardholderCompany",
  "OpenapiIssuingCardholderIdDocument",
  "OpenapiIssuingCardholderIndividualDob",
  "OpenapiIssuingCardholderRedaction",
  "OpenapiIssuingCardholderRequirements",
  "OpenapiIssuingCardholderSimpleSpendingControls",
  "OpenapiIssuingCardholderSimpleSpendingLimit",
  "OpenapiIssuingCardholderSpendUtilization",
  "OpenapiIssuingCardholderSpendUtilizationInterval",
  "OpenapiIssuingCardholderSpendingLimit",
  "OpenapiIssuingCardholderVerification",
  "OpenapiIssuingCreditLedgerEntryResourceEntrySource",
  "OpenapiIssuingCreditRepaymentRepaymentAmount",
  "OpenapiIssuingCreditRepaymentRepaymentAmountAllocation",
  "OpenapiIssuingCreditRepaymentRepaymentDestinationBalance",
  "OpenapiIssuingCryptoTransactionConfirmed",
  "OpenapiIssuingCryptoTransactionEntry",
  "OpenapiIssuingCryptoTransactionFailed",
  "OpenapiIssuingCryptoTransactionFee",
  "OpenapiIssuingDisputeCanceledEvidence",
  "OpenapiIssuingDisputeDuplicateEvidence",
  "OpenapiIssuingDisputeEvidence",
  "OpenapiIssuingDisputeFraudulentEvidence",
  "OpenapiIssuingDisputeMerchandiseNotAsDescribedEvidence",
  "OpenapiIssuingDisputeNoValidAuthorizationEvidence",
  "OpenapiIssuingDisputeNotReceivedEvidence",
  "OpenapiIssuingDisputeOtherEvidence",
  "OpenapiIssuingDisputeProductNotReceivedEvidence",
  "OpenapiIssuingDisputeRedaction",
  "OpenapiIssuingDisputeServiceNotAsDescribedEvidence",
  "OpenapiIssuingEmbeddedFlags",
  "OpenapiIssuingOnboardingFinancialServicesOnboarding",
  "OpenapiIssuingOnboardingLiveModeTrialControlsIssuingLiveModeTrialControls",
  "OpenapiIssuingPersonalizationDesignCarrierText",
  "OpenapiIssuingPersonalizationDesignPreferences",
  "OpenapiIssuingPersonalizationDesignRejectionReasons",
  "OpenapiIssuingPhysicalBundleFeatures",
  "OpenapiIssuingProgramDashboardOnlyOffboardTest",
  "OpenapiIssuingRuleBacktest",
  "OpenapiIssuingTransactionEnrichment",
  "OpenapiIssuingTransactionEnrichmentBusiness",
  "OpenapiIssuingTransactionEnrichmentBusinessLocationAddress",
  "OpenapiIssuingTransactionEnrichmentBusinessLocationCoordinates",
  "OpenapiIssuingTransactionEnrichmentBusinessSpade",
  "OpenapiIssuingTransactionEnrichmentThirdParty",
  "OpenapiIssuingTransactionEnrichmentThirdPartySpade",
  "OpenapiIssuingTransactionFleetCardholderPromptData",
  "OpenapiIssuingTransactionFleetData",
  "OpenapiIssuingTransactionFleetFuelPriceData",
  "OpenapiIssuingTransactionFleetNonFuelPriceData",
  "OpenapiIssuingTransactionFleetReportedBreakdown",
  "OpenapiIssuingTransactionFleetTaxData",
  "OpenapiIssuingTransactionFlightData",
  "OpenapiIssuingTransactionFlightDataLeg",
  "OpenapiIssuingTransactionFuelData",
  "OpenapiIssuingTransactionInterchange",
  "OpenapiIssuingTransactionLodgingData",
  "OpenapiIssuingTransactionPurchaseDetails",
  "OpenapiIssuingTransactionReceiptData",
  "OpenapiIssuingTransactionRedaction",
  "OpenapiIssuingTransactionTaxData",
  "OpenapiKlarnaAddress",
  "OpenapiKlarnaIncrementalAuthorization",
  "OpenapiKlarnaMulticapture",
  "OpenapiKlarnaPayerDetails",
  "OpenapiKlarnaSupplementaryPurchaseData",
  "OpenapiKlarnaSupplementaryPurchaseDataAddress",
  "OpenapiKlarnaSupplementaryPurchaseDataBusReservationDetailsArrival",
  "OpenapiKlarnaSupplementaryPurchaseDataBusReservationDetailsDeparture",
  "OpenapiKlarnaSupplementaryPurchaseDataBusReservationDetailsInsurance",
  "OpenapiKlarnaSupplementaryPurchaseDataBusReservationDetailsPassenger",
  "OpenapiKlarnaSupplementaryPurchaseDataCustomerCustomerAccount",
  "OpenapiKlarnaSupplementaryPurchaseDataCustomerCustomerAccountsLastLogin",
  "OpenapiKlarnaSupplementaryPurchaseDataCustomerCustomerAccountsPurchaseHistory",
  "OpenapiKlarnaSupplementaryPurchaseDataEventReservationDetailsInsurance",
  "OpenapiKlarnaSupplementaryPurchaseDataFerryReservationDetailsArrival",
  "OpenapiKlarnaSupplementaryPurchaseDataFerryReservationDetailsDeparture",
  "OpenapiKlarnaSupplementaryPurchaseDataFerryReservationDetailsInsurance",
  "OpenapiKlarnaSupplementaryPurchaseDataFerryReservationDetailsPassenger",
  "OpenapiKlarnaSupplementaryPurchaseDataInsurance",
  "OpenapiKlarnaSupplementaryPurchaseDataRoundTripReservationDetailsArrival",
  "OpenapiKlarnaSupplementaryPurchaseDataRoundTripReservationDetailsDeparture",
  "OpenapiKlarnaSupplementaryPurchaseDataRoundTripReservationDetailsInsurance",
  "OpenapiKlarnaSupplementaryPurchaseDataRoundTripReservationDetailsPassenger",
  "OpenapiKlarnaSupplementaryPurchaseDataTrainReservationDetailsArrival",
  "OpenapiKlarnaSupplementaryPurchaseDataTrainReservationDetailsDeparture",
  "OpenapiKlarnaSupplementaryPurchaseDataTrainReservationDetailsInsurance",
  "OpenapiKlarnaSupplementaryPurchaseDataTrainReservationDetailsPassenger",
  "OpenapiLastFinalizationError",
  "OpenapiLastPaymentError",
  "OpenapiLastSetupError",
  "OpenapiLegalEntity",
  "OpenapiLegalEntityAddress",
  "OpenapiLegalEntityCompany",
  "OpenapiLegalEntityCompanyStockData",
  "OpenapiLegalEntityCompanyVerification",
  "OpenapiLegalEntityCompanyVerificationDocument",
  "OpenapiLegalEntityDirectorshipDeclaration",
  "OpenapiLegalEntityDob",
  "OpenapiLegalEntityInfo",
  "OpenapiLegalEntityJapanAddress",
  "OpenapiLegalEntityPersonVerification",
  "OpenapiLegalEntityPersonVerificationDocument",
  "OpenapiLegalEntityRegistrationDate",
  "OpenapiLegalEntityRepresentativeDeclaration",
  "OpenapiLegalEntityUboDeclaration",
  "OpenapiLetterAccountEmailSettingsEndpointResourcesAccountEmailSettingCreation",
  "OpenapiLetterAccountEmailSettingsEndpointResourcesFetchAccountEmailSetting",
  "OpenapiLetterAccountEmailSettingsEndpointResourcesListAccountEmailSettings",
  "OpenapiLevel3",
  "OpenapiLevel3LineItems",
  "OpenapiLineItemKlarna",
  "OpenapiLineItemPaypal",
  "OpenapiLineItemPolicy",
  "OpenapiLineItemsAdjustableQuantity",
  "OpenapiLineItemsDiscountAmount",
  "OpenapiLineItemsDisplay",
  "OpenapiLineItemsInventory",
  "OpenapiLineItemsPaymentLinkMeta",
  "OpenapiLineItemsPaymentLinkMetaResourceAdjustableQuantity",
  "OpenapiLineItemsProductDetails",
  "OpenapiLineItemsTaxAmount",
  "OpenapiLinkedAccountOptionsCommon",
  "OpenapiLogRequest",
  "OpenapiLogResponse",
  "OpenapiLoginLink",
  "OpenapiLpmAdoptionResourcesCreateOrUpdatePaymentsConfig",
  "OpenapiLpmAdoptionResourcesDisplayPreference",
  "OpenapiLpmAdoptionResourcesPaymentMethodDefaultCurrencyLimitResourceCurrencyLimit",
  "OpenapiLpmAdoptionResourcesPaymentMethodEnabledProp",
  "OpenapiLpmAdoptionResourcesPaymentMethodFilteringReason",
  "OpenapiLpmAdoptionResourcesPaymentMethodFilteringReasonResourcePaymentMethodFiltrationReasonArgs",
  "OpenapiLpmAdoptionResourcesPaymentMethodRecommendedBuyerCountries",
  "OpenapiLpmAdoptionResourcesPaymentMethodSupportedCurrencies",
  "OpenapiLpmAdoptionResourcesPaymentsConfigResourceExperimentTreatmentPaymentMethodRuleSet",
  "OpenapiLpmAdoptionResourcesRuleSet",
  "OpenapiLpmAdoptionResourcesSyncDetails",
  "OpenapiLpmDashboardSettingsGetMerchantAffirmFinancingPackage",
  "OpenapiLpmPartnerDashboardSettlementAmount",
  "OpenapiLpmPartnerDashboardSettlementDurationPb",
  "OpenapiLpmPartnerDashboardSettlementInstantPb",
  "OpenapiLpmPartnerDashboardSettlementSettlementConversations",
  "OpenapiLpmPartnerDashboardUpstreamConversationBody",
  "OpenapiLpmPartnerDashboardUpstreamConversationHeader",
  "OpenapiLpmPartnerDashboardUpstreamConversationInstantPb",
  "OpenapiLpmPartnerDashboardUpstreamConversationObjAttr",
  "OpenapiLpmPartnerDashboardUpstreamConversationRequestDetails",
  "OpenapiLpmPartnerDashboardUpstreamConversationResponseDetails",
  "OpenapiLpmPartnerDashboardUpstreamConversationUpstreamConversation",
  "OpenapiManageMethodFrMealVouchersSiretConecsInfo",
  "OpenapiManageMethodMyInfoEmpty",
  "OpenapiManageMethodSigmaReportingQueryDownloadLink",
  "OpenapiManagedComplianceResourceFinancialAccount",
  "OpenapiManagedComplianceResourcePlatformSettingsResourceAddress",
  "OpenapiManagedComplianceResourcePlatformSettingsResourceContactInformation",
  "OpenapiManagedComplianceResourcePlatformSettingsResourceDeclaration",
  "OpenapiManagedComplianceResourceSellerPeriodAuTransactionInformation",
  "OpenapiManagedComplianceResourceSellerPeriodAuTransactionInformationResourceAuTransactionInformation",
  "OpenapiManagedComplianceResourceSellerPeriodIdentityInformation",
  "OpenapiManagedComplianceResourceSellerPeriodIdentityInformationResourceIdNumberInformation",
  "OpenapiManagedComplianceResourceSellerPeriodTransactionInformation",
  "OpenapiManagedComplianceResourceSellerPeriodTransactionInformationResourceTransactionInformation",
  "OpenapiMandateAcssDebit",
  "OpenapiMandateAfterpayClearpay",
  "OpenapiMandateAlipay",
  "OpenapiMandateAmazonPay",
  "OpenapiMandateAuBecsDebit",
  "OpenapiMandateBacsDebit",
  "OpenapiMandateBlik",
  "OpenapiMandateCashapp",
  "OpenapiMandateCrypto",
  "OpenapiMandateDemoPay",
  "OpenapiMandateDummyAuthPush",
  "OpenapiMandateGcash",
  "OpenapiMandateGopay",
  "OpenapiMandateKakaoPay",
  "OpenapiMandateKlarna",
  "OpenapiMandateKrCard",
  "OpenapiMandateKrMarket",
  "OpenapiMandateLink",
  "OpenapiMandateMomo",
  "OpenapiMandateMultiUse",
  "OpenapiMandateNaverPay",
  "OpenapiMandateNgCard",
  "OpenapiMandateNgMarket",
  "OpenapiMandateNzBankAccount",
  "OpenapiMandateOptionsOnSessionDetailsBlik",
  "OpenapiMandateOptionsPayto",
  "OpenapiMandateOptionsUpi",
  "OpenapiMandatePaymentMethodDetails",
  "OpenapiMandatePaypal",
  "OpenapiMandatePayto",
  "OpenapiMandateRevolutPay",
  "OpenapiMandateSepaDebit",
  "OpenapiMandateSingleUse",
  "OpenapiMandateUpi",
  "OpenapiMandateUsBankAccount",
  "OpenapiMandateWechatPay",
  "OpenapiMarginsResourceMarginAmount",
  "OpenapiMarketingMerchantCustomerRetrieveMerchantCustomerMarketingPreferences",
  "OpenapiMarketingMerchantCustomerUpdatePreferencesUpdatePreferences",
  "OpenapiMassPayoutsAccountTermsOfServiceAcceptance",
  "OpenapiMerchantActivityResourceAccountActivity",
  "OpenapiMerchantBalancesV2ShimResourcesAmount",
  "OpenapiMerchantBalancesV2ShimResourcesInboundTransferExpandedInboundTransferExpansionOf",
  "OpenapiMerchantBalancesV2ShimResourcesInboundTransferFrom",
  "OpenapiMerchantBalancesV2ShimResourcesInboundTransferPaymentMethod",
  "OpenapiMerchantBalancesV2ShimResourcesInboundTransferTo",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentDeliveryOptions",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentExpandedOutboundPaymentExpansionOf",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentFailedDetails",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentFrom",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentRecipientNotification",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentReturnedDetails",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentStatusDetails",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentStatusTransitions",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentTo",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundTransferDeliveryOptions",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundTransferExpandedOutboundTransferExpansionOf",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundTransferFailedDetails",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundTransferFrom",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundTransferReturnedDetails",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundTransferStatusDetails",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundTransferStatusTransitions",
  "OpenapiMerchantBalancesV2ShimResourcesOutboundTransferTo",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditAtlasInvestment",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditBalanceTransfer",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditBankTransfer",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditCaBankAccount",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditCardSpend",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditCardSpendDispute",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditCardSpendRefund",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditCryptoWallet",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditCryptoWalletTransfer",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditEuBankAccount",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditExpandedReceivedCreditExpansionOf",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditFailedDetails",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditGbBankAccount",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditMxBankAccount",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditReturnedDetails",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditSepaBankAccount",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditStatusDetails",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditStatusTransitions",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditStripeBalancePayment",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditStripeNetworkTransfer",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditStripeNetworkTransferFrom",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedCreditUsBankAccount",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitAuthorization",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitBalanceTransfer",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitBankTransfer",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitCardSpend",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitCardTransaction",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitDisputeDetails",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitExpandedReceivedDebitExpansionOf",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitFailedDetails",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitStatusDetails",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitStatusTransitions",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitStripeBalancePayment",
  "OpenapiMerchantBalancesV2ShimResourcesReceivedDebitUsBankAccount",
  "OpenapiMerchantCaseTrigger",
  "OpenapiMerchantCaseTriggerSourceMetadata",
  "OpenapiMerchantUnauthedDisplay",
  "OpenapiMerlinResourceNavigationItem",
  "OpenapiMetadataKeysState",
  "OpenapiMexicoPostalCodeReferenceNestedZipCodeReference",
  "OpenapiMexicoPostalCodeReferenceSubarea",
  "OpenapiMigrateTo",
  "OpenapiMissionControlGetMissionMerchant",
  "OpenapiMissionControlMissionTrigger",
  "OpenapiMoneyManagementResourceAggregatedAmount",
  "OpenapiMoneyManagementResourceAvailableBalance",
  "OpenapiMoneyManagementResourceAvailableInstant",
  "OpenapiMoneyManagementResourceBalanceBreakdown",
  "OpenapiMoneyManagementResourceBalanceBreakdownByBalance",
  "OpenapiMoneyManagementResourceBalanceBreakdownByDate",
  "OpenapiMoneyManagementResourceBalanceBreakdownBySource",
  "OpenapiMoneyManagementResourceBalanceCapabilities",
  "OpenapiMoneyManagementResourceBalanceSummary",
  "OpenapiMoneyManagementResourceBalanceSummaryResourceData",
  "OpenapiMoneyManagementResourceCurrencyBalanceSummary",
  "OpenapiMoneyManagementResourceFinancialAccountBalanceResourceResourceFieldsBalanceEntry",
  "OpenapiMoneyManagementResourceFinancialAccountBalanceResourceResourceFieldsStorage",
  "OpenapiMoneyManagementResourceFuturePayoutEntry",
  "OpenapiMoneyManagementResourceFuturePayouts",
  "OpenapiMoneyManagementResourceInstantPayoutCapability",
  "OpenapiMoneyManagementResourceNetworkFeeStructure",
  "OpenapiMoneyManagementResourceOutboundPaymentNetworkFeeStructure",
  "OpenapiMoneyManagementResourcePaymentNetworkReserve",
  "OpenapiMoneyManagementResourcePaymentsBalance",
  "OpenapiMoneyManagementResourcePaymentsBalanceSummary",
  "OpenapiMoneyManagementResourcePendingBalance",
  "OpenapiMoneyManagementResourcePendingBreakdown",
  "OpenapiMoneyManagementResourceReserves",
  "OpenapiMoneyManagementResourceReservesBreakdown",
  "OpenapiMoneyManagementResourceStandardPayoutCapability",
  "OpenapiMxMobileWhatsNewResourceWhatsNew",
  "OpenapiMxMobileWhatsNewResourceWhatsNewContent",
  "OpenapiMxMobileWhatsNewResourceWhatsNewItem",
  "OpenapiNetworkOptionsCard",
  "OpenapiNetworks",
  "OpenapiNotificationEventAutomationActionResourceSendWebhookCustomEvent",
  "OpenapiNotificationEventData",
  "OpenapiNotificationEventResourceRedaction",
  "OpenapiNotificationWebhookConversationResponseHeaders",
  "OpenapiNull",
  "OpenapiOfflineAcceptance",
  "OpenapiOnboardingPolicyBulkOnboardingBulkOnboardingLegalEntity",
  "OpenapiOnboardingPolicyPubcoMerchantEligibilityForPiiExemptOnboarding",
  "OpenapiOnboardingPolicyShardedOnboardingShardedOnboardingDelete",
  "OpenapiOnboardingPolicyShardedOnboardingShardedOnboardingSubmissionEmail",
  "OpenapiOnboardingPolicyUrlOptOutIsUrlOptOutMerchant",
  "OpenapiOnboardingStartupStartupPartners",
  "OpenapiOnlineAcceptance",
  "OpenapiOpsBenefitsCardBenefits",
  "OpenapiOpsBenefitsDetailsBenefits",
  "OpenapiOpsNtaResourceNtaCorporateNumber",
  "OpenapiOpsNtaResourceNtaCorporateNumberTypeaheadResults",
  "OpenapiOpsPayoutsRoutingNumberBank",
  "OpenapiOpsPayoutsRoutingNumberBankSuggest",
  "OpenapiOrderItem",
  "OpenapiOrderReturns",
  "OpenapiOrderShipping",
  "OpenapiOrdersPaymentMethodOptionsAfterpayClearpay",
  "OpenapiOrdersV2ResourceAutomaticPaymentMethods",
  "OpenapiOrdersV2ResourceAutomaticTax",
  "OpenapiOrdersV2ResourceBillingDetails",
  "OpenapiOrdersV2ResourceCardPaymentMethodOptions",
  "OpenapiOrdersV2ResourceClientPermissions",
  "OpenapiOrdersV2ResourceFulfillment",
  "OpenapiOrdersV2ResourceFulfillmentSummary",
  "OpenapiOrdersV2ResourceGiftCardDetails",
  "OpenapiOrdersV2ResourceInventory",
  "OpenapiOrdersV2ResourceOrderLineItems",
  "OpenapiOrdersV2ResourceOrderSearchLineItems",
  "OpenapiOrdersV2ResourcePayment",
  "OpenapiOrdersV2ResourcePaymentClient",
  "OpenapiOrdersV2ResourcePaymentClientResourcePaymentSettingsClient",
  "OpenapiOrdersV2ResourcePaymentMethodOptions",
  "OpenapiOrdersV2ResourcePaymentSettings",
  "OpenapiOrdersV2ResourceShippingCost",
  "OpenapiOrdersV2ResourceShippingDetails",
  "OpenapiOrdersV2ResourceTaxDetails",
  "OpenapiOrdersV2ResourceTaxDetailsResourceTaxId",
  "OpenapiOrdersV2ResourceTotalDetails",
  "OpenapiOrdersV2ResourceTotalDetailsApiResourceBreakdown",
  "OpenapiOrdersV2ResourceTotalDetailsClientResourceBreakdownClient",
  "OpenapiOrdersV2ResourceTransferData",
  "OpenapiOutboundPaymentsPaymentMethodDetails",
  "OpenapiOutboundPaymentsPaymentMethodDetailsUsBankAccount",
  "OpenapiOutboundPaymentsPaymentMethodDetailsUsBankAccountAchSubmission",
  "OpenapiOutboundPaymentsResourceReturnedStatus",
  "OpenapiOutboundTransfersPaymentMethodDetails",
  "OpenapiOutboundTransfersPaymentMethodDetailsUsBankAccount",
  "OpenapiOutboundTransfersPaymentMethodDetailsUsBankAccountAchSubmission",
  "OpenapiOutboundTransfersResourceReturnedDetails",
  "OpenapiPackageDimensions",
  "OpenapiPaperCheckImage",
  "OpenapiPaperCheckInvoiceLines",
  "OpenapiPaperCheckInvoicePayments",
  "OpenapiPaperCheckParsedInvoice",
  "OpenapiPaperChecksResourcePrintedDetails",
  "OpenapiPaperChecksResourceReconciliationRecord",
  "OpenapiPaperChecksResourceStatusTransitions",
  "OpenapiPaymentDashboardBadgeTooltipData",
  "OpenapiPaymentDashboardDestinationChargeData",
  "OpenapiPaymentDashboardEnrichedInstrumentData",
  "OpenapiPaymentDashboardSearchPoweredListCardPresentProperties",
  "OpenapiPaymentDashboardSharedPaymentToken",
  "OpenapiPaymentData",
  "OpenapiPaymentDetailsKlarna",
  "OpenapiPaymentFlowsAmountDetailsClientResourceSurcharge",
  "OpenapiPaymentFlowsAmountDetailsClientResourceTip",
  "OpenapiPaymentFlowsAmountDetailsLineItems",
  "OpenapiPaymentFlowsAmountDetailsResourceDonation",
  "OpenapiPaymentFlowsAmountDetailsResourceError",
  "OpenapiPaymentFlowsAmountDetailsResourceLineItemsListResourceLineItemResourcePaymentMethodOptions",
  "OpenapiPaymentFlowsAmountDetailsResourceLineItemsListResourceLineItemResourceTax",
  "OpenapiPaymentFlowsAmountDetailsResourceShipping",
  "OpenapiPaymentFlowsAmountDetailsResourceTax",
  "OpenapiPaymentFlowsAutomaticPaymentMethodsPaymentIntent",
  "OpenapiPaymentFlowsAutomaticPaymentMethodsSetupIntent",
  "OpenapiPaymentFlowsExtendedAuthorization",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRental",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryAffiliate",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryDateOfBirth",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryDiscounts",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryDistance",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryDriver",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryExtraCharge",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryInsurance",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryLocation",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryTax",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryTaxItem",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryTotal",
  "OpenapiPaymentFlowsIndustryMetadataCarRentalDataResourceCarRentalSupplementaryVehicle",
  "OpenapiPaymentFlowsIndustryMetadataFleetFuelDataResourceFleetFuel",
  "OpenapiPaymentFlowsIndustryMetadataFleetFuelDataResourceFleetFuelPrimaryFuelFields",
  "OpenapiPaymentFlowsIndustryMetadataFleetFuelDataResourceFleetFuelStation",
  "OpenapiPaymentFlowsIndustryMetadataFleetFuelDataResourceFleetFuelVat",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlight",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryAffiliate",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryArrival",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryDeparture",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryDiscounts",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryExtraCharge",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryInsurance",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryPassenger",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementarySegment",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryTax",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryTaxItem",
  "OpenapiPaymentFlowsIndustryMetadataFlightDataResourceFlightSupplementaryTotal",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodging",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryAccommodation",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryAffiliate",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryDiscount",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryExtraCharge",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryGuest",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryHost",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryInsurance",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryTax",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryTaxItem",
  "OpenapiPaymentFlowsIndustryMetadataLodgingDataResourceLodgingSupplementaryTotal",
  "OpenapiPaymentFlowsInstallmentOptions",
  "OpenapiPaymentFlowsNextActionRedirectToUrlQrCode",
  "OpenapiPaymentFlowsOvercapture",
  "OpenapiPaymentFlowsPaymentDetails",
  "OpenapiPaymentFlowsPaymentDetailsResourceAffiliate",
  "OpenapiPaymentFlowsPaymentDetailsResourceBenefit",
  "OpenapiPaymentFlowsPaymentDetailsResourceBillingInterval",
  "OpenapiPaymentFlowsPaymentDetailsResourceCarRental",
  "OpenapiPaymentFlowsPaymentDetailsResourceCarRentalDistance",
  "OpenapiPaymentFlowsPaymentDetailsResourceCarRentalDriver",
  "OpenapiPaymentFlowsPaymentDetailsResourceDelivery",
  "OpenapiPaymentFlowsPaymentDetailsResourceDeliveryRecipient",
  "OpenapiPaymentFlowsPaymentDetailsResourceEvent",
  "OpenapiPaymentFlowsPaymentDetailsResourceFlight",
  "OpenapiPaymentFlowsPaymentDetailsResourceFlightPassenger",
  "OpenapiPaymentFlowsPaymentDetailsResourceFlightSegment",
  "OpenapiPaymentFlowsPaymentDetailsResourceFrMealVoucher",
  "OpenapiPaymentFlowsPaymentDetailsResourceHealthcare",
  "OpenapiPaymentFlowsPaymentDetailsResourceIias",
  "OpenapiPaymentFlowsPaymentDetailsResourceLodging",
  "OpenapiPaymentFlowsPaymentDetailsResourceLodgingPassenger",
  "OpenapiPaymentFlowsPaymentDetailsResourceMoneyServices",
  "OpenapiPaymentFlowsPaymentDetailsResourceMoneyServicesAccountFunding",
  "OpenapiPaymentFlowsPaymentDetailsResourceMoneyServicesAddress",
  "OpenapiPaymentFlowsPaymentDetailsResourceMoneyServicesDateOfBirth",
  "OpenapiPaymentFlowsPaymentDetailsResourceMoneyServicesPartyDetails",
  "OpenapiPaymentFlowsPaymentDetailsResourceQualifiedAmountDetails",
  "OpenapiPaymentFlowsPaymentDetailsResourceSubscription",
  "OpenapiPaymentFlowsPaymentIntentAsyncWorkflows",
  "OpenapiPaymentFlowsPaymentIntentAsyncWorkflowsResourceInputs",
  "OpenapiPaymentFlowsPaymentIntentAsyncWorkflowsResourceInputsResourceTax",
  "OpenapiPaymentFlowsPaymentIntentPresentmentDetails",
  "OpenapiPaymentFlowsPaymentIntentTotalDetails",
  "OpenapiPaymentFlowsPaymentIntentTotalDetailsResourceBreakdown",
  "OpenapiPaymentFlowsPaymentMethodResourceRedaction",
  "OpenapiPaymentFlowsPrivatePaymentMethodsAffirmDetailsResourceDecrementalAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsAffirmDetailsResourceMulticapture",
  "OpenapiPaymentFlowsPrivatePaymentMethodsAlipay",
  "OpenapiPaymentFlowsPrivatePaymentMethodsAlipayDetails",
  "OpenapiPaymentFlowsPrivatePaymentMethodsBillieDeprecatedDetailsResourceDecrementalAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsBillieDeprecatedDetailsResourceIncrementalAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsBilliePaymentMethodOptionsResourceCompanyDetails",
  "OpenapiPaymentFlowsPrivatePaymentMethodsBilliePaymentMethodOptionsResourceCompanyDetailsResourceCompanyDetailsRegisteredAddress",
  "OpenapiPaymentFlowsPrivatePaymentMethodsBizumSetupAttemptDetails",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesAccountFundingAccountFunding",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesDebtRepaymentDebtRepayment",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesDecrementalAuthorizationDecrementalAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesExtendedAuthorizationExtendedAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesFlexibleExtendedAuthorizationFlexibleExtendedAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesFundingTransactionFundingTransaction",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesIncrementalAuthorizationIncrementalAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesOvercaptureOvercapture",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesPartialAuthorizationPartialAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceEnterpriseFeaturesReauthorizationReauthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardDetailsApiResourceMulticapture",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardLineItemFleetData",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardOptionsStatementDetails",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardOptionsStatementDetailsResourceAddress",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardPaymentIntentAmountDetailsLineItemPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardPresentAmountDetailsLineItemPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardPresentCommonWallet",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardPresentDetailsResourceEnterpriseFeaturesFlexibleExtendedAuthorizationFlexibleExtendedAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardPresentDetailsResourceEnterpriseFeaturesFundingTransactionFundingTransaction",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardPresentDetailsResourceEnterpriseFeaturesMulticaptureMulticapture",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardPresentDetailsResourceEnterpriseFeaturesReauthorizationReauthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCardPresentDynamicCurrencyConversion",
  "OpenapiPaymentFlowsPrivatePaymentMethodsCashappDetailsResourceIncrementalAuthorization",
  "OpenapiPaymentFlowsPrivatePaymentMethodsDummyAuthPushDetailsResourceMulticapture",
  "OpenapiPaymentFlowsPrivatePaymentMethodsDummyAuthPushPaymentIntentAmountDetailsLineItemPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsDummyPassthroughCardPaymentMethodResourceInternalCard",
  "OpenapiPaymentFlowsPrivatePaymentMethodsDummyPassthroughCardSharedChecks",
  "OpenapiPaymentFlowsPrivatePaymentMethodsFinancialConnectionsCommonLinkedAccountOptionsFilters",
  "OpenapiPaymentFlowsPrivatePaymentMethodsFinancialConnectionsCommonLinkedAccountOptionsManualEntry",
  "OpenapiPaymentFlowsPrivatePaymentMethodsGiftCardDetailsResourceBalance",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKakaoPayPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaDob",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaLineItemResourceTax",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaPaymentDetailsResourceAffiliate",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaPaymentDetailsResourceMarketplaceAccount",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaPaymentDetailsResourceMarketplaceBuyerInfo",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaPaymentDetailsResourceVoucher",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaPaymentIntentAmountDetailsLineItemPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaSupplementaryPurchaseDataBusReservationDetailsBusReservationDetails",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaSupplementaryPurchaseDataCustomerCustomer",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaSupplementaryPurchaseDataEventReservationDetailsEventReservationDetails",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaSupplementaryPurchaseDataFerryReservationDetailsFerryReservationDetails",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaSupplementaryPurchaseDataMarketplaceSellersMarketplaceSeller",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaSupplementaryPurchaseDataRoundTripReservationDetailsRoundTripReservationDetails",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaSupplementaryPurchaseDataTrainReservationDetailsTrainReservationDetails",
  "OpenapiPaymentFlowsPrivatePaymentMethodsKlarnaSupplementaryPurchaseDataVouchersVoucher",
  "OpenapiPaymentFlowsPrivatePaymentMethodsLinkDetailsResourceMulticapture",
  "OpenapiPaymentFlowsPrivatePaymentMethodsLinkInstantDebitsSellerInfoResourceMetrics",
  "OpenapiPaymentFlowsPrivatePaymentMethodsLinkPaymentIntentAmountDetailsLineItemPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsLinkPaymentIntentAmountDetailsLineItemPaymentMethodOptionsResourceInstantDebits",
  "OpenapiPaymentFlowsPrivatePaymentMethodsNaverPayPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsNgBankPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsNgBankTransferPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsNgCardPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsNgUssdPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsPaycoPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsPaypalAmountDetailsLineItemPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsPaypalLineItemResourceTax",
  "OpenapiPaymentFlowsPrivatePaymentMethodsRechnungDob",
  "OpenapiPaymentFlowsPrivatePaymentMethodsSamsungPayPaymentMethodOptions",
  "OpenapiPaymentFlowsPrivatePaymentMethodsSatispaySetupAttemptDetails",
  "OpenapiPaymentFlowsSetupIntentOutcome",
  "OpenapiPaymentFlowsSetupIntentRadarResults",
  "OpenapiPaymentFlowsSetupIntentResourceRedaction",
  "OpenapiPaymentFlowsSetupIntentSetupDetails",
  "OpenapiPaymentFlowsSetupIntentSetupDetailsResourceBenefit",
  "OpenapiPaymentFlowsSetupIntentSetupDetailsResourceFrMealVoucher",
  "OpenapiPaymentIntentCardProcessing",
  "OpenapiPaymentIntentCharges",
  "OpenapiPaymentIntentCryptoCollectDepositDetails",
  "OpenapiPaymentIntentCryptoDisplayDetails",
  "OpenapiPaymentIntentCryptoSendDeposit",
  "OpenapiPaymentIntentLineItems",
  "OpenapiPaymentIntentLineItemsCaptured",
  "OpenapiPaymentIntentNextAction",
  "OpenapiPaymentIntentNextActionAlipayHandleRedirect",
  "OpenapiPaymentIntentNextActionAwaitAuthorization",
  "OpenapiPaymentIntentNextActionBancontactHandleRedirect",
  "OpenapiPaymentIntentNextActionBoleto",
  "OpenapiPaymentIntentNextActionCardAwaitNotification",
  "OpenapiPaymentIntentNextActionDisplayBankTransferInstructions",
  "OpenapiPaymentIntentNextActionDisplayMultibancoDetails",
  "OpenapiPaymentIntentNextActionDisplayOxxoDetails",
  "OpenapiPaymentIntentNextActionForwardNextAction",
  "OpenapiPaymentIntentNextActionKlarnaDisplayQrCode",
  "OpenapiPaymentIntentNextActionKonbini",
  "OpenapiPaymentIntentNextActionKonbiniFamilymart",
  "OpenapiPaymentIntentNextActionKonbiniLawson",
  "OpenapiPaymentIntentNextActionKonbiniMinistop",
  "OpenapiPaymentIntentNextActionKonbiniSeicomart",
  "OpenapiPaymentIntentNextActionKonbiniSevenEleven",
  "OpenapiPaymentIntentNextActionKonbiniStores",
  "OpenapiPaymentIntentNextActionPaynowDisplayQrCode",
  "OpenapiPaymentIntentNextActionPixDisplayQrCode",
  "OpenapiPaymentIntentNextActionPromptpayDisplayQrCode",
  "OpenapiPaymentIntentNextActionRedirectToUrl",
  "OpenapiPaymentIntentNextActionSharedPaymentTokenAction",
  "OpenapiPaymentIntentNextActionSwishAwaitAuthorization",
  "OpenapiPaymentIntentNextActionThirdPartyHandleRedirectOrDisplayQrCode",
  "OpenapiPaymentIntentNextActionUpiAwaitNotification",
  "OpenapiPaymentIntentNextActionUpiRedirectToAppThenWait",
  "OpenapiPaymentIntentNextActionVerifyWithMicrodeposits",
  "OpenapiPaymentIntentNextActionWechatPayDisplayQrCode",
  "OpenapiPaymentIntentNextActionWechatPayRedirectToAndroidApp",
  "OpenapiPaymentIntentNextActionWechatPayRedirectToIosApp",
  "OpenapiPaymentIntentPaymentMethodOptions",
  "OpenapiPaymentIntentPaymentMethodOptionsAcssDebit",
  "OpenapiPaymentIntentPaymentMethodOptionsAuBecsDebit",
  "OpenapiPaymentIntentPaymentMethodOptionsBlik",
  "OpenapiPaymentIntentPaymentMethodOptionsCard",
  "OpenapiPaymentIntentPaymentMethodOptionsCardNetworkOptions",
  "OpenapiPaymentIntentPaymentMethodOptionsCardNetworkOptionsAmex",
  "OpenapiPaymentIntentPaymentMethodOptionsClient",
  "OpenapiPaymentIntentPaymentMethodOptionsEps",
  "OpenapiPaymentIntentPaymentMethodOptionsLink",
  "OpenapiPaymentIntentPaymentMethodOptionsMandateOptionsAcssDebit",
  "OpenapiPaymentIntentPaymentMethodOptionsMandateOptionsBacsDebit",
  "OpenapiPaymentIntentPaymentMethodOptionsMandateOptionsBlik",
  "OpenapiPaymentIntentPaymentMethodOptionsMandateOptionsPayto",
  "OpenapiPaymentIntentPaymentMethodOptionsMandateOptionsSepaDebit",
  "OpenapiPaymentIntentPaymentMethodOptionsMobilepay",
  "OpenapiPaymentIntentPaymentMethodOptionsNzBankAccount",
  "OpenapiPaymentIntentPaymentMethodOptionsPayto",
  "OpenapiPaymentIntentPaymentMethodOptionsRechnung",
  "OpenapiPaymentIntentPaymentMethodOptionsSepaDebit",
  "OpenapiPaymentIntentPaymentMethodOptionsStripeBalance",
  "OpenapiPaymentIntentPaymentMethodOptionsSwish",
  "OpenapiPaymentIntentPaymentMethodOptionsUsBankAccount",
  "OpenapiPaymentIntentPaymentMethodOptionsVipps",
  "OpenapiPaymentIntentPaymentsOrchestration",
  "OpenapiPaymentIntentProcessing",
  "OpenapiPaymentIntentProcessingCustomerNotification",
  "OpenapiPaymentIntentTerminalMerchantCharges",
  "OpenapiPaymentIntentTerminalMerchantLineItems",
  "OpenapiPaymentIntentTerminalMerchantLineItemsCaptured",
  "OpenapiPaymentIntentTransitBalance",
  "OpenapiPaymentIntentTypeSpecificPaymentMethodOptionsClient",
  "OpenapiPaymentLinkLineItems",
  "OpenapiPaymentLinksResourceAfterCompletion",
  "OpenapiPaymentLinksResourceAutomaticSurcharge",
  "OpenapiPaymentLinksResourceAutomaticTax",
  "OpenapiPaymentLinksResourceBusinessName",
  "OpenapiPaymentLinksResourceCardPaymentMethodOptions",
  "OpenapiPaymentLinksResourceCardRestrictions",
  "OpenapiPaymentLinksResourceCompletedSessions",
  "OpenapiPaymentLinksResourceCompletionBehaviorConfirmationPage",
  "OpenapiPaymentLinksResourceCompletionBehaviorRedirect",
  "OpenapiPaymentLinksResourceComputed",
  "OpenapiPaymentLinksResourceCopiedLineItems",
  "OpenapiPaymentLinksResourceCustomFieldsDropdown",
  "OpenapiPaymentLinksResourceCustomFieldsDropdownOption",
  "OpenapiPaymentLinksResourceCustomFieldsLabel",
  "OpenapiPaymentLinksResourceCustomFieldsNumeric",
  "OpenapiPaymentLinksResourceCustomFieldsText",
  "OpenapiPaymentLinksResourceCustomText",
  "OpenapiPaymentLinksResourceCustomTextPosition",
  "OpenapiPaymentLinksResourceIndividualName",
  "OpenapiPaymentLinksResourceInvoiceCreation",
  "OpenapiPaymentLinksResourceInvoiceSettings",
  "OpenapiPaymentLinksResourceNameCollection",
  "OpenapiPaymentLinksResourceOptionalItem",
  "OpenapiPaymentLinksResourceOptionalItemAdjustableQuantity",
  "OpenapiPaymentLinksResourcePaymentIntentData",
  "OpenapiPaymentLinksResourcePaymentMethodOptions",
  "OpenapiPaymentLinksResourcePaymentMethodReuseAgreement",
  "OpenapiPaymentLinksResourcePhoneNumberCollection",
  "OpenapiPaymentLinksResourceRestrictions",
  "OpenapiPaymentLinksResourceShippingAddressCollection",
  "OpenapiPaymentLinksResourceShippingOption",
  "OpenapiPaymentLinksResourceSubscriptionData",
  "OpenapiPaymentLinksResourceSubscriptionDataInvoiceSettings",
  "OpenapiPaymentLinksResourceTaxIdCollection",
  "OpenapiPaymentLinksResourceTransferData",
  "OpenapiPaymentMethodAcssDebit",
  "OpenapiPaymentMethodAffirm",
  "OpenapiPaymentMethodAfterpayClearpay",
  "OpenapiPaymentMethodAlma",
  "OpenapiPaymentMethodAmazonPay",
  "OpenapiPaymentMethodAuBecsDebit",
  "OpenapiPaymentMethodBacsDebit",
  "OpenapiPaymentMethodBancontact",
  "OpenapiPaymentMethodBillie",
  "OpenapiPaymentMethodBizum",
  "OpenapiPaymentMethodBlik",
  "OpenapiPaymentMethodBoleto",
  "OpenapiPaymentMethodCapchasePay",
  "OpenapiPaymentMethodCard",
  "OpenapiPaymentMethodCardCardArt",
  "OpenapiPaymentMethodCardCardArtImage",
  "OpenapiPaymentMethodCardChecks",
  "OpenapiPaymentMethodCardFundingOptions",
  "OpenapiPaymentMethodCardGeneratedCard",
  "OpenapiPaymentMethodCardNetworkToken",
  "OpenapiPaymentMethodCardPresentNetworks",
  "OpenapiPaymentMethodCardWallet",
  "OpenapiPaymentMethodCardWalletAmexExpressCheckout",
  "OpenapiPaymentMethodCardWalletApplePay",
  "OpenapiPaymentMethodCardWalletGooglePay",
  "OpenapiPaymentMethodCardWalletLink",
  "OpenapiPaymentMethodCardWalletMasterpass",
  "OpenapiPaymentMethodCardWalletSamsungPay",
  "OpenapiPaymentMethodCardWalletVisaCheckout",
  "OpenapiPaymentMethodCashapp",
  "OpenapiPaymentMethodCheckScan",
  "OpenapiPaymentMethodClickToPay",
  "OpenapiPaymentMethodConfigResourceDisplayPreference",
  "OpenapiPaymentMethodConfigResourcePaymentMethodProperties",
  "OpenapiPaymentMethodCrypto",
  "OpenapiPaymentMethodCustom",
  "OpenapiPaymentMethodCustomerBalance",
  "OpenapiPaymentMethodDemoPay",
  "OpenapiPaymentMethodDetails",
  "OpenapiPaymentMethodDetailsAchCreditTransfer",
  "OpenapiPaymentMethodDetailsAchDebit",
  "OpenapiPaymentMethodDetailsAcssDebit",
  "OpenapiPaymentMethodDetailsAffirm",
  "OpenapiPaymentMethodDetailsAfterpayClearpay",
  "OpenapiPaymentMethodDetailsAlma",
  "OpenapiPaymentMethodDetailsAmazonPay",
  "OpenapiPaymentMethodDetailsAuBecsDebit",
  "OpenapiPaymentMethodDetailsBacsDebit",
  "OpenapiPaymentMethodDetailsBancontact",
  "OpenapiPaymentMethodDetailsBillie",
  "OpenapiPaymentMethodDetailsBitcoin",
  "OpenapiPaymentMethodDetailsBizum",
  "OpenapiPaymentMethodDetailsBlik",
  "OpenapiPaymentMethodDetailsBoleto",
  "OpenapiPaymentMethodDetailsCapchasePay",
  "OpenapiPaymentMethodDetailsCard",
  "OpenapiPaymentMethodDetailsCardChecks",
  "OpenapiPaymentMethodDetailsCardInstallments",
  "OpenapiPaymentMethodDetailsCardInstallmentsPlan",
  "OpenapiPaymentMethodDetailsCardNetworkToken",
  "OpenapiPaymentMethodDetailsCardPresent",
  "OpenapiPaymentMethodDetailsCardPresentOffline",
  "OpenapiPaymentMethodDetailsCardPresentReceipt",
  "OpenapiPaymentMethodDetailsCardWallet",
  "OpenapiPaymentMethodDetailsCardWalletAmexExpressCheckout",
  "OpenapiPaymentMethodDetailsCardWalletApplePay",
  "OpenapiPaymentMethodDetailsCardWalletGooglePay",
  "OpenapiPaymentMethodDetailsCardWalletLink",
  "OpenapiPaymentMethodDetailsCardWalletMasterpass",
  "OpenapiPaymentMethodDetailsCardWalletSamsungPay",
  "OpenapiPaymentMethodDetailsCardWalletVisaCheckout",
  "OpenapiPaymentMethodDetailsCashapp",
  "OpenapiPaymentMethodDetailsCheckScan",
  "OpenapiPaymentMethodDetailsClickToPay",
  "OpenapiPaymentMethodDetailsCrypto",
  "OpenapiPaymentMethodDetailsCustomerBalance",
  "OpenapiPaymentMethodDetailsDebtRepayment",
  "OpenapiPaymentMethodDetailsDemoPay",
  "OpenapiPaymentMethodDetailsDuitnow",
  "OpenapiPaymentMethodDetailsDummyAuthPush",
  "OpenapiPaymentMethodDetailsDummyPassthroughCard",
  "OpenapiPaymentMethodDetailsEdenred",
  "OpenapiPaymentMethodDetailsEps",
  "OpenapiPaymentMethodDetailsFpx",
  "OpenapiPaymentMethodDetailsGbpCreditTransfer",
  "OpenapiPaymentMethodDetailsGcash",
  "OpenapiPaymentMethodDetailsGetbalance",
  "OpenapiPaymentMethodDetailsGiftCard",
  "OpenapiPaymentMethodDetailsGiropay",
  "OpenapiPaymentMethodDetailsGopay",
  "OpenapiPaymentMethodDetailsGrabpay",
  "OpenapiPaymentMethodDetailsIdBankTransfer",
  "OpenapiPaymentMethodDetailsIdCreditTransfer",
  "OpenapiPaymentMethodDetailsIdeal",
  "OpenapiPaymentMethodDetailsInteracPresent",
  "OpenapiPaymentMethodDetailsInteracPresentReceipt",
  "OpenapiPaymentMethodDetailsJpCreditTransfer",
  "OpenapiPaymentMethodDetailsKakaoPay",
  "OpenapiPaymentMethodDetailsKlarna",
  "OpenapiPaymentMethodDetailsKlarnaWallet",
  "OpenapiPaymentMethodDetailsKnet",
  "OpenapiPaymentMethodDetailsKonbini",
  "OpenapiPaymentMethodDetailsKonbiniStore",
  "OpenapiPaymentMethodDetailsKrCard",
  "OpenapiPaymentMethodDetailsKrMarket",
  "OpenapiPaymentMethodDetailsKriya",
  "OpenapiPaymentMethodDetailsLink",
  "OpenapiPaymentMethodDetailsMbWay",
  "OpenapiPaymentMethodDetailsMobilepay",
  "OpenapiPaymentMethodDetailsMomo",
  "OpenapiPaymentMethodDetailsMondu",
  "OpenapiPaymentMethodDetailsMultibanco",
  "OpenapiPaymentMethodDetailsNaverPay",
  "OpenapiPaymentMethodDetailsNetbanking",
  "OpenapiPaymentMethodDetailsNgBank",
  "OpenapiPaymentMethodDetailsNgBankTransfer",
  "OpenapiPaymentMethodDetailsNgCard",
  "OpenapiPaymentMethodDetailsNgMarket",
  "OpenapiPaymentMethodDetailsNgUssd",
  "OpenapiPaymentMethodDetailsNgWallet",
  "OpenapiPaymentMethodDetailsNzBankAccount",
  "OpenapiPaymentMethodDetailsOctopus",
  "OpenapiPaymentMethodDetailsOxxo",
  "OpenapiPaymentMethodDetailsP24",
  "OpenapiPaymentMethodDetailsPaperCheck",
  "OpenapiPaymentMethodDetailsPassthroughCard",
  "OpenapiPaymentMethodDetailsPayByBank",
  "OpenapiPaymentMethodDetailsPayByBankSortCode",
  "OpenapiPaymentMethodDetailsPayco",
  "OpenapiPaymentMethodDetailsPaymentRecordAcssDebit",
  "OpenapiPaymentMethodDetailsPaymentRecordAffirm",
  "OpenapiPaymentMethodDetailsPaymentRecordAfterpayClearpay",
  "OpenapiPaymentMethodDetailsPaymentRecordAlma",
  "OpenapiPaymentMethodDetailsPaymentRecordAmazonPay",
  "OpenapiPaymentMethodDetailsPaymentRecordBancontact",
  "OpenapiPaymentMethodDetailsPaymentRecordBillie",
  "OpenapiPaymentMethodDetailsPaymentRecordBizum",
  "OpenapiPaymentMethodDetailsPaymentRecordBlik",
  "OpenapiPaymentMethodDetailsPaymentRecordBoleto",
  "OpenapiPaymentMethodDetailsPaymentRecordCapchasePay",
  "OpenapiPaymentMethodDetailsPaymentRecordCashapp",
  "OpenapiPaymentMethodDetailsPaymentRecordDummyAuthPush",
  "OpenapiPaymentMethodDetailsPaymentRecordEdenred",
  "OpenapiPaymentMethodDetailsPaymentRecordEps",
  "OpenapiPaymentMethodDetailsPaymentRecordGetbalance",
  "OpenapiPaymentMethodDetailsPaymentRecordGiftCard",
  "OpenapiPaymentMethodDetailsPaymentRecordGiropay",
  "OpenapiPaymentMethodDetailsPaymentRecordGopay",
  "OpenapiPaymentMethodDetailsPaymentRecordIdBankTransfer",
  "OpenapiPaymentMethodDetailsPaymentRecordIdeal",
  "OpenapiPaymentMethodDetailsPaymentRecordKakaoPay",
  "OpenapiPaymentMethodDetailsPaymentRecordKlarna",
  "OpenapiPaymentMethodDetailsPaymentRecordKnet",
  "OpenapiPaymentMethodDetailsPaymentRecordKonbini",
  "OpenapiPaymentMethodDetailsPaymentRecordKrMarket",
  "OpenapiPaymentMethodDetailsPaymentRecordKriya",
  "OpenapiPaymentMethodDetailsPaymentRecordMbWay",
  "OpenapiPaymentMethodDetailsPaymentRecordMobilepay",
  "OpenapiPaymentMethodDetailsPaymentRecordMondu",
  "OpenapiPaymentMethodDetailsPaymentRecordMultibanco",
  "OpenapiPaymentMethodDetailsPaymentRecordNaverPay",
  "OpenapiPaymentMethodDetailsPaymentRecordNetbanking",
  "OpenapiPaymentMethodDetailsPaymentRecordNgBank",
  "OpenapiPaymentMethodDetailsPaymentRecordNgBankTransfer",
  "OpenapiPaymentMethodDetailsPaymentRecordNgCard",
  "OpenapiPaymentMethodDetailsPaymentRecordNgMarket",
  "OpenapiPaymentMethodDetailsPaymentRecordNgWallet",
  "OpenapiPaymentMethodDetailsPaymentRecordOxxo",
  "OpenapiPaymentMethodDetailsPaymentRecordP24",
  "OpenapiPaymentMethodDetailsPaymentRecordPayByBank",
  "OpenapiPaymentMethodDetailsPaymentRecordPayco",
  "OpenapiPaymentMethodDetailsPaymentRecordPaynow",
  "OpenapiPaymentMethodDetailsPaymentRecordPaypay",
  "OpenapiPaymentMethodDetailsPaymentRecordPix",
  "OpenapiPaymentMethodDetailsPaymentRecordPromptpay",
  "OpenapiPaymentMethodDetailsPaymentRecordQris",
  "OpenapiPaymentMethodDetailsPaymentRecordRechnung",
  "OpenapiPaymentMethodDetailsPaymentRecordSamsungPay",
  "OpenapiPaymentMethodDetailsPaymentRecordSepaDebit",
  "OpenapiPaymentMethodDetailsPaymentRecordShopeepay",
  "OpenapiPaymentMethodDetailsPaymentRecordSofort",
  "OpenapiPaymentMethodDetailsPaymentRecordSouthKoreaMarket",
  "OpenapiPaymentMethodDetailsPaymentRecordSwish",
  "OpenapiPaymentMethodDetailsPaymentRecordTestPay",
  "OpenapiPaymentMethodDetailsPaymentRecordTwint",
  "OpenapiPaymentMethodDetailsPaymentRecordUpi",
  "OpenapiPaymentMethodDetailsPaymentRecordUsBankAccount",
  "OpenapiPaymentMethodDetailsPaymentRecordVipps",
  "OpenapiPaymentMethodDetailsPaymentRecordWechatPay",
  "OpenapiPaymentMethodDetailsPaymentRecordWero",
  "OpenapiPaymentMethodDetailsPaymentRecordZip",
  "OpenapiPaymentMethodDetailsPaynow",
  "OpenapiPaymentMethodDetailsPaypal",
  "OpenapiPaymentMethodDetailsPaypay",
  "OpenapiPaymentMethodDetailsPayto",
  "OpenapiPaymentMethodDetailsPix",
  "OpenapiPaymentMethodDetailsPromptpay",
  "OpenapiPaymentMethodDetailsQris",
  "OpenapiPaymentMethodDetailsRechnung",
  "OpenapiPaymentMethodDetailsRevolutPay",
  "OpenapiPaymentMethodDetailsSamsungPay",
  "OpenapiPaymentMethodDetailsSatispay",
  "OpenapiPaymentMethodDetailsScalapay",
  "OpenapiPaymentMethodDetailsSepaCreditTransfer",
  "OpenapiPaymentMethodDetailsSepaDebit",
  "OpenapiPaymentMethodDetailsSequra",
  "OpenapiPaymentMethodDetailsShopPay",
  "OpenapiPaymentMethodDetailsShopeepay",
  "OpenapiPaymentMethodDetailsSofort",
  "OpenapiPaymentMethodDetailsSouthKoreaMarket",
  "OpenapiPaymentMethodDetailsStripeAccount",
  "OpenapiPaymentMethodDetailsStripeBalance",
  "OpenapiPaymentMethodDetailsSunbit",
  "OpenapiPaymentMethodDetailsSwish",
  "OpenapiPaymentMethodDetailsTestPay",
  "OpenapiPaymentMethodDetailsTwint",
  "OpenapiPaymentMethodDetailsUnimplemented",
  "OpenapiPaymentMethodDetailsUpi",
  "OpenapiPaymentMethodDetailsUsBankAccount",
  "OpenapiPaymentMethodDetailsVipps",
  "OpenapiPaymentMethodDetailsWechat",
  "OpenapiPaymentMethodDetailsWechatPay",
  "OpenapiPaymentMethodDetailsWero",
  "OpenapiPaymentMethodDetailsZip",
  "OpenapiPaymentMethodDomainResourcePaymentMethodStatus",
  "OpenapiPaymentMethodDomainResourcePaymentMethodStatusDetails",
  "OpenapiPaymentMethodDuitnow",
  "OpenapiPaymentMethodDummyAuthPush",
  "OpenapiPaymentMethodDummyPassthroughCard",
  "OpenapiPaymentMethodEdenred",
  "OpenapiPaymentMethodEps",
  "OpenapiPaymentMethodFpx",
  "OpenapiPaymentMethodGcash",
  "OpenapiPaymentMethodGetbalance",
  "OpenapiPaymentMethodGiftCard",
  "OpenapiPaymentMethodGiropay",
  "OpenapiPaymentMethodGopay",
  "OpenapiPaymentMethodGrabpay",
  "OpenapiPaymentMethodIdBankTransfer",
  "OpenapiPaymentMethodIdCreditTransfer",
  "OpenapiPaymentMethodIdeal",
  "OpenapiPaymentMethodKakaoPay",
  "OpenapiPaymentMethodKlarna",
  "OpenapiPaymentMethodKnet",
  "OpenapiPaymentMethodKonbini",
  "OpenapiPaymentMethodKrCard",
  "OpenapiPaymentMethodKrMarket",
  "OpenapiPaymentMethodKriya",
  "OpenapiPaymentMethodLink",
  "OpenapiPaymentMethodMbWay",
  "OpenapiPaymentMethodMobilepay",
  "OpenapiPaymentMethodMomo",
  "OpenapiPaymentMethodMondu",
  "OpenapiPaymentMethodMultibanco",
  "OpenapiPaymentMethodNaverPay",
  "OpenapiPaymentMethodNetbanking",
  "OpenapiPaymentMethodNgBank",
  "OpenapiPaymentMethodNgBankTransfer",
  "OpenapiPaymentMethodNgCard",
  "OpenapiPaymentMethodNgMarket",
  "OpenapiPaymentMethodNgUssd",
  "OpenapiPaymentMethodNgWallet",
  "OpenapiPaymentMethodNzBankAccount",
  "OpenapiPaymentMethodOctopus",
  "OpenapiPaymentMethodOptionsAffirm",
  "OpenapiPaymentMethodOptionsAffirmPurchaseDetails",
  "OpenapiPaymentMethodOptionsAfterpayClearpay",
  "OpenapiPaymentMethodOptionsAlipay",
  "OpenapiPaymentMethodOptionsAlma",
  "OpenapiPaymentMethodOptionsAmazonPay",
  "OpenapiPaymentMethodOptionsBancontact",
  "OpenapiPaymentMethodOptionsBillie",
  "OpenapiPaymentMethodOptionsBizum",
  "OpenapiPaymentMethodOptionsBoleto",
  "OpenapiPaymentMethodOptionsBuyNowPayLater",
  "OpenapiPaymentMethodOptionsCardInstallments",
  "OpenapiPaymentMethodOptionsCardMandateOptions",
  "OpenapiPaymentMethodOptionsCardPresent",
  "OpenapiPaymentMethodOptionsCardPresentDynamicCurrencyConversion",
  "OpenapiPaymentMethodOptionsCardPresentRouting",
  "OpenapiPaymentMethodOptionsCardPresentSurcharge",
  "OpenapiPaymentMethodOptionsCardSurcharge",
  "OpenapiPaymentMethodOptionsClickToPay",
  "OpenapiPaymentMethodOptionsCrypto",
  "OpenapiPaymentMethodOptionsCustomerBalance",
  "OpenapiPaymentMethodOptionsCustomerBalanceBankTransfer",
  "OpenapiPaymentMethodOptionsCustomerBalanceEuBankAccount",
  "OpenapiPaymentMethodOptionsCustomerBalanceIdBban",
  "OpenapiPaymentMethodOptionsDemoPay",
  "OpenapiPaymentMethodOptionsDummyAuthPush",
  "OpenapiPaymentMethodOptionsDummyPassthroughCard",
  "OpenapiPaymentMethodOptionsFpx",
  "OpenapiPaymentMethodOptionsGcash",
  "OpenapiPaymentMethodOptionsGetbalance",
  "OpenapiPaymentMethodOptionsGiropay",
  "OpenapiPaymentMethodOptionsGopay",
  "OpenapiPaymentMethodOptionsGrabpay",
  "OpenapiPaymentMethodOptionsIdBankTransfer",
  "OpenapiPaymentMethodOptionsIdeal",
  "OpenapiPaymentMethodOptionsInteracPresent",
  "OpenapiPaymentMethodOptionsKlarna",
  "OpenapiPaymentMethodOptionsKnet",
  "OpenapiPaymentMethodOptionsKonbini",
  "OpenapiPaymentMethodOptionsKrCard",
  "OpenapiPaymentMethodOptionsKrMarket",
  "OpenapiPaymentMethodOptionsMandateOptionsBizum",
  "OpenapiPaymentMethodOptionsMandateOptionsPix",
  "OpenapiPaymentMethodOptionsMandateOptionsStripeBalance",
  "OpenapiPaymentMethodOptionsMandateOptionsUpi",
  "OpenapiPaymentMethodOptionsMbWay",
  "OpenapiPaymentMethodOptionsMomo",
  "OpenapiPaymentMethodOptionsMondu",
  "OpenapiPaymentMethodOptionsMultibanco",
  "OpenapiPaymentMethodOptionsNgMarket",
  "OpenapiPaymentMethodOptionsOxxo",
  "OpenapiPaymentMethodOptionsP24",
  "OpenapiPaymentMethodOptionsPayByBank",
  "OpenapiPaymentMethodOptionsPaynow",
  "OpenapiPaymentMethodOptionsPaypal",
  "OpenapiPaymentMethodOptionsPaypay",
  "OpenapiPaymentMethodOptionsPix",
  "OpenapiPaymentMethodOptionsPromptpay",
  "OpenapiPaymentMethodOptionsRevolutPay",
  "OpenapiPaymentMethodOptionsSatispay",
  "OpenapiPaymentMethodOptionsScalapay",
  "OpenapiPaymentMethodOptionsShopeepay",
  "OpenapiPaymentMethodOptionsSofort",
  "OpenapiPaymentMethodOptionsTwint",
  "OpenapiPaymentMethodOptionsUpi",
  "OpenapiPaymentMethodOptionsUsBankAccountMandateOptions",
  "OpenapiPaymentMethodOptionsWechatPay",
  "OpenapiPaymentMethodOptionsZip",
  "OpenapiPaymentMethodOxxo",
  "OpenapiPaymentMethodP24",
  "OpenapiPaymentMethodPaperCheck",
  "OpenapiPaymentMethodPayByBank",
  "OpenapiPaymentMethodPayco",
  "OpenapiPaymentMethodPaynow",
  "OpenapiPaymentMethodPaypal",
  "OpenapiPaymentMethodPaypay",
  "OpenapiPaymentMethodPayto",
  "OpenapiPaymentMethodPix",
  "OpenapiPaymentMethodPromptpay",
  "OpenapiPaymentMethodQris",
  "OpenapiPaymentMethodRechnung",
  "OpenapiPaymentMethodRevolutPay",
  "OpenapiPaymentMethodSamsungPay",
  "OpenapiPaymentMethodSatispay",
  "OpenapiPaymentMethodScalapay",
  "OpenapiPaymentMethodSepaDebit",
  "OpenapiPaymentMethodSequra",
  "OpenapiPaymentMethodShopPay",
  "OpenapiPaymentMethodShopeepay",
  "OpenapiPaymentMethodSofort",
  "OpenapiPaymentMethodSouthKoreaMarket",
  "OpenapiPaymentMethodStripeBalance",
  "OpenapiPaymentMethodSunbit",
  "OpenapiPaymentMethodSwish",
  "OpenapiPaymentMethodTestPay",
  "OpenapiPaymentMethodTwint",
  "OpenapiPaymentMethodUpi",
  "OpenapiPaymentMethodUsBankAccount",
  "OpenapiPaymentMethodUsBankAccountStatusDetails",
  "OpenapiPaymentMethodUsCashVoucher",
  "OpenapiPaymentMethodVipps",
  "OpenapiPaymentMethodVolumeLimitUsage",
  "OpenapiPaymentMethodWechatPay",
  "OpenapiPaymentMethodWero",
  "OpenapiPaymentMethodZip",
  "OpenapiPaymentMethodsProcessingAvailability",
  "OpenapiPaymentMethodsProductIntegrationAdaptersCardAmex",
  "OpenapiPaymentOrchestrationRoutingResourceEmpty",
  "OpenapiPaymentOrchestrationRoutingResourceGetOnboardedProcessors",
  "OpenapiPaymentOrchestrationRoutingResourceRoutingConfig",
  "OpenapiPaymentPagesCheckoutItemsOneTimePriceResourceOneTimePrice",
  "OpenapiPaymentPagesCheckoutItemsPricingPlanSubscriptionResourcePricingPlanSubscriptionItem",
  "OpenapiPaymentPagesCheckoutItemsRateCardSubscriptionResourceRateCardSubscriptionItem",
  "OpenapiPaymentPagesCheckoutSessionAdaptivePricing",
  "OpenapiPaymentPagesCheckoutSessionAfterExpiration",
  "OpenapiPaymentPagesCheckoutSessionAfterExpirationRecovery",
  "OpenapiPaymentPagesCheckoutSessionAutomaticPaymentMethods",
  "OpenapiPaymentPagesCheckoutSessionAutomaticSurcharge",
  "OpenapiPaymentPagesCheckoutSessionAutomaticTax",
  "OpenapiPaymentPagesCheckoutSessionBillingDetails",
  "OpenapiPaymentPagesCheckoutSessionBrandingSettings",
  "OpenapiPaymentPagesCheckoutSessionBrandingSettingsIcon",
  "OpenapiPaymentPagesCheckoutSessionBrandingSettingsLogo",
  "OpenapiPaymentPagesCheckoutSessionBusinessName",
  "OpenapiPaymentPagesCheckoutSessionCheckoutAddressDetails",
  "OpenapiPaymentPagesCheckoutSessionCheckoutItem",
  "OpenapiPaymentPagesCheckoutSessionCheckoutSessionResourceResourceFieldsRedaction",
  "OpenapiPaymentPagesCheckoutSessionCredit",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsBanner",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsBannerIcon",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsCheckbox",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsDropdown",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsDropdownOption",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsNumericInput",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsNumericInputValidation",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsText",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsTextInput",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsTextInputRegex",
  "OpenapiPaymentPagesCheckoutSessionCustomComponentsTextInputValidation",
  "OpenapiPaymentPagesCheckoutSessionCustomFieldsDropdown",
  "OpenapiPaymentPagesCheckoutSessionCustomFieldsLabel",
  "OpenapiPaymentPagesCheckoutSessionCustomFieldsNumeric",
  "OpenapiPaymentPagesCheckoutSessionCustomFieldsOption",
  "OpenapiPaymentPagesCheckoutSessionCustomFieldsText",
  "OpenapiPaymentPagesCheckoutSessionCustomText",
  "OpenapiPaymentPagesCheckoutSessionCustomTextPosition",
  "OpenapiPaymentPagesCheckoutSessionCustomerDetails",
  "OpenapiPaymentPagesCheckoutSessionDiscount",
  "OpenapiPaymentPagesCheckoutSessionIndividualName",
  "OpenapiPaymentPagesCheckoutSessionInvoiceCreation",
  "OpenapiPaymentPagesCheckoutSessionManagedPayments",
  "OpenapiPaymentPagesCheckoutSessionNameCollection",
  "OpenapiPaymentPagesCheckoutSessionOptionalItem",
  "OpenapiPaymentPagesCheckoutSessionOptionalItemAdjustableQuantity",
  "OpenapiPaymentPagesCheckoutSessionPaymentMethodDetailsWalletDetails",
  "OpenapiPaymentPagesCheckoutSessionPaymentMethodReuseAgreement",
  "OpenapiPaymentPagesCheckoutSessionPermissions",
  "OpenapiPaymentPagesCheckoutSessionPhoneNumberCollection",
  "OpenapiPaymentPagesCheckoutSessionPresentmentDetailsWithFxRate",
  "OpenapiPaymentPagesCheckoutSessionSavedPaymentMethodOptions",
  "OpenapiPaymentPagesCheckoutSessionShippingAddressCollection",
  "OpenapiPaymentPagesCheckoutSessionShippingOption",
  "OpenapiPaymentPagesCheckoutSessionSubscriptionData",
  "OpenapiPaymentPagesCheckoutSessionSubscriptionDataInvoiceSettings",
  "OpenapiPaymentPagesCheckoutSessionSurchargeCost",
  "OpenapiPaymentPagesCheckoutSessionTaxId",
  "OpenapiPaymentPagesCheckoutSessionTaxIdCollection",
  "OpenapiPaymentPagesCheckoutSessionTotalDetails",
  "OpenapiPaymentPagesCheckoutSessionTotalDetailsResourceBreakdown",
  "OpenapiPaymentPagesCheckoutSessionUpdatePermission",
  "OpenapiPaymentPagesPaymentPageResourcesAdjustableQuantity",
  "OpenapiPaymentPagesPaymentPageResourcesCoupon",
  "OpenapiPaymentPagesPaymentPageResourcesDiscountAmount",
  "OpenapiPaymentPagesPaymentPageResourcesPromotionCode",
  "OpenapiPaymentPagesPaymentPageResourcesTaxAmount",
  "OpenapiPaymentPagesPaymentPageResourcesTaxRate",
  "OpenapiPaymentPagesPrivateCardPaymentMethodOptionsResourceRestrictions",
  "OpenapiPaymentPlanAmount",
  "OpenapiPaymentsDashboardAddFundsTicket",
  "OpenapiPaymentsDashboardAmountAndCurrency",
  "OpenapiPaymentsDashboardAsyncFee",
  "OpenapiPaymentsDashboardAsyncFeeSummary",
  "OpenapiPaymentsDashboardClimateContribution",
  "OpenapiPaymentsDashboardExternalProcessorFeeSummary",
  "OpenapiPaymentsDashboardFeeSummary",
  "OpenapiPaymentsDashboardFundingSource",
  "OpenapiPaymentsDashboardFxQuoteAssociation",
  "OpenapiPaymentsDashboardMandateCustomerAcceptance",
  "OpenapiPaymentsDashboardMandateCustomerAcceptanceOnline",
  "OpenapiPaymentsDashboardPaymentDetailSummary",
  "OpenapiPaymentsDashboardRealTimeNotificationSetting",
  "OpenapiPaymentsDashboardUsageFee",
  "OpenapiPaymentsDashboardUsageFeeSummary",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceAddress",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceAmount",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceAuthorizationDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceBillingDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceCustomerDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceFailureDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthenticated",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthenticationInitiated",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthenticationInitiatedProcessorDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthenticationInitiatedProcessorDetailsCustom",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorized",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetailsAdyen",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetailsBraintree",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetailsCardnet",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetailsChase",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetailsCheckoutCom",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetailsCustom",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetailsPxp",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetailsStripe",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceAuthorizedProcessorDetailsWorldpay",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceCanceled",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceCaptureInitiated",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceCaptureSettled",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceCardDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailed",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedFailureDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetailsAdyen",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetailsBraintree",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetailsCardnet",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetailsChase",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetailsCheckoutCom",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetailsCustom",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetailsPxp",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetailsStripe",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceFailedProcessorDetailsWorldpay",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceGuaranteed",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceInformational",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceInitiated",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceInitiatedPaymentMethodDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourcePaymentMethodDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundFailed",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundFailedProcessorDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundFailedProcessorDetailsResourceAdyenDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundFailedProcessorDetailsResourceBraintreeDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundFailedProcessorDetailsResourceCardnetDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundFailedProcessorDetailsResourceChaseDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundFailedProcessorDetailsResourceCheckoutComDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundFailedProcessorDetailsResourcePxpDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundFailedProcessorDetailsResourceWorldpayDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiated",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetailsResourceAdyenDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetailsResourceBraintreeDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetailsResourceCardnetDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetailsResourceChaseDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetailsResourceCheckoutComDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetailsResourceCustomDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetailsResourcePxpDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetailsResourceStripeDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundInitiatedProcessorDetailsResourceWorldpayDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefunded",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundedProcessorDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundedProcessorDetailsResourceAdyenDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundedProcessorDetailsResourceBraintreeDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundedProcessorDetailsResourceCardnetDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundedProcessorDetailsResourceChaseDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundedProcessorDetailsResourceCheckoutComDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundedProcessorDetailsResourcePxpDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentAttemptRecordEntryResourceRefundedProcessorDetailsResourceWorldpayDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodAffirmDetailsResourceDecrementalAuthorization",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodAffirmDetailsResourceMulticapture",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodAlmaDetailsResourceInstallments",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodAmazonPayDetailsResourceFunding",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodAmazonPayDetailsResourceFundingResourceFundingCard",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodBillieDetailsResourceDecrementalAuthorization",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodBillieDetailsResourceIncrementalAuthorization",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodBillieDetailsResourceMulticapture",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCardDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCardDetailsResourceChecks",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCardDetailsResourceInstallmentPlan",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCardDetailsResourceInstallments",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCardDetailsResourceNetworkToken",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCardDetailsResourceThreeDSecure",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCardDetailsResourceWallet",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCardDetailsResourceWalletResourceApplePay",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCardDetailsResourceWalletResourceGooglePay",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCashappDetailsResourceIncrementalAuthorization",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodCustomDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodDummyAuthPushDetailsResourceMulticapture",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodGiftCardDetailsResourceBalance",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodKlarnaDetailsResourceIncrementalAuthorization",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodKlarnaDetailsResourceMulticapture",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodKlarnaDetailsResourcePayerDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodKlarnaDetailsResourcePayerDetailsResourcePayerDetailsAddress",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodKlarnaDetailsResourceWallet",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodKonbiniDetailsResourceStore",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodMobilepayDetailsResourceCard",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodPayByBankDetailsResourceSortCode",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodShopPayDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourcePaymentMethodVippsDetailsResourceCard",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetailsResourceAdyenDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetailsResourceBraintreeDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetailsResourceCardnetDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetailsResourceChaseDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetailsResourceCheckoutComDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetailsResourceCustomDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetailsResourcePxpDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetailsResourceStripeDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceProcessorDetailsResourceWorldpayDetails",
  "OpenapiPaymentsPrimitivesPaymentRecordsResourceShippingDetails",
  "OpenapiPayoutPayoutMethodDetails",
  "OpenapiPayoutPayoutMethodDetailsResourceBankAccount",
  "OpenapiPayoutPayoutMethodDetailsResourceCard",
  "OpenapiPayoutSummary",
  "OpenapiPayoutsTraceId",
  "OpenapiPaypalSellerProtection",
  "OpenapiPendingUpdateClient",
  "OpenapiPersonAdditionalTosAcceptance",
  "OpenapiPersonAdditionalTosAcceptances",
  "OpenapiPersonEthnicityDetails",
  "OpenapiPersonFutureRequirements",
  "OpenapiPersonRaceDetails",
  "OpenapiPersonRelationship",
  "OpenapiPersonRequirements",
  "OpenapiPersonUsCfpbData",
  "OpenapiPlanTier",
  "OpenapiPlatformCadDetails",
  "OpenapiPlatformConnectionStripeTypeExternalAccounts",
  "OpenapiPlatformControllingPlatformClientApplication",
  "OpenapiPlatformEarningFeeSource",
  "OpenapiPlatformEarningFundingSource",
  "OpenapiPlatformEarningRefunds",
  "OpenapiPlatformEarningSource",
  "OpenapiPlatformEarningSourceResourceResource",
  "OpenapiPlatformExtensionResourceAccountStatusPreviewResult",
  "OpenapiPlatformExtensionResourceCapabilityExtensionCreateResult",
  "OpenapiPlatformExtensionResourceCapabilityExtensionPreviewResult",
  "OpenapiPlatformExtensionResourceCapabilityExtensionPreviewResultList",
  "OpenapiPlatformExtensionResourceDisruptedExtensionList",
  "OpenapiPlatformFeeRefunds",
  "OpenapiPlatformMerchantInvoiceSettings",
  "OpenapiPmonboardingDataLpmOnboardingBoolField",
  "OpenapiPmonboardingDataLpmOnboardingField",
  "OpenapiPmonboardingDataLpmOnboardingSelectField",
  "OpenapiPmonboardingDataLpmOnboardingStringField",
  "OpenapiPmonboardingDataOnboardingForm",
  "OpenapiPortalBusinessProfile",
  "OpenapiPortalClientResourceAdaptivePricingClient",
  "OpenapiPortalClientResourceAddressClient",
  "OpenapiPortalClientResourceCurrencyConversionDisclosureDetailsClient",
  "OpenapiPortalClientResourceCustomerShippingClient",
  "OpenapiPortalClientResourceDiscountAmountClient",
  "OpenapiPortalClientResourceLicenseFeeClient",
  "OpenapiPortalClientResourcePaymentError",
  "OpenapiPortalClientResourcePresentmentDetailsClient",
  "OpenapiPortalClientResourcePricingPlanComponentClient",
  "OpenapiPortalClientResourcePricingPlanComponentTierClient",
  "OpenapiPortalClientResourcePricingPlanComponentTransformQuantityClient",
  "OpenapiPortalClientResourceRateCardClient",
  "OpenapiPortalClientResourceRetentionCoupon",
  "OpenapiPortalClientResourceRetentionCouponClientResourceRetentionCouponClient",
  "OpenapiPortalClientResourceRetentionOptions",
  "OpenapiPortalClientResourceSharedPaymentMethodClient",
  "OpenapiPortalClientResourceSubscriptionPaymentSettingsClient",
  "OpenapiPortalCreditBalance",
  "OpenapiPortalCustomerClientTaxIds",
  "OpenapiPortalCustomerTaxClient",
  "OpenapiPortalCustomerUpdate",
  "OpenapiPortalEmpty",
  "OpenapiPortalExpAffectedSubscription",
  "OpenapiPortalExpCreditGrantBalance",
  "OpenapiPortalExpCreditGrantBalanceBalance",
  "OpenapiPortalExpCreditGrantBalanceExpiration",
  "OpenapiPortalExpCreditHistory",
  "OpenapiPortalExpCreditHistoryAmount",
  "OpenapiPortalExpCreditHistoryApplicabilityConfig",
  "OpenapiPortalExpCreditHistoryCustomPricingUnitValue",
  "OpenapiPortalExpCreditHistoryMonetaryValue",
  "OpenapiPortalExpCreditHistoryScope",
  "OpenapiPortalExpCreditNoteLines",
  "OpenapiPortalExpGetOverdueInvoiceBalance",
  "OpenapiPortalExpLineItemDiscount",
  "OpenapiPortalExpLineItemDiscountCoupon",
  "OpenapiPortalExpLineItemTax",
  "OpenapiPortalExpLineItemTierDetails",
  "OpenapiPortalExpLinkPaymentMethodDetails",
  "OpenapiPortalExpLinkPaymentMethodDetailsBankAccount",
  "OpenapiPortalExpLinkPaymentMethodDetailsCard",
  "OpenapiPortalExpListAllCreditNotes",
  "OpenapiPortalExpListCreditNoteLineItems",
  "OpenapiPortalExpListInvoiceHistory",
  "OpenapiPortalExpListInvoiceHistoryAllowedActions",
  "OpenapiPortalExpListInvoiceHistoryDownloadInvoiceAction",
  "OpenapiPortalExpListInvoiceHistoryDownloadReceiptAction",
  "OpenapiPortalExpListInvoiceHistoryInvoiceItem",
  "OpenapiPortalExpListInvoiceHistoryPayInvoiceAction",
  "OpenapiPortalExpListInvoiceHistoryPresentmentDetails",
  "OpenapiPortalExpListInvoiceLineItems",
  "OpenapiPortalExpListSubscriptions",
  "OpenapiPortalExpPayInvoiceAction",
  "OpenapiPortalExpPreviewCancelSubscriptionCancellationReason",
  "OpenapiPortalExpPreviewCancelSubscriptionRefundEligibility",
  "OpenapiPortalExpPreviewCancelSubscriptionTotalCost",
  "OpenapiPortalExpPreviewReactivate",
  "OpenapiPortalExpPreviewReactivateLastInvoicePayment",
  "OpenapiPortalExpPreviewReactivateSubscriptionItem",
  "OpenapiPortalExpPricingItem",
  "OpenapiPortalExpSubscriptionAllowedActions",
  "OpenapiPortalExpSubscriptionBillingCycle",
  "OpenapiPortalExpSubscriptionBillingCycleDay",
  "OpenapiPortalExpSubscriptionBillingCycleMonth",
  "OpenapiPortalExpSubscriptionBillingCycleTime",
  "OpenapiPortalExpSubscriptionBillingCycleWeek",
  "OpenapiPortalExpSubscriptionBillingCycleYear",
  "OpenapiPortalExpSubscriptionDetails",
  "OpenapiPortalExpSubscriptionDetailsPricingPlan",
  "OpenapiPortalExpSubscriptionDetailsProduct",
  "OpenapiPortalExpSubscriptionItem",
  "OpenapiPortalExpSubscriptionMeterUsage",
  "OpenapiPortalExpSubscriptionMeterUsageMeterSegmentCondition",
  "OpenapiPortalExpSubscriptionMeterUsagePeriod",
  "OpenapiPortalExpSubscriptionMeterUsagePricing",
  "OpenapiPortalExpSubscriptionMeterUsageTier",
  "OpenapiPortalExpSubscriptionMeterUsageTransformQuantity",
  "OpenapiPortalExpSubscriptionNextInvoicePayment",
  "OpenapiPortalExpSubscriptionPresentmentDetails",
  "OpenapiPortalExpSubscriptionUpdateAction",
  "OpenapiPortalExpSubscriptionUpdatePreviewAdjustableQuantity",
  "OpenapiPortalExpSubscriptionUpdatePreviewExistingAddOn",
  "OpenapiPortalExpSubscriptionUpdatePreviewTier",
  "OpenapiPortalExpSubscriptionUpdatePreviewTransformQuantity",
  "OpenapiPortalExpSubscriptionUpdateTiers",
  "OpenapiPortalExpUpdatePaymentMethodRender",
  "OpenapiPortalExpUsageAnalytics",
  "OpenapiPortalExpUsageAnalyticsRow",
  "OpenapiPortalFeatures",
  "OpenapiPortalFlowsAfterCompletionHostedConfirmation",
  "OpenapiPortalFlowsAfterCompletionRedirect",
  "OpenapiPortalFlowsCouponOffer",
  "OpenapiPortalFlowsFlowCancellationReason",
  "OpenapiPortalFlowsFlowPaymentMethodUpdate",
  "OpenapiPortalFlowsFlowSubscriptionCancel",
  "OpenapiPortalFlowsFlowSubscriptionUpdate",
  "OpenapiPortalFlowsFlowSubscriptionUpdateConfirmClient",
  "OpenapiPortalFlowsRetention",
  "OpenapiPortalFlowsSubscriptionUpdateConfirmDiscountClient",
  "OpenapiPortalInvoiceList",
  "OpenapiPortalPaymentMethodUpdate",
  "OpenapiPortalPricingPlanSubscriptionClient",
  "OpenapiPortalResourceScheduleUpdateAtPeriodEnd",
  "OpenapiPortalResourceScheduleUpdateAtPeriodEndCondition",
  "OpenapiPortalSubscriptionCancel",
  "OpenapiPortalSubscriptionCancelRestrictions",
  "OpenapiPortalSubscriptionCancellationReason",
  "OpenapiPortalSubscriptionCancellationRedirect",
  "OpenapiPortalSubscriptionPause",
  "OpenapiPortalSubscriptionUpdate",
  "OpenapiPortalSubscriptionUpdatePackaging",
  "OpenapiPortalSubscriptionUpdateProduct",
  "OpenapiPortalSubscriptionUpdateProductAdjustableQuantity",
  "OpenapiPortalSubscriptionUpdateProductClient",
  "OpenapiPortalSubscriptionUpdateRestrictions",
  "OpenapiPortalUpdatePreview",
  "OpenapiPortalUsageAnalytics",
  "OpenapiPortalUsageBasedBilling",
  "OpenapiPostV1AccountBatchPersons",
  "OpenapiPostV1AccountsAccountBatchPersons",
  "OpenapiPostV1BillingPortalRefundPolicies",
  "OpenapiPostV1BillingPortalRetentionFlows",
  "OpenapiPostV1CapitalAdditionalUnderwritingRequestsCancel",
  "OpenapiPostV1TerminalHardwareWarrantyClaimsTerminalHardwareWarrantyClaimHardwareWarrantyClaimItems",
  "OpenapiPostV1TestHelpersTerminalHardwareOrderDevicesCreateDevicesForOrder",
  "OpenapiPostVolumeLimitIncreaseRequest",
  "OpenapiPrebillingData",
  "OpenapiPrefillMetadata",
  "OpenapiPriceDetails",
  "OpenapiPriceOption",
  "OpenapiPriceTier",
  "OpenapiPricingTablesPricingTableResourcesCustomFieldsDropdown",
  "OpenapiPricingTablesPricingTableResourcesCustomFieldsLabel",
  "OpenapiPricingTablesPricingTableResourcesCustomFieldsNumeric",
  "OpenapiPricingTablesPricingTableResourcesCustomFieldsOption",
  "OpenapiPricingTablesPricingTableResourcesCustomFieldsText",
  "OpenapiPricingTablesPricingTableResourcesCustomUrlConfig",
  "OpenapiPricingTablesPricingTableResourcesPricingTableInterval",
  "OpenapiPricingTablesPricingTableResourcesPricingTableItem",
  "OpenapiPricingTablesPricingTableResourcesPricingTableItemResourceTaxIdCollection",
  "OpenapiPricingTablesPricingTableResourcesPricingTableResourceBrandingSettings",
  "OpenapiProductCatalogImplEndpointsTrialOfferResourceRelativeDuration",
  "OpenapiProductCatalogImplEndpointsTrialOfferResourceTransition",
  "OpenapiProductCatalogImplEndpointsTrialOfferResourceTrialOfferDuration",
  "OpenapiProductCatalogImplEndpointsTrialOfferResourceTrialOfferEndBehavior",
  "OpenapiProductClassProducts",
  "OpenapiProductClassesResourceComputedAttribute",
  "OpenapiProductClassesResourceComputedAttributeValue",
  "OpenapiProductMarketingFeature",
  "OpenapiProductPlans",
  "OpenapiProductPrices",
  "OpenapiProductSkus",
  "OpenapiProductsResourceAttributeInAttributeValue",
  "OpenapiProductsResourceProvisioningApiResourceProvisioningGiftCard",
  "OpenapiProductsResourceProvisioningApiResourceProvisioningGiftCardFixedAmount",
  "OpenapiPromotionCodesResourcePromotion",
  "OpenapiPromotionCodesResourceRestrictions",
  "OpenapiProrationComponentClient",
  "OpenapiProrationDataClient",
  "OpenapiProrationDetails",
  "OpenapiProvisioning",
  "OpenapiPutV1RealTimeNotificationSettings",
  "OpenapiQuoteLineItems",
  "OpenapiQuotesCoreApiResourceLastReestimateDetails",
  "OpenapiQuotesCoreApiResourceReestimateFailure",
  "OpenapiQuotesResourceAutomaticTax",
  "OpenapiQuotesResourceComputed",
  "OpenapiQuotesResourceDashboardCustomer",
  "OpenapiQuotesResourceFromQuote",
  "OpenapiQuotesResourcePrebilling",
  "OpenapiQuotesResourceQuoteLinesAppliesTo",
  "OpenapiQuotesResourceQuoteLinesTimestampHelpersDuration",
  "OpenapiQuotesResourceRecurring",
  "OpenapiQuotesResourceStatusDetailsAcceptingFailedReason",
  "OpenapiQuotesResourceStatusDetailsAcceptingStatusDetails",
  "OpenapiQuotesResourceStatusDetailsLinesInvalid",
  "OpenapiQuotesResourceStatusDetailsStaleReason",
  "OpenapiQuotesResourceStatusDetailsStaleStatusDetails",
  "OpenapiQuotesResourceStatusDetailsSubscriptionChanged",
  "OpenapiQuotesResourceStatusDetailsSubscriptionScheduleChanged",
  "OpenapiQuotesResourceStatusTransitions",
  "OpenapiQuotesResourceSubscriptionDataBillFrom",
  "OpenapiQuotesResourceSubscriptionDataBillOnAcceptance",
  "OpenapiQuotesResourceSubscriptionDataBillUntil",
  "OpenapiQuotesResourceSubscriptionDataBillingMode",
  "OpenapiQuotesResourceSubscriptionDataBillingSchedulesBillFrom",
  "OpenapiQuotesResourceSubscriptionDataBillingSchedulesBillUntil",
  "OpenapiQuotesResourceSubscriptionDataSubscriptionData",
  "OpenapiQuotesResourceSubscriptionDataSubscriptionDataOverrides",
  "OpenapiQuotesResourceSubscriptionScheduleWithAppliesTo",
  "OpenapiQuotesResourceTotalDetails",
  "OpenapiQuotesResourceTotalDetailsResourceBreakdown",
  "OpenapiQuotesResourceTransferData",
  "OpenapiQuotesResourceUpfront",
  "OpenapiQuotesResourceUpfrontLineItems",
  "OpenapiRadarApplyRiskPreference",
  "OpenapiRadarCustomCountersRadarCustomCounterConfiguration",
  "OpenapiRadarCustomCountersRadarCustomCounterDataConfiguration",
  "OpenapiRadarCustomCountersRadarCustomCounterDataSubConfiguration",
  "OpenapiRadarCustomCountersRadarCustomCounterFeature",
  "OpenapiRadarDisputesAutoRepresentmentSettings",
  "OpenapiRadarDisputesDisputeSettings",
  "OpenapiRadarDisputesEvidenceSubmissionSettings",
  "OpenapiRadarDisputesGraphQlDisputeEvidenceExtras",
  "OpenapiRadarDisputesGraphQlDisputeEvidenceExtrasAddress",
  "OpenapiRadarDisputesGraphQlDisputeEvidenceExtrasDate",
  "OpenapiRadarDisputesGraphQlDisputeEvidenceExtrasShipment",
  "OpenapiRadarDisputesGraphQlipAddress",
  "OpenapiRadarFraudAlert",
  "OpenapiRadarFraudExplorerResourceAgenticInsight",
  "OpenapiRadarFraudExplorerResourceAllTime",
  "OpenapiRadarFraudExplorerResourceRetrieveAgenticInsights",
  "OpenapiRadarFraudExplorerResourceRetriveAttributeValues",
  "OpenapiRadarFraudExplorerResourceTermAmount",
  "OpenapiRadarFraudExplorerResourceTermCount",
  "OpenapiRadarFraudExplorerResourceTimeSeriesEntry",
  "OpenapiRadarGraphPrototypeResourceGraphPrototypeExpand",
  "OpenapiRadarListListListItems",
  "OpenapiRadarListRedaction",
  "OpenapiRadarRadarTieredFeatures",
  "OpenapiRadarReviewConnectAccountExternalAccounts",
  "OpenapiRadarReviewResourceConnect",
  "OpenapiRadarReviewResourceGuestCustomer",
  "OpenapiRadarReviewResourceLocation",
  "OpenapiRadarReviewResourceRefundSignals",
  "OpenapiRadarReviewResourceReviewAssignmentHistory",
  "OpenapiRadarReviewResourceSession",
  "OpenapiRadarRuleRuleSetSettings",
  "OpenapiRadarSearchResourceRuleDetailMetrics",
  "OpenapiRadarSearchResourceRuleDisputeMetrics",
  "OpenapiRadarSearchResourceRuleDisputesSearch",
  "OpenapiRadarSettings",
  "OpenapiRadarSmartThreedsUpdateSettings",
  "OpenapiRadarSupportedPaymentMethods",
  "OpenapiRadarTemplateConfigs",
  "OpenapiReceivedCreditsResourceLinkedFlows",
  "OpenapiReceivedCreditsResourceSourceFlowsDetails",
  "OpenapiReceivedDebitsResourceLinkedFlows",
  "OpenapiReceivedHoldsResourceAdjustmentAdjustment",
  "OpenapiReceivedHoldsResourceAmountDetails",
  "OpenapiReceivedHoldsResourceCardMerchantSourceDetails",
  "OpenapiReceivedHoldsResourceCardNetworkDetails",
  "OpenapiReceivedHoldsResourceFeeDetails",
  "OpenapiReceivedHoldsResourceLegacyLinkedFlows",
  "OpenapiReceivedHoldsResourceLinkedFlows",
  "OpenapiReceivedHoldsResourceNetworkDetails",
  "OpenapiReceivedHoldsResourcePendingApproval",
  "OpenapiReceivedHoldsResourcePendingApprovalPendingReceivedHoldAttemptDetails",
  "OpenapiReceivedHoldsResourceReceivedHoldAdjustmentHistory",
  "OpenapiReceivedHoldsResourceSourceDetails",
  "OpenapiReceivedHoldsResourceVerificationData",
  "OpenapiRecipientShipping",
  "OpenapiRecurring",
  "OpenapiRecurringClient",
  "OpenapiRedaction",
  "OpenapiRefundNextAction",
  "OpenapiRefundNextActionDisplayDetails",
  "OpenapiRefundPaymentMethodDetails",
  "OpenapiRefundPaymentMethodDetailsCard",
  "OpenapiRefundPaymentMethodDetailsInteracPresent",
  "OpenapiRefundPaymentMethodOptions",
  "OpenapiRefundPaymentMethodOptionsCard",
  "OpenapiRefundPaymentMethodOptionsCardNetworkOptions",
  "OpenapiRefundPaymentMethodOptionsCardNetworkOptionsAmex",
  "OpenapiReonboardingAccount",
  "OpenapiReportingPermissionedEntity",
  "OpenapiReportingReportsCachedMetadataKeysCompartmentCachedMetadataKeys",
  "OpenapiRequestLogs",
  "OpenapiReservesReserveHoldsResourcesReleaseSchedule",
  "OpenapiReservesReservePlansResourcesFixedRelease",
  "OpenapiReservesReservePlansResourcesRollingRelease",
  "OpenapiReservesReserveReleasesResourcesSourceTransaction",
  "OpenapiRetrieveIncomingWireReferenceManage",
  "OpenapiRetrievePaymentMethodVolumeLimit",
  "OpenapiRetryDetails",
  "OpenapiRevenueRecognitionAccountingIntelligenceRevenueForecastRevenueForecast",
  "OpenapiRevenueRecognitionAccountingIntelligenceStatementsInsightsStatementsInsights",
  "OpenapiRevenueRecognitionContractResourceBillingModel",
  "OpenapiRevenueRecognitionContractResourceContractItems",
  "OpenapiRevenueRecognitionContractResourceHoldDetails",
  "OpenapiRevenueRecognitionContractResourcePeriod",
  "OpenapiRevenueRecognitionContractResourceStatusTransitions",
  "OpenapiRevenueRecognitionContractResourceTerminationForConvenience",
  "OpenapiRevenueRecognitionOverviewRecommendationResourceOverviewRecommendationList",
  "OpenapiRevenueRecognitionResourceRevenueRecognitionStatus",
  "OpenapiRevenueRecognitionSegmentMappingResourceFilterOptionsList",
  "OpenapiRevenueRecognitionSegmentMappingResourceSubledgerAndGlFilterOptions",
  "OpenapiRevenueRecognitionSettings",
  "OpenapiRevenueRecoveryRetryResourceDebitRetriesConfig",
  "OpenapiRevenueRecoveryRetryResourceLpmRetriesConfig",
  "OpenapiRevenueRecoveryRetryResourcePaymentMethodConfig",
  "OpenapiRevenueRecoveryRetryResourceRetrySettings",
  "OpenapiRevenueRecoveryRetryResourceScheduledRetryPolicy",
  "OpenapiRevenueRecoveryRetryResourceSmartRetryPolicy",
  "OpenapiReverseSmsConfirm",
  "OpenapiRevolutPayUnderlyingPaymentMethodFundingDetails",
  "OpenapiRisaComplianceSurvey",
  "OpenapiRiskAddressValidationAddressValidationResult",
  "OpenapiRiskAddressValidationAddressValidationSuggestions",
  "OpenapiRiskChallengesResourcesFinancialConnectionResponse",
  "OpenapiRiskChallengesResourcesStripeVerifiedAccept",
  "OpenapiRiskChallengesTosInsufficientProductDescriptionSaveProductDescriptionIfSufficient",
  "OpenapiRiskCommunicationAccountStatusAccountStatusBanner",
  "OpenapiRiskCommunicationAccountStatusAccountStatusBannerButton",
  "OpenapiRiskCommunicationAccountStatusAccountStatusBannerResponse",
  "OpenapiRiskCommunicationAccountStatusAccountStatusSuppressionExemptions",
  "OpenapiRiskCommunicationAccountStatusExtensionMetadata",
  "OpenapiRiskCommunicationAccountStatusGuidelines",
  "OpenapiRiskDashboardFormsRiskDashboardForm",
  "OpenapiRiskDashboardFormsRiskDashboardFormAddBankConnectionQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormAllPayoutAccountsLinked",
  "OpenapiRiskDashboardFormsRiskDashboardFormAttestationQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormContentControl",
  "OpenapiRiskDashboardFormsRiskDashboardFormCurrencyInputQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormDateInputQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormDocumentUploadTagOption",
  "OpenapiRiskDashboardFormsRiskDashboardFormDropdownQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormGetReadyStartPage",
  "OpenapiRiskDashboardFormsRiskDashboardFormGetReadyStartPageMoreContext",
  "OpenapiRiskDashboardFormsRiskDashboardFormLink",
  "OpenapiRiskDashboardFormsRiskDashboardFormListResponse",
  "OpenapiRiskDashboardFormsRiskDashboardFormMinimalEndPage",
  "OpenapiRiskDashboardFormsRiskDashboardFormMinimalStartPage",
  "OpenapiRiskDashboardFormsRiskDashboardFormMultiDocumentUploadQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormMultiSelectQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormMultiSelectWithNoneOptionQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormMultiTaggedDocumentUploadQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormNextStepsEndPage",
  "OpenapiRiskDashboardFormsRiskDashboardFormPage",
  "OpenapiRiskDashboardFormsRiskDashboardFormPercentInputQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormQuestionSet",
  "OpenapiRiskDashboardFormsRiskDashboardFormQuestionValidation",
  "OpenapiRiskDashboardFormsRiskDashboardFormQuestionValidationRegexMatch",
  "OpenapiRiskDashboardFormsRiskDashboardFormResponse",
  "OpenapiRiskDashboardFormsRiskDashboardFormResponseTaggedFileUploadProps",
  "OpenapiRiskDashboardFormsRiskDashboardFormResponseValue",
  "OpenapiRiskDashboardFormsRiskDashboardFormSavedResponseTaggedFileUploadProps",
  "OpenapiRiskDashboardFormsRiskDashboardFormSingleSelectQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormSingleSelectWithRecommendedOptionQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormTaskListStartPage",
  "OpenapiRiskDashboardFormsRiskDashboardFormTaxItemListStartPage",
  "OpenapiRiskDashboardFormsRiskDashboardFormTaxItemListStartPageItem",
  "OpenapiRiskDashboardFormsRiskDashboardFormTaxTaskListEndPage",
  "OpenapiRiskDashboardFormsRiskDashboardFormTaxTaskListEndPageTask",
  "OpenapiRiskDashboardFormsRiskDashboardFormTextAreaQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormTextInputQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormTextOption",
  "OpenapiRiskDashboardFormsRiskDashboardFormTextOptionWithIcon",
  "OpenapiRiskDashboardFormsRiskDashboardFormTextVariant",
  "OpenapiRiskDashboardFormsRiskDashboardFormUrlInputQuestion",
  "OpenapiRiskDashboardFormsRiskDashboardFormUrlValidation",
  "OpenapiRiskDefinedInterventionsResourcesGetOrCreateDefinedIntervention",
  "OpenapiRiskDetails",
  "OpenapiRiskStripeVerifiedCreateSupportCaseAndLinkToRp",
  "OpenapiRiskStripeVerifiedIsMerchantTopStartup",
  "OpenapiRiskStripeVerifiedVerifiedStatus",
  "OpenapiRiskStripeVerifiedVerifiedTierState",
  "OpenapiRiskSupportabilityBinSponsorEligibilityResourcesUrlRequirementEvaluationStatus",
  "OpenapiRoutingAttributes",
  "OpenapiRulesEngineAccountRulesRadarGptChatHistory",
  "OpenapiRulesEngineAccountRulesRadarGptChatHistoryRule",
  "OpenapiRulesEngineAccountRulesRadarGptSendMessage",
  "OpenapiRulesEngineMerchantRuleFanoutResult",
  "OpenapiSchedulesPhaseAutomaticTax",
  "OpenapiScreenshareSessionToken",
  "OpenapiSecretServiceResourceScope",
  "OpenapiSelfReportedAmount",
  "OpenapiSellerDetails",
  "OpenapiSepaDebitGeneratedFrom",
  "OpenapiSepaDebitVerification",
  "OpenapiServicePeriodAnchorConfigForSchedule",
  "OpenapiServicePeriodAnchorCustomConfig",
  "OpenapiSessionLineItems",
  "OpenapiSettings",
  "OpenapiSettingsBankDebitFeatureInvitation",
  "OpenapiSettingsBankToPayoutReconciliationSettings",
  "OpenapiSettingsCurrencyVolumes",
  "OpenapiSettingsDebitsSettlementScenario",
  "OpenapiSettingsDebitsSettlementSettings",
  "OpenapiSettingsDebitsSettlementSettingsModify",
  "OpenapiSettingsLegalEntityTaxInfo",
  "OpenapiSettingsPaymentMethodCurrencyVolumes",
  "OpenapiSettingsUsBankAccountSettings",
  "OpenapiSetupAttemptPaymentMethodDetails",
  "OpenapiSetupAttemptPaymentMethodDetailsAcssDebit",
  "OpenapiSetupAttemptPaymentMethodDetailsAfterpayClearpay",
  "OpenapiSetupAttemptPaymentMethodDetailsAlipay",
  "OpenapiSetupAttemptPaymentMethodDetailsAmazonPay",
  "OpenapiSetupAttemptPaymentMethodDetailsAuBecsDebit",
  "OpenapiSetupAttemptPaymentMethodDetailsBacsDebit",
  "OpenapiSetupAttemptPaymentMethodDetailsBancontact",
  "OpenapiSetupAttemptPaymentMethodDetailsBlik",
  "OpenapiSetupAttemptPaymentMethodDetailsBoleto",
  "OpenapiSetupAttemptPaymentMethodDetailsCard",
  "OpenapiSetupAttemptPaymentMethodDetailsCardChecks",
  "OpenapiSetupAttemptPaymentMethodDetailsCardChecksNameChecks",
  "OpenapiSetupAttemptPaymentMethodDetailsCardPresent",
  "OpenapiSetupAttemptPaymentMethodDetailsCardWallet",
  "OpenapiSetupAttemptPaymentMethodDetailsCashapp",
  "OpenapiSetupAttemptPaymentMethodDetailsCrypto",
  "OpenapiSetupAttemptPaymentMethodDetailsDemoPay",
  "OpenapiSetupAttemptPaymentMethodDetailsDummyAuthPush",
  "OpenapiSetupAttemptPaymentMethodDetailsDummyPassthroughCard",
  "OpenapiSetupAttemptPaymentMethodDetailsGcash",
  "OpenapiSetupAttemptPaymentMethodDetailsGopay",
  "OpenapiSetupAttemptPaymentMethodDetailsIdBankTransfer",
  "OpenapiSetupAttemptPaymentMethodDetailsIdeal",
  "OpenapiSetupAttemptPaymentMethodDetailsKakaoPay",
  "OpenapiSetupAttemptPaymentMethodDetailsKlarna",
  "OpenapiSetupAttemptPaymentMethodDetailsKrCard",
  "OpenapiSetupAttemptPaymentMethodDetailsKrMarket",
  "OpenapiSetupAttemptPaymentMethodDetailsLink",
  "OpenapiSetupAttemptPaymentMethodDetailsMomo",
  "OpenapiSetupAttemptPaymentMethodDetailsNaverPay",
  "OpenapiSetupAttemptPaymentMethodDetailsNgCard",
  "OpenapiSetupAttemptPaymentMethodDetailsNgMarket",
  "OpenapiSetupAttemptPaymentMethodDetailsNzBankAccount",
  "OpenapiSetupAttemptPaymentMethodDetailsPaypal",
  "OpenapiSetupAttemptPaymentMethodDetailsPayto",
  "OpenapiSetupAttemptPaymentMethodDetailsPix",
  "OpenapiSetupAttemptPaymentMethodDetailsRevolutPay",
  "OpenapiSetupAttemptPaymentMethodDetailsSepaDebit",
  "OpenapiSetupAttemptPaymentMethodDetailsSofort",
  "OpenapiSetupAttemptPaymentMethodDetailsStripeBalance",
  "OpenapiSetupAttemptPaymentMethodDetailsTwint",
  "OpenapiSetupAttemptPaymentMethodDetailsUpi",
  "OpenapiSetupAttemptPaymentMethodDetailsUsBankAccount",
  "OpenapiSetupAttemptPaymentMethodDetailsUsCashVoucher",
  "OpenapiSetupAttemptPaymentMethodDetailsWechatPay",
  "OpenapiSetupAttemptSetupError",
  "OpenapiSetupIntentNextAction",
  "OpenapiSetupIntentNextActionAlipayHandleRedirect",
  "OpenapiSetupIntentNextActionPixDisplayQrCode",
  "OpenapiSetupIntentNextActionRedirectToUrl",
  "OpenapiSetupIntentNextActionVerifyWithMicrodeposits",
  "OpenapiSetupIntentNextActionWechatPayHandleAppRedirect",
  "OpenapiSetupIntentPaymentMethodOptions",
  "OpenapiSetupIntentPaymentMethodOptionsAcssDebit",
  "OpenapiSetupIntentPaymentMethodOptionsAlipay",
  "OpenapiSetupIntentPaymentMethodOptionsAmazonPay",
  "OpenapiSetupIntentPaymentMethodOptionsBacsDebit",
  "OpenapiSetupIntentPaymentMethodOptionsBizum",
  "OpenapiSetupIntentPaymentMethodOptionsBlik",
  "OpenapiSetupIntentPaymentMethodOptionsCard",
  "OpenapiSetupIntentPaymentMethodOptionsCardMandateOptions",
  "OpenapiSetupIntentPaymentMethodOptionsCardPresent",
  "OpenapiSetupIntentPaymentMethodOptionsClient",
  "OpenapiSetupIntentPaymentMethodOptionsDemoPay",
  "OpenapiSetupIntentPaymentMethodOptionsDummyAuthPush",
  "OpenapiSetupIntentPaymentMethodOptionsKlarna",
  "OpenapiSetupIntentPaymentMethodOptionsLink",
  "OpenapiSetupIntentPaymentMethodOptionsMandateOptionsAcssDebit",
  "OpenapiSetupIntentPaymentMethodOptionsMandateOptionsBacsDebit",
  "OpenapiSetupIntentPaymentMethodOptionsMandateOptionsBlik",
  "OpenapiSetupIntentPaymentMethodOptionsMandateOptionsDummyAuthPush",
  "OpenapiSetupIntentPaymentMethodOptionsMandateOptionsPayto",
  "OpenapiSetupIntentPaymentMethodOptionsMandateOptionsSepaDebit",
  "OpenapiSetupIntentPaymentMethodOptionsPaypal",
  "OpenapiSetupIntentPaymentMethodOptionsPayto",
  "OpenapiSetupIntentPaymentMethodOptionsPix",
  "OpenapiSetupIntentPaymentMethodOptionsSepaDebit",
  "OpenapiSetupIntentPaymentMethodOptionsStripeBalance",
  "OpenapiSetupIntentPaymentMethodOptionsUpi",
  "OpenapiSetupIntentPaymentMethodOptionsUsBankAccount",
  "OpenapiSetupIntentPaymentMethodOptionsWechatPay",
  "OpenapiSetupIntentTypeSpecificPaymentMethodOptionsClient",
  "OpenapiShareableMetricsSharedMetric",
  "OpenapiSharedPaymentTokensAmount",
  "OpenapiSharedPaymentTokensHashedNextActionValues",
  "OpenapiSharedPaymentTokensNextAction",
  "OpenapiSharedPaymentTokensReferralFeeDetailsIssued",
  "OpenapiSharedPaymentTokensRiskDetailsFloatScoreInsight",
  "OpenapiSharedPaymentTokensRiskDetailsIntegerScoreInsight",
  "OpenapiSharedPaymentTokensRiskDetailsIssued",
  "OpenapiSharedPaymentTokensRiskDetailsIssuedInsights",
  "OpenapiSharedPaymentTokensUseStripeSdk",
  "OpenapiShipping",
  "OpenapiShippingRateDeliveryEstimate",
  "OpenapiShippingRateDeliveryEstimateBound",
  "OpenapiShippingRateFixedAmount",
  "OpenapiSigmaAssistantResourcesAssistantChatHistory",
  "OpenapiSigmaAssistantResourcesAssistantMessage",
  "OpenapiSigmaAssistantResourcesAssistantSendMessage",
  "OpenapiSigmaExportToSdp",
  "OpenapiSigmaIsSigmaMerchantSanctioned",
  "OpenapiSigmaListVisualizations",
  "OpenapiSigmaResourcesReportingQueryFoldersListFolders",
  "OpenapiSigmaScheduledQueryRunError",
  "OpenapiSigmaSigmaForOrgsResourcesDownloadLink",
  "OpenapiSigmaSigmaForOrgsResourcesEntities",
  "OpenapiSigmaSigmaForOrgsResourcesEntity",
  "OpenapiSigmaSigmaForOrgsResourcesPermissionedEntity",
  "OpenapiSigmaSigmaForOrgsResourcesQuerySchedule",
  "OpenapiSigmaSigmaForOrgsResourcesSchema",
  "OpenapiSingleUse",
  "OpenapiSkuInventory",
  "OpenapiSmorResourceAcceptTermsOfService",
  "OpenapiSmorResourceAccountEligibility",
  "OpenapiSmorResourceListEligibleTaxCodes",
  "OpenapiSmorResourceManagedPayments",
  "OpenapiSmorResourceManagedPaymentsEligibility",
  "OpenapiSourceCodeVerificationFlow",
  "OpenapiSourceMandate",
  "OpenapiSourceMandateAcceptance",
  "OpenapiSourceMandateOfflineAcceptance",
  "OpenapiSourceMandateOnlineAcceptance",
  "OpenapiSourceOrder",
  "OpenapiSourceOrderItem",
  "OpenapiSourceOwner",
  "OpenapiSourceReceiverFlow",
  "OpenapiSourceRedaction",
  "OpenapiSourceRedirectFlow",
  "OpenapiSourceShipping",
  "OpenapiSourceTypeAchCreditTransfer",
  "OpenapiSourceTypeAchDebit",
  "OpenapiSourceTypeAcssDebit",
  "OpenapiSourceTypeAlipay",
  "OpenapiSourceTypeAuBecsDebit",
  "OpenapiSourceTypeBacsDebit",
  "OpenapiSourceTypeBancontact",
  "OpenapiSourceTypeBitcoin",
  "OpenapiSourceTypeCard",
  "OpenapiSourceTypeCardPresent",
  "OpenapiSourceTypeChfCreditTransfer",
  "OpenapiSourceTypeEps",
  "OpenapiSourceTypeFpx",
  "OpenapiSourceTypeGbpCreditTransfer",
  "OpenapiSourceTypeGiropay",
  "OpenapiSourceTypeGrabpay",
  "OpenapiSourceTypeIdCreditTransfer",
  "OpenapiSourceTypeIdeal",
  "OpenapiSourceTypeInteracPresent",
  "OpenapiSourceTypeJpCreditTransfer",
  "OpenapiSourceTypeKlarna",
  "OpenapiSourceTypeMultibanco",
  "OpenapiSourceTypeOpenBanking",
  "OpenapiSourceTypeOxxo",
  "OpenapiSourceTypeP24",
  "OpenapiSourceTypePaperCheck",
  "OpenapiSourceTypePaypal",
  "OpenapiSourceTypePaysecure",
  "OpenapiSourceTypeSepaCreditTransfer",
  "OpenapiSourceTypeSepaDebit",
  "OpenapiSourceTypeSofort",
  "OpenapiSourceTypeThreeDSecure",
  "OpenapiSourceTypeThreeDSecure2",
  "OpenapiSourceTypeThreeDSecure2Eap",
  "OpenapiSourceTypeWechat",
  "OpenapiStackableDiscountWithDiscountSettings",
  "OpenapiStackableDiscountWithDiscountSettingsAndDiscountEnd",
  "OpenapiStatusTransitions",
  "OpenapiStripeCliDeviceAuthenticationTokensStatusResult",
  "OpenapiStripeCliWebhookSecret",
  "OpenapiStripeConsoleBackfillMerchantContext",
  "OpenapiStripeConsoleCancelQuery",
  "OpenapiStripeConsoleCreateAudioTranscription",
  "OpenapiStripeConsoleDeleteDebugPrompt",
  "OpenapiStripeConsoleDeleteMerchantContext",
  "OpenapiStripeConsoleDeleteSkill",
  "OpenapiStripeConsoleGetConversation",
  "OpenapiStripeConsoleGetConversations",
  "OpenapiStripeConsoleGetDebugPrompt",
  "OpenapiStripeConsoleGetMerchantContext",
  "OpenapiStripeConsoleGetQueryStatus",
  "OpenapiStripeConsoleGetSkill",
  "OpenapiStripeConsoleGetSkillResourceSkillFile",
  "OpenapiStripeConsoleGetSkills",
  "OpenapiStripeConsoleGetSkillsResourceSkill",
  "OpenapiStripeConsoleQuery",
  "OpenapiStripeConsoleRenameConversation",
  "OpenapiStripeConsoleToggleSkill",
  "OpenapiStripeConsoleUpdateDebugPrompt",
  "OpenapiStripeConsoleUpdateMerchantContext",
  "OpenapiStripeConsoleUpsertSkill",
  "OpenapiStripeDataPipelineContactEmail",
  "OpenapiStripeDataPipelineExportPlanRequirements",
  "OpenapiStripeDataPipelineExportPlans",
  "OpenapiStripeDataPipelineInviteEmail",
  "OpenapiStripeDatabasesResourceStripeDatabase",
  "OpenapiStripeDatabasesResourceStripeDatabaseList",
  "OpenapiStripeDatabasesResourceStripeSyncTables",
  "OpenapiStripeDatabasesResourceSyncSheetsOAuth",
  "OpenapiSubscriptionAutomaticTax",
  "OpenapiSubscriptionAutomaticTaxClient",
  "OpenapiSubscriptionBillingThresholds",
  "OpenapiSubscriptionCount",
  "OpenapiSubscriptionDetailsData",
  "OpenapiSubscriptionItemBillingThresholds",
  "OpenapiSubscriptionItems",
  "OpenapiSubscriptionPaymentMethodOptionsBizum",
  "OpenapiSubscriptionPaymentMethodOptionsBlik",
  "OpenapiSubscriptionPaymentMethodOptionsCard",
  "OpenapiSubscriptionPaymentMethodOptionsMandateOptionsBizum",
  "OpenapiSubscriptionPaymentMethodOptionsMandateOptionsBlik",
  "OpenapiSubscriptionPaymentMethodOptionsMandateOptionsPix",
  "OpenapiSubscriptionPaymentMethodOptionsPix",
  "OpenapiSubscriptionPendingInvoiceItemInterval",
  "OpenapiSubscriptionPrebillingData",
  "OpenapiSubscriptionRecoveryLinkInvoiceClientLines",
  "OpenapiSubscriptionScheduleAddInvoiceItem",
  "OpenapiSubscriptionScheduleAddInvoiceItemPeriod",
  "OpenapiSubscriptionScheduleConfigurationItem",
  "OpenapiSubscriptionScheduleCurrentPhase",
  "OpenapiSubscriptionSchedulePhaseConfiguration",
  "OpenapiSubscriptionScheduleRenewalInterval",
  "OpenapiSubscriptionSchedulesResourceDefaultSettings",
  "OpenapiSubscriptionSchedulesResourceDefaultSettingsAutomaticTax",
  "OpenapiSubscriptionSchedulesResourceEndBehavior",
  "OpenapiSubscriptionSchedulesResourceInvoiceItemPeriodResourcePeriodEnd",
  "OpenapiSubscriptionSchedulesResourceInvoiceItemPeriodResourcePeriodStart",
  "OpenapiSubscriptionSchedulesResourcePauseCollection",
  "OpenapiSubscriptionSchedulesResourceTrialSettings",
  "OpenapiSubscriptionTransferData",
  "OpenapiSubscriptionsResourceBillingCycleAnchorConfig",
  "OpenapiSubscriptionsResourceBillingMode",
  "OpenapiSubscriptionsResourceBillingModeFlexible",
  "OpenapiSubscriptionsResourceBillingSchedulesAppliesTo",
  "OpenapiSubscriptionsResourceBillingSchedulesBillUntil",
  "OpenapiSubscriptionsResourceBillingSchedulesBillUntilDuration",
  "OpenapiSubscriptionsResourcePauseCollection",
  "OpenapiSubscriptionsResourcePausedStatusDetails",
  "OpenapiSubscriptionsResourcePausedStatusDetailsPublic",
  "OpenapiSubscriptionsResourcePausedStatusDetailsSubscription",
  "OpenapiSubscriptionsResourcePaymentMethodOptions",
  "OpenapiSubscriptionsResourcePaymentSettings",
  "OpenapiSubscriptionsResourcePendingUpdate",
  "OpenapiSubscriptionsResourcePriceMigrationError",
  "OpenapiSubscriptionsResourcePriceMigrationErrorFailedTransition",
  "OpenapiSubscriptionsResourceStatusDetails",
  "OpenapiSubscriptionsResourceStatusDetailsPublic",
  "OpenapiSubscriptionsResourceSubscriptionInvoiceSettings",
  "OpenapiSubscriptionsResourceSubscriptionPresentmentDetails",
  "OpenapiSubscriptionsResourceTrialSettingsEndBehavior",
  "OpenapiSubscriptionsResourceTrialSettingsTrialSettings",
  "OpenapiSubscriptionsTrialsResourceCurrentTrial",
  "OpenapiSubscriptionsTrialsResourceEndBehavior",
  "OpenapiSubscriptionsTrialsResourceTrialSettings",
  "OpenapiSuggestionResourceAccount",
  "OpenapiSuggestionResourceAddress",
  "OpenapiSuggestionResourceBusinessProfile",
  "OpenapiSuggestionResourceCardPayments",
  "OpenapiSuggestionResourceCompany",
  "OpenapiSuggestionResourcePayments",
  "OpenapiSuggestionResourceResourceValue",
  "OpenapiSuggestionResourceSettings",
  "OpenapiSuggestionResourceSuggestion",
  "OpenapiSuggestionResourceSuggestionContext",
  "OpenapiSummaryItemPolicy",
  "OpenapiSupportCreateSupportEmail",
  "OpenapiSupportServicesCampaignsCampaignResourceDiscountConfig",
  "OpenapiSupportServicesCheckRefundEligibility",
  "OpenapiSupportServicesManagedOperationsMerchantSettings",
  "OpenapiSupportServicesRetentionFlowResourceCancellationSurvey",
  "OpenapiSupportServicesRetentionFlowResourceLossAversion",
  "OpenapiSupportServicesRetentionFlowResourceOffer",
  "OpenapiSupportServicesRetentionFlowResourceRetentionOffers",
  "OpenapiTailorDashboardResourceListDynamicClientApplications",
  "OpenapiTaxCodeRequirements",
  "OpenapiTaxDocumentsList",
  "OpenapiTaxDocumentsTaxDocumentChallenge1099Tin",
  "OpenapiTaxEnrollmentFilingResourceAccountAccess",
  "OpenapiTaxEnrollmentFilingResourceBankDetails",
  "OpenapiTaxEnrollmentFilingResourceBusiness",
  "OpenapiTaxEnrollmentFilingResourceContact",
  "OpenapiTaxEnrollmentFilingResourceEnrollmentOrApplication",
  "OpenapiTaxEnrollmentFilingResourceErrorInformationError",
  "OpenapiTaxEnrollmentFilingResourceIdentificationNumbers",
  "OpenapiTaxEnrollmentFilingResourceInformation",
  "OpenapiTaxEnrollmentFilingResourceInformationRequirements",
  "OpenapiTaxEnrollmentFilingResourcePartnerAccount",
  "OpenapiTaxEnrollmentFilingResourcePartnerOnboardingInformation",
  "OpenapiTaxEnrollmentFilingResourcePhysicalPresence",
  "OpenapiTaxEnrollmentFilingResourceRegistrationDetails",
  "OpenapiTaxEnrollmentFilingResourceRequirementAccountAccessRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementAddressRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementBankDetailsRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementBusinessRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementIdentificationNumbersRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementPartnerOnboardingInformationRequirements",
  "OpenapiTaxEnrollmentFilingResourceRequirementPhysicalPresenceRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementRegisteredLocationsArrayRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementRegistrationDetailsRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementRequirementDate",
  "OpenapiTaxEnrollmentFilingResourceRequirementRequirementFloat",
  "OpenapiTaxEnrollmentFilingResourceRequirementRequirementInteger",
  "OpenapiTaxEnrollmentFilingResourceRequirementRequirementMultipleChoice",
  "OpenapiTaxEnrollmentFilingResourceRequirementRequirementOneOf",
  "OpenapiTaxEnrollmentFilingResourceRequirementRequirementPhoneNumber",
  "OpenapiTaxEnrollmentFilingResourceRequirementRequirementString",
  "OpenapiTaxEnrollmentFilingResourceRequirementTaxDetailsRequirement",
  "OpenapiTaxEnrollmentFilingResourceRequirementThirdPartyDetailsRequirement",
  "OpenapiTaxEnrollmentFilingResourceStatusHistoryItem",
  "OpenapiTaxEnrollmentFilingResourceTaxDetails",
  "OpenapiTaxEnrollmentFilingResourceThirdPartyDetails",
  "OpenapiTaxEnrollmentPartnerSelectionResourcePartnerAvailability",
  "OpenapiTaxEnrollmentPartnerSelectionResourcePartnerAvailabilityList",
  "OpenapiTaxExemptionsResourceCa",
  "OpenapiTaxExemptionsResourceUs",
  "OpenapiTaxFilingAmount",
  "OpenapiTaxIDsOwner",
  "OpenapiTaxIdVerification",
  "OpenapiTaxProductEnableEngine",
  "OpenapiTaxProductGlobalSettings",
  "OpenapiTaxProductIntegrationResourceTaxCalculationReference",
  "OpenapiTaxProductJurisdictionFeaturesFilingGetFilingFeatures",
  "OpenapiTaxProductMonetizationResourceAnnualEntitlementUsage",
  "OpenapiTaxProductMonetizationResourceCurrentPricing",
  "OpenapiTaxProductMonetizationResourceCurrentPricingDetail",
  "OpenapiTaxProductMonetizationResourceCurrentTaxPricing",
  "OpenapiTaxProductMonetizationResourceMerchantPricingDetails",
  "OpenapiTaxProductMonetizationResourcePendingUpdate",
  "OpenapiTaxProductMonetizationResourceRegistrationsAndFilings",
  "OpenapiTaxProductMonetizationResourceTaxSubscriptionPricingDetails",
  "OpenapiTaxProductNotificationPreferencesLocationPreference",
  "OpenapiTaxProductNotificationPreferencesRegionPreference",
  "OpenapiTaxProductNotificationPreferencesThresholdNotificationOptIn",
  "OpenapiTaxProductNotificationPreferencesThresholdNotificationPreferences",
  "OpenapiTaxProductPlatformTaxSettings",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsCaProvinceStandard",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsCanada",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsDefault",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsDefaultInboundGoods",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsDefaultStandard",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsEuStandard",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsEurope",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsSimplified",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsThailand",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsThailandStandard",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUnitedStates",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsAdmissionsTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsAttendanceTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsEntertainmentTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsGrossReceiptsTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsHomeRuleTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsHospitalityTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsLocalAmusementTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsLocalLeaseTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsLuxuryTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsResortTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsStateSalesTax",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsStateSalesTaxElection",
  "OpenapiTaxProductRegistrationsResourceCountryOptionsUsTourismTax",
  "OpenapiTaxProductRegistrationsResourceTaxRegistrationAvailability",
  "OpenapiTaxProductRegistrationsResourceTaxRegistrationsAvailability",
  "OpenapiTaxProductResourceHeadOfficeAvailableLocation",
  "OpenapiTaxProductResourceHeadOfficeAvailableLocationList",
  "OpenapiTaxProductResourcePostalAddress",
  "OpenapiTaxProductResourceTaxOnboardingAvailability",
  "OpenapiTaxProductResourceTaxOnboardingCompletedStepEntry",
  "OpenapiTaxProductResourceTaxSettingsDefaults",
  "OpenapiTaxProductResourceTaxSettingsHeadOffice",
  "OpenapiTaxProductResourceTaxSettingsStatusDetails",
  "OpenapiTaxProductResourceTaxSettingsStatusDetailsResourceActive",
  "OpenapiTaxProductResourceTaxSettingsStatusDetailsResourcePending",
  "OpenapiTaxProductResourceTaxSignupStateActivation",
  "OpenapiTaxProductResourceTaxSignupStateInterestIndication",
  "OpenapiTaxProductResourceTaxSignupStateRetrieve",
  "OpenapiTaxProductSettingsTaxCodeAssistantAfterSave",
  "OpenapiTaxProductSettingsTaxCodeAssistantAiAssistedTokenList",
  "OpenapiTaxProductSettingsTaxCodeAssistantSearchFeedback",
  "OpenapiTaxProductSettingsTaxCodeAssistantTokenList",
  "OpenapiTaxProductShopifyConnectorResourceShopifyOauthNonceVerification",
  "OpenapiTaxProductShopifyConnectorResourceShopifyOauthUrl",
  "OpenapiTaxProductTaxDetailsResourceProviderOptions",
  "OpenapiTaxProductTaxDetailsResourceTaxDetails",
  "OpenapiTaxProductTaxMigrationsResourceCurrentStateWrapperV2",
  "OpenapiTaxProductTaxMigrationsResourceSubscriptionStats",
  "OpenapiTaxProductTaxMigrationsResourceSubscriptionTotals",
  "OpenapiTaxProductTaxMigrationsResourceTaxMigrationList",
  "OpenapiTaxProductTaxTransactionTaxIdDetails",
  "OpenapiTaxProductTerritoryAvailabilityPartnerRegistrationApplication",
  "OpenapiTaxProductTerritoryAvailabilityTaxAvailableCountries",
  "OpenapiTaxProductTerritoryAvailabilityTaxAvailableState",
  "OpenapiTaxProductTerritoryAvailabilityTaxInformation",
  "OpenapiTaxProductThresholdMonitoringCustomerLocation",
  "OpenapiTaxProductThresholdMonitoringLocation",
  "OpenapiTaxProductThresholdMonitoringMonetaryAmount",
  "OpenapiTaxProductThresholdMonitoringTaxTimeWindow",
  "OpenapiTaxProductThresholdMonitoringThreshold",
  "OpenapiTaxProductThresholdMonitoringUnattributedLocation",
  "OpenapiTaxProductThresholdMonitoringUnattributedTimeWindow",
  "OpenapiTaxRaasMerchantInfo",
  "OpenapiTaxRaasResourceAddress",
  "OpenapiTaxRaasResourceBankDetails",
  "OpenapiTaxRaasResourceBusiness",
  "OpenapiTaxRaasResourceBusinessOwnership",
  "OpenapiTaxRaasResourceContact",
  "OpenapiTaxRaasResourceErrorInformationError",
  "OpenapiTaxRaasResourceExternalRegistrationUrl",
  "OpenapiTaxRaasResourceInformation",
  "OpenapiTaxRaasResourceInformationRequirements",
  "OpenapiTaxRaasResourcePreWork",
  "OpenapiTaxRaasResourceRequirementAddressRequirement",
  "OpenapiTaxRaasResourceRequirementBankDetailsRequirement",
  "OpenapiTaxRaasResourceRequirementBusinessOwnerEntityArrayRequirement",
  "OpenapiTaxRaasResourceRequirementBusinessOwnerEntityRequirement",
  "OpenapiTaxRaasResourceRequirementBusinessOwnerPersonArrayRequirement",
  "OpenapiTaxRaasResourceRequirementBusinessOwnerPersonRequirement",
  "OpenapiTaxRaasResourceRequirementBusinessOwnershipRequirement",
  "OpenapiTaxRaasResourceRequirementBusinessRepresentativeRequirement",
  "OpenapiTaxRaasResourceRequirementBusinessRequirement",
  "OpenapiTaxRaasResourceRequirementContactRequirement",
  "OpenapiTaxRaasResourceRequirementPreWorkRequirement",
  "OpenapiTaxRaasResourceRequirementRequirement",
  "OpenapiTaxRaasResourceRequirementRequirementDate",
  "OpenapiTaxRaasResourceRequirementRequirementFloat",
  "OpenapiTaxRaasResourceRequirementRequirementInteger",
  "OpenapiTaxRaasResourceRequirementRequirementMultipleChoice",
  "OpenapiTaxRaasResourceRequirementRequirementOneOf",
  "OpenapiTaxRaasResourceRequirementRequirementPhoneNumber",
  "OpenapiTaxRaasResourceRequirementRequirementString",
  "OpenapiTaxRaasResourceRequirementSalesThroughMarketplacesRequirement",
  "OpenapiTaxRaasResourceStatusHistoryItem",
  "OpenapiTaxRateFlatAmount",
  "OpenapiTaxReportingAccountSettingsResourceTaxFormSettings",
  "OpenapiTaxReportingFatcaCrsResourcesFatcaCrsControllingPerson",
  "OpenapiTaxReportingFatcaCrsResourcesFatcaCrsPlaceOfBirth",
  "OpenapiTaxReportingFatcaCrsResourcesFatcaCrsSignature",
  "OpenapiTaxReportingFatcaCrsResourcesFatcaCrsTaxResidency",
  "OpenapiTaxReportingPrivateResourceUsTaxFormNameAddressPreview",
  "OpenapiTaxReportingPrivateResourceUsTaxFormW8Preview",
  "OpenapiTaxReportingResourceFormHistory",
  "OpenapiTaxReportingResourceIdentityFormData",
  "OpenapiTaxReportingResourceLatestUsTaxFormRequest",
  "OpenapiTaxReportingResourceTax1099FormDelivery",
  "OpenapiTaxReportingResourceTax1099FormDeliveryStatus",
  "OpenapiTaxReportingResourceTax1099FormResourceTaxCenterEligibility",
  "OpenapiTaxReportingResourceTax1099FormResourceTaxCenterEmailAddress",
  "OpenapiTaxReportingResourceTax1099FormResourceTaxCenterPreverificationStatus",
  "OpenapiTaxReportingResourceTax1099FormStatusErrors",
  "OpenapiTaxReportingResourceTax1099FormUxStatus",
  "OpenapiTaxReportingResourceTax1099KNumericalData",
  "OpenapiTaxReportingResourceTax1099KNumericalDeltas",
  "OpenapiTaxReportingResourceTax1099MiscNumericalData",
  "OpenapiTaxReportingResourceTax1099MiscNumericalDeltas",
  "OpenapiTaxReportingResourceTax1099NecNumericalData",
  "OpenapiTaxReportingResourceTax1099NecNumericalDeltas",
  "OpenapiTaxReportingResourceTax1099UxStatusReasons",
  "OpenapiTerminalConfigurationConfigurationResourceAppThemeConfig",
  "OpenapiTerminalConfigurationConfigurationResourceCellularConfig",
  "OpenapiTerminalConfigurationConfigurationResourceCheckoutAppsConfig",
  "OpenapiTerminalConfigurationConfigurationResourceCheckoutAppsConfigResourceDonations",
  "OpenapiTerminalConfigurationConfigurationResourceCurrencySpecificConfig",
  "OpenapiTerminalConfigurationConfigurationResourceDeviceTypeSpecificConfig",
  "OpenapiTerminalConfigurationConfigurationResourceDynamicCurrencyConversionConfig",
  "OpenapiTerminalConfigurationConfigurationResourceEnterprisePeapWifi",
  "OpenapiTerminalConfigurationConfigurationResourceEnterpriseTlsWifi",
  "OpenapiTerminalConfigurationConfigurationResourcePersonalPskWifi",
  "OpenapiTerminalConfigurationConfigurationResourceReaderSecurityConfig",
  "OpenapiTerminalConfigurationConfigurationResourceStandaloneCardPresent",
  "OpenapiTerminalConfigurationConfigurationResourceStandaloneCardPresentRouting",
  "OpenapiTerminalConfigurationConfigurationResourceStandaloneConfig",
  "OpenapiTerminalConfigurationConfigurationResourceStandalonePaymentMethodOptions",
  "OpenapiTerminalConfigurationConfigurationResourceStandalonePaymentSettings",
  "OpenapiTerminalConfigurationConfigurationResourceStandaloneReaderSecurity",
  "OpenapiTerminalConfigurationConfigurationResourceStandaloneReaderSecurityTransactionHistory",
  "OpenapiTerminalConfigurationConfigurationResourceStandaloneTransferData",
  "OpenapiTerminalConfigurationConfigurationResourceTipping",
  "OpenapiTerminalConfigurationConfigurationResourceWifiConfig",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceAppThemeConfigWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceCellularConfigWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceCheckoutAppsConfigWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceDeviceTypeSpecificConfig",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceDynamicCurrencyConversionConfigWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceOfflineConfigWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceReaderSecurityConfigWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceRebootWindowWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceSplashscreenConfigWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceStandaloneConfigWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceTippingWithSource",
  "OpenapiTerminalConfigurationDerivedConfigurationResourceWifiConfigWithSource",
  "OpenapiTerminalDeployPlanDeployPlanResourceMandatoryUpdateConfiguration",
  "OpenapiTerminalDeployPlanDeployPlanResourceRolloutStageInfo",
  "OpenapiTerminalDeviceAssetDeviceAssetResourceAndroidApk",
  "OpenapiTerminalDeviceAssetVersionDeviceAssetVersionResourceAndroidApk",
  "OpenapiTerminalDeviceAssetVersionDeviceAssetVersionResourceAppReview",
  "OpenapiTerminalDeviceAssetVersionDeviceAssetVersionResourceRejectionEvidence",
  "OpenapiTerminalEmpty",
  "OpenapiTerminalHardwareConnectConfigurationCustomCatalogEntry",
  "OpenapiTerminalHardwareConnectConfigurationSkuCatalog",
  "OpenapiTerminalHardwareOrderAddressValidation",
  "OpenapiTerminalHardwareOrderAvailableCountries",
  "OpenapiTerminalHardwareOrderAvailableProviders",
  "OpenapiTerminalHardwareOrderCharacterLimitsValidation",
  "OpenapiTerminalHardwareOrderCharacterLimitsValidationAddress",
  "OpenapiTerminalHardwareOrderCharacterLimitsValidationMinMaxCharacterLimits",
  "OpenapiTerminalHardwareOrderCharacterLimitsValidationName",
  "OpenapiTerminalHardwareOrderCharacterLimitsValidationShipping",
  "OpenapiTerminalHardwareOrderMonthlyInvoiceDetails",
  "OpenapiTerminalHardwareOrderPaymentDetails",
  "OpenapiTerminalHardwareOrderPaymentIntentDetails",
  "OpenapiTerminalHardwareOrderPaymentIntentDetailsCard",
  "OpenapiTerminalHardwareOrderPaymentIntentDetailsOwner",
  "OpenapiTerminalHardwareOrderPaymentIntentDetailsOwnerAddress",
  "OpenapiTerminalHardwareOrderPreview",
  "OpenapiTerminalHardwareOrderProductTypeGroups",
  "OpenapiTerminalHardwareOrderProductTypeGroupsItem",
  "OpenapiTerminalHardwareOrderProductTypesOrder",
  "OpenapiTerminalHardwareOrderSplitName",
  "OpenapiTerminalHardwareOrderSuggestedAddress",
  "OpenapiTerminalLocationCapabilityLocationCapabilityResourceRequirements",
  "OpenapiTerminalLocationCapabilityLocationCapabilityResourceRequirementsError",
  "OpenapiTerminalLocationLocationResourceCapabilitiesSettings",
  "OpenapiTerminalLocationLocationResourceCapabilitiesSettingsResourcePaypayInPersonPayments",
  "OpenapiTerminalLocationLocationResourceUnattended",
  "OpenapiTerminalMerchantDeployableCountryMerchantDeployableCountry",
  "OpenapiTerminalMerchantP2PeMerchantP2PeValues",
  "OpenapiTerminalOrchestratedDeploymentOrchestratedDeploymentResourceTrackedDeployment",
  "OpenapiTerminalPreferredDeviceAssets",
  "OpenapiTerminalPreferredDeviceAssetsResourceAndroidApk",
  "OpenapiTerminalPreferredDeviceAssetsResourceAndroidApkResourceCheckoutApps",
  "OpenapiTerminalReaderAdminOperationsCheckConnectivity",
  "OpenapiTerminalReaderAdminOperationsCheckConnectivityResult",
  "OpenapiTerminalReaderAdminOperationsRestart",
  "OpenapiTerminalReaderDistinctDeviceTypes",
  "OpenapiTerminalReaderReaderResourceActivateGiftCardAction",
  "OpenapiTerminalReaderReaderResourceApiError",
  "OpenapiTerminalReaderReaderResourceBattery",
  "OpenapiTerminalReaderReaderResourceBluetooth",
  "OpenapiTerminalReaderReaderResourceBluetoothInterface",
  "OpenapiTerminalReaderReaderResourceCart",
  "OpenapiTerminalReaderReaderResourceCashoutGiftCardAction",
  "OpenapiTerminalReaderReaderResourceCellular",
  "OpenapiTerminalReaderReaderResourceCellularConnectionStripeType",
  "OpenapiTerminalReaderReaderResourceCellularInterface",
  "OpenapiTerminalReaderReaderResourceCheckGiftCardBalanceAction",
  "OpenapiTerminalReaderReaderResourceCollectDataAction",
  "OpenapiTerminalReaderReaderResourceCollectDataConfig",
  "OpenapiTerminalReaderReaderResourceCollectDataMagstripe",
  "OpenapiTerminalReaderReaderResourceCollectDataNfcUid",
  "OpenapiTerminalReaderReaderResourceCollectInputsAction",
  "OpenapiTerminalReaderReaderResourceCollectPaymentMethodAction",
  "OpenapiTerminalReaderReaderResourceConfirmPaymentIntentAction",
  "OpenapiTerminalReaderReaderResourceCustomText",
  "OpenapiTerminalReaderReaderResourceDeactivateGiftCardAction",
  "OpenapiTerminalReaderReaderResourceDeploymentDetails",
  "OpenapiTerminalReaderReaderResourceDeviceObservabilityData",
  "OpenapiTerminalReaderReaderResourceEmail",
  "OpenapiTerminalReaderReaderResourceEthernet",
  "OpenapiTerminalReaderReaderResourceEthernetConnectionStripeType",
  "OpenapiTerminalReaderReaderResourceEthernetInterface",
  "OpenapiTerminalReaderReaderResourceFileMetadata",
  "OpenapiTerminalReaderReaderResourceInput",
  "OpenapiTerminalReaderReaderResourceLineItem",
  "OpenapiTerminalReaderReaderResourceMainBatteryState",
  "OpenapiTerminalReaderReaderResourceMotoConfig",
  "OpenapiTerminalReaderReaderResourceNetworkInterfaces",
  "OpenapiTerminalReaderReaderResourceNetworking",
  "OpenapiTerminalReaderReaderResourceNetworkingInterfaces",
  "OpenapiTerminalReaderReaderResourceNumeric",
  "OpenapiTerminalReaderReaderResourcePhone",
  "OpenapiTerminalReaderReaderResourcePrintContent",
  "OpenapiTerminalReaderReaderResourceProcessPaymentIntentAction",
  "OpenapiTerminalReaderReaderResourceProcessSetupIntentAction",
  "OpenapiTerminalReaderReaderResourceReaderAssetVersionResourceReaderAndroidApk",
  "OpenapiTerminalReaderReaderResourceReaderDeployBundle",
  "OpenapiTerminalReaderReaderResourceReloadGiftCardAction",
  "OpenapiTerminalReaderReaderResourceSetReaderDisplayAction",
  "OpenapiTerminalReaderReaderResourceSignature",
  "OpenapiTerminalReaderReaderResourceSoftware",
  "OpenapiTerminalReaderReaderResourceSurcharge",
  "OpenapiTerminalReaderReaderResourceSurchargeConfig",
  "OpenapiTerminalReaderReaderResourceSurchargeConsentConfig",
  "OpenapiTerminalReaderReaderResourceTamperState",
  "OpenapiTerminalReaderReaderResourceText",
  "OpenapiTerminalReaderReaderResourceTippingConfig",
  "OpenapiTerminalReaderReaderResourceToggle",
  "OpenapiTerminalReaderReaderResourceWifi",
  "OpenapiTerminalReaderReaderResourceWifiConnectionStripeType",
  "OpenapiTerminalReaderReaderResourceWifiInterface",
  "OpenapiTerminalTerminalDetailsTerminalDetails",
  "OpenapiTerminalTerminalHardwareOrderMonthlyInstallmentsHardwareOrderItemAmount",
  "OpenapiTerminalTerminalHardwareOrderMonthlyInstallmentsTerminalHardwareSkuAmount",
  "OpenapiTerminalTerminalHardwareOrderShippingMethodEstimatedDeliveryWindow",
  "OpenapiTerminalTerminalHardwareOrderSupportedTaxIdCountries",
  "OpenapiTerminalTerminalHardwareOrderSupportedTaxIdCountriesSupportedTaxIdCountry",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderAddress",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderDeviceWarranty",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderHardwareOrderItem",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderMonthlyInstallments",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderPaymentIntentStripeEntityPublishableKey",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderPreviewResourceResourceFieldsCutoffTime",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderRate",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderShipmentTracking",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderShipping",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderTax",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderTaxCreditNote",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareOrderTaxInvoice",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareSkuBadge",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareSkuImage",
  "OpenapiTerminalTerminalHardwareOrderTerminalHardwareSkuInTheBox",
  "OpenapiThreeDSecureDetails",
  "OpenapiThreeDSecureDetailsCharge",
  "OpenapiThreeDSecureOptions",
  "OpenapiThreeDSecureStandaloneResourceAcquirerDetails",
  "OpenapiThreeDSecureStandaloneResourceBrowserDetails",
  "OpenapiThreeDSecureStandaloneResourceCartesBancaires",
  "OpenapiThreeDSecureStandaloneResourceChallengeDetails",
  "OpenapiThreeDSecureStandaloneResourceChannel",
  "OpenapiThreeDSecureStandaloneResourceDataShareDetails",
  "OpenapiThreeDSecureStandaloneResourceExpiry",
  "OpenapiThreeDSecureStandaloneResourceFlowPreference",
  "OpenapiThreeDSecureStandaloneResourceFrictionlessDetails",
  "OpenapiThreeDSecureStandaloneResourceFutureUsage",
  "OpenapiThreeDSecureStandaloneResourceInstallment",
  "OpenapiThreeDSecureStandaloneResourceNetworkDetails",
  "OpenapiThreeDSecureStandaloneResourceOutcomeDetails",
  "OpenapiThreeDSecureStandaloneResourceRecurring",
  "OpenapiThreeDSecureStandaloneResourceShippingAddress",
  "OpenapiThreeDSecureStandaloneResourceThreeRiDetails",
  "OpenapiThreeDSecureUsage",
  "OpenapiThresholdsResourceAmount",
  "OpenapiThresholdsResourceCreditBalanceAlertFilter",
  "OpenapiThresholdsResourceCreditBalanceThresholdConfig",
  "OpenapiThresholdsResourceMonetaryAmount",
  "OpenapiThresholdsResourceRatedUsageAlertFilter",
  "OpenapiThresholdsResourceRatedUsageThresholdConfig",
  "OpenapiThresholdsResourceSpendThresholdConfig",
  "OpenapiThresholdsResourceSpendThresholdFilter",
  "OpenapiThresholdsResourceSpendThresholdGte",
  "OpenapiThresholdsResourceUsageAlertFilter",
  "OpenapiThresholdsResourceUsageThresholdConfig",
  "OpenapiTokenApiResourceRedaction",
  "OpenapiTokenBillingRetrieveAiModelPrices",
  "OpenapiTokenBillingRetrieveAiModelPricesResourceAiModelPrice",
  "OpenapiTokenCardNetworks",
  "OpenapiTokenCardWallet",
  "OpenapiTokenCardWalletApplePay",
  "OpenapiTopupResourcePaymentMethodOptions",
  "OpenapiTopupResourceResourceFieldsAchCreditTransfer",
  "OpenapiTopupResourceResourceFieldsGbpCreditTransfer",
  "OpenapiTopupResourceResourceFieldsJpCreditTransfer",
  "OpenapiTopupResourceResourceFieldsSepaCreditTransfer",
  "OpenapiTopupResourceUsBankAccount",
  "OpenapiTopupSource",
  "OpenapiTopupSourceApiResourceResourceFieldsCredentials",
  "OpenapiTransactionsResourceFlowDetails",
  "OpenapiTransactionsResourceTransactionEntries",
  "OpenapiTransferCurrencyMapping",
  "OpenapiTransferData",
  "OpenapiTransferRecipientCards",
  "OpenapiTransferRecipientTransferReversals",
  "OpenapiTransferReversals",
  "OpenapiTransferSchedule",
  "OpenapiTransformQuantity",
  "OpenapiTransformUsage",
  "OpenapiTransitBalanceTransitBalanceBalance",
  "OpenapiTreasuryFinancialAccountsResourceAbaRecord",
  "OpenapiTreasuryFinancialAccountsResourceBalance",
  "OpenapiTreasuryFinancialAccountsResourceDashboardBalance",
  "OpenapiTreasuryFinancialAccountsResourceFinancialAccountFeatures",
  "OpenapiTreasuryFinancialAccountsResourceFinancialAddress",
  "OpenapiTreasuryFinancialAccountsResourceFinancialAddressesFeatures",
  "OpenapiTreasuryFinancialAccountsResourceInboundTransfers",
  "OpenapiTreasuryFinancialAccountsResourceOutboundPayments",
  "OpenapiTreasuryFinancialAccountsResourceOutboundTransfers",
  "OpenapiTreasuryFinancialAccountsResourcePlatformRestrictions",
  "OpenapiTreasuryFinancialAccountsResourceReceivedCreditsPlatformRestriction",
  "OpenapiTreasuryFinancialAccountsResourceReceivedDebitsPlatformRestriction",
  "OpenapiTreasuryFinancialAccountsResourceStatusDetails",
  "OpenapiTreasuryFinancialAccountsResourceTogglesSettingStatusDetails",
  "OpenapiTreasuryInboundTransfersResourceFailureDetails",
  "OpenapiTreasuryInboundTransfersResourceFailureDetailsResourceNetworkDetails",
  "OpenapiTreasuryInboundTransfersResourceFailureDetailsUsCheck",
  "OpenapiTreasuryInboundTransfersResourceInboundTransferResourceLinkedFlows",
  "OpenapiTreasuryInboundTransfersResourceInboundTransferResourceStatusTransitions",
  "OpenapiTreasuryOutboundPaymentsResourceAchTrackingDetails",
  "OpenapiTreasuryOutboundPaymentsResourceOutboundPaymentResourceEndUserDetails",
  "OpenapiTreasuryOutboundPaymentsResourceOutboundPaymentResourceStatusTransitions",
  "OpenapiTreasuryOutboundPaymentsResourceOutboundPaymentResourceTrackingDetails",
  "OpenapiTreasuryOutboundPaymentsResourceReturnedStatus",
  "OpenapiTreasuryOutboundPaymentsResourceUsDomesticWireTrackingDetails",
  "OpenapiTreasuryOutboundTransfersResourceAchNetworkDetails",
  "OpenapiTreasuryOutboundTransfersResourceAchTrackingDetails",
  "OpenapiTreasuryOutboundTransfersResourceNetworkDetails",
  "OpenapiTreasuryOutboundTransfersResourceOutboundTransferResourceTrackingDetails",
  "OpenapiTreasuryOutboundTransfersResourceReturnedDetails",
  "OpenapiTreasuryOutboundTransfersResourceStatusTransitions",
  "OpenapiTreasuryOutboundTransfersResourceUsDomesticWireTrackingDetails",
  "OpenapiTreasuryReceivedCreditsResourceAchNetworkDetails",
  "OpenapiTreasuryReceivedCreditsResourceLinkedFlows",
  "OpenapiTreasuryReceivedCreditsResourceNetworkDetails",
  "OpenapiTreasuryReceivedCreditsResourceReversalDetails",
  "OpenapiTreasuryReceivedCreditsResourceSourceFlowsDetails",
  "OpenapiTreasuryReceivedCreditsResourceStatusTransitions",
  "OpenapiTreasuryReceivedDebitsResourceAchNetworkDetails",
  "OpenapiTreasuryReceivedDebitsResourceDebitReversalLinkedFlows",
  "OpenapiTreasuryReceivedDebitsResourceLinkedFlows",
  "OpenapiTreasuryReceivedDebitsResourceNetworkDetails",
  "OpenapiTreasuryReceivedDebitsResourceReversalDetails",
  "OpenapiTreasuryReceivedDebitsResourceStatusTransitions",
  "OpenapiTreasuryReceivedDebitsResourceUsDomesticCheckNetworkDetails",
  "OpenapiTreasurySharedResourceBillingDetails",
  "OpenapiTreasurySharedResourceFailureDetailsAch",
  "OpenapiTreasurySharedResourceFailureDetailsNetworkDetails",
  "OpenapiTreasurySharedResourceFinancialAddressAbaRecord",
  "OpenapiTreasurySharedResourceFinancialAddressFinancialAddress",
  "OpenapiTreasurySharedResourceInitiatingPaymentMethodDetailsInitiatingPaymentMethodDetails",
  "OpenapiTreasurySharedResourceInitiatingPaymentMethodDetailsUsBankAccount",
  "OpenapiTreasuryTransactionsResourceAbstractTransactionResourceStatusTransitions",
  "OpenapiTreasuryTransactionsResourceBalanceImpact",
  "OpenapiTreasuryTransactionsResourceFlowDetails",
  "OpenapiTreasuryTransactionsResourceTransactionDetails",
  "OpenapiTreasuryTransactionsResourceTransactionDetailsResourceCounterpartyDetails",
  "OpenapiTreasuryTransactionsResourceTransactionEntries",
  "OpenapiUpcomingInvoice",
  "OpenapiUpcomingInvoiceClientLines",
  "OpenapiUpcomingInvoiceLines",
  "OpenapiUpcomingInvoicePayments",
  "OpenapiUpsell",
  "OpenapiUri",
  "OpenapiUsBankAccountNetworks",
  "OpenapiUsageDetails",
  "OpenapiUsageLimits",
  "OpenapiUserAccountingPlatformFetchMonthlyWaterfallResourcesFetchMonthlyWaterfall",
  "OpenapiUserAccountingPlatformFetchMonthlyWaterfallResourcesFetchMonthlyWaterfallEntry",
  "OpenapiUserAccountingPlatformUapJournalSummarizerServiceApiGetSummarizedJournalEntries",
  "OpenapiUserAccountingPlatformUapJournalSummarizerServiceApiListSummarizedJournalEntries",
  "OpenapiUserAccountingPlatformUapJournalSummarizerServiceApiResourcesDownloadSummarizedJournalEntries",
  "OpenapiUserAccountingPlatformUapJournalSummarizerServiceApiResourcesGetSjeConfig",
  "OpenapiUserAccountingPlatformUapJournalSummarizerServiceApiResourcesUpdateSjeConfig",
  "OpenapiUserAuthCodeGrpcIsOtpSmsDeliveryHealthy",
  "OpenapiUserBillingCommercialExpUsageFee",
  "OpenapiUserBillingCommercialExpUsageFeeData",
  "OpenapiUserBillingCommercialExpUsageFeeSummary",
  "OpenapiUserInvite",
  "OpenapiUserMessagingChannelOptions",
  "OpenapiUserSettlementCurrencies",
  "OpenapiValidatedCalculatedOrderIntentWithClientSecret",
  "OpenapiVerificationDocumentValidationValidationFeedback",
  "OpenapiVerificationResourceAccountRequirementsResourceAccountDetail",
  "OpenapiVerificationResourceAccountRequirementsResourceDoc",
  "OpenapiVerificationResourceAccountRequirementsResourceDocumentProperties",
  "OpenapiVerificationResourceAccountRequirementsResourceFieldError",
  "OpenapiVerificationResourceAccountRequirementsResourceFieldPath",
  "OpenapiVerificationResourceAccountRequirementsResourceNonAccountField",
  "OpenapiVerificationResourceAccountRequirementsResourcePartialPerson",
  "OpenapiVerificationResourceAccountRequirementsResourcePathAndProperties",
  "OpenapiVerificationResourceAccountRequirementsResourceRelationship",
  "OpenapiVerificationResourceAccountRequirementsResourceRequestedReason",
  "OpenapiVerificationResourceAccountRequirementsResourceRequestedReasonKyc",
  "OpenapiVerificationResourceAccountRequirementsResourceRequirements",
  "OpenapiVerificationSessionRedaction",
  "OpenapiVerificationStationResourceNormalizedVolume",
  "OpenapiVersionDataSeries",
  "OpenapiVippsInternalCard",
  "OpenapiWaysToPayResourceCardDisplay",
  "OpenapiWaysToPayResourcePaymentMethod",
  "OpenapiWaysToPayResourcePaymentMethodSetupSession",
  "OpenapiWaysToPayResourcePublishableKey",
  "OpenapiWebhookBetaEvents",
  "OpenapiWebhookEndpointStats",
  "OpenapiWebhookEventData",
  "OpenapiWebhookEvents",
  "OpenapiWorkbenchResourceApiRequestStatsMultiPeriod",
  "OpenapiWorkbenchResourceCreateTestDataDeletionJob",
  "OpenapiWorkbenchResourceEventDestinationStats",
  "OpenapiWorkbenchResourceForwardIntegrationInsightsFeedback",
  "OpenapiWorkbenchResourceRetrieveAccountResourceVersion",
  "OpenapiWorkbenchResourceRetrieveTestingScenarioRequestLogsAndEvents",
  "OpenapiWorkbenchResourceSendFeedback",
  "OpenapiWorkbenchResourceShellPreviewTree",
  "OpenapiWorkbenchResourceTestingScenarioSingleRequestLogAndEvents"
]